import React, { useEffect, useState } from "react";
import { buildAllotmentDepStr } from "./allotmentQueryKey";
import InfiniteScroll from "react-infinite-scroll-component";

//* import css
import cssClasses from "./AllAllotments.module.css";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ParkingModal from "./ParkingModal";  // adjust path to where you saved it
import DeemedTab from "./CrmAllotment/DeemedTab"; // Phase 4 — Deemed Cancellation tab
import MuiButton from "@mui/material/Button";


//* import mui
import {
  Box,
  Card,
  Checkbox,
  ClickAwayListener,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
//* import user
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import {
  deleteOldParkingRecords,
  fetchSelectedParkingNumbers,
  getAllAllotmentTransactions,
  getAllotmentById,
  getAllotmentPayment,
  getAllotmentTransactions,
  getCrmAllotment,
  getDiscountAmountTotal,
  getFilterNames,
  getPANConflicts,
  getRefundedAmount,
  approveTagCrmAllotment,
  sendWhatsappMessageOnTagApprove,
  insertCRMLogs,
  insertInventoryLogs,
  updateAllotmentPayment,
  updateAllotmentPriceDiscount,
  updateCrmByAllotmentPaymentId,
  updateParkingStatusFlag,
} from "../../Services/AllAllotments";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import CheckIcon from "@mui/icons-material/Check";
import DropDownButton from "../../Subcomponents/DropDownButton";
import Dot from "../../Components/Icons/Dot";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import PaymentModal from "../../Modals/PaymentModal/PaymentModal";
import LoaderModal from "../../Modals/LoaderModal/LoaderModal";
import { errorTost, successTost } from "../../Services/Toast";
import useAlertModal from "../../Subcomponents/useAlertModal";
import axios from "axios";
import { supabase } from "../../supabaseClient";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { TabContext, TabPanel } from "@mui/lab";
import TabsMenu from "../../Subcomponents/TabsMenu";
import _, { debounce, findIndex, orderBy, sortBy } from "lodash";
import EmptyListIcon from "../../Assets/Images/Common/NoSiteVisitsFound.svg";
import {
  autoAdjustToken,
  getAllEventsCancelUnitRequests,
  getAllEventsChangeUnitRequests,
  updateAllotmentUnitCost,
  updateCancelRequests,
  updateCancelRequestsForRejection,
  updateCancelRequestsForSkipReprice,
  updateChangeUnitRequest,
  updateInventorForCancelUnit,
  updateInventorForChangeUnit,
  updateInventorStatusWiseForCancelUnit,
  checkForInventoryStatus,
  freeAndZeroInventoryForChangeUnit,
} from "../../Services/Event";
import {
  addLeadLogs,
  addLeadNotificationForCp,
  updateLeadAllStatus,
} from "../../Services/Lead";
import AllotmentDetails from "../../Modals/AllotmentDetails/AllotmentDetails";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { useSelector } from "react-redux";
import { updateAllotmentPaymentStatus } from "../../Services/AlotUnit";
import CancelUnitConfirmation from "../../Modals/CancelUnitConfirmation/CancelUnitConfirmation";
import {
  getCRMUserFromCRMTable,
  getCRMUsersFromUserTable,
  getPreselectConfirmationsConfig,
  insertToCRMTable,
  updateUnitCostAllotmentPaymentById,
} from "../../Services/Users";
import SelectCrmUserModal from "./SelectCrmUserModal/SelectCrmUserModal";
import CrmAllotment from "./CrmAllotment/CrmAllotment";
import {
  updateAllotmentTransactions,
  updateInventoryStatus,
} from "../../Services/ChangeUnit";
import AdjustToken from "../../Modals/AdjustToken/AdjustToken";
import CancelUnit from "../../Modals/CancelUnit.js/CancelUnit";
import {
  bucketingForChangeUnit,
  refundFromAllAllotmentPayment,
  refundTokenPayment,
} from "../../Services/PaymentApi";
import { getProjectList, getWingList } from "../../Services/Payments";
import TreeviewCheckbox from "../TreeviewCheckbox";
import ServerPaginationGrid from "../ServerPaginationGrid";
import { getAllInventoryStatusFromTable } from "../../Services/SustenanceService";
import ViewToggleSwitch from "../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import DateComponent from "../../Subcomponents/DateComponent";
import RepriceUnit from "../../Modals/RepriceUnit/RepriceUnit";
import EmptyState from "../../Assets/Images/Common/noProjectFound.svg";
import ArrowBlockRight from "../../Assets/Images/Common/arrowBlockRight.svg"
import { useLocation, useNavigate } from "react-router-dom";
import infoSvg from "../../Assets/Images/Common/info.svg"
import { getPaymentPlansPriceFromServer } from "../../Services/Project";
import CrmTimeLineModal from "./CrmAllotment/CRMTimeLineModal/CrmTimeLineModal";
import ViewUnitCostModal from "./ViewUnitCostModal/ViewUnitCostModal";
import PANConflictCard from "./PANConflictCard/PANConflictCard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ViewDiscountUnitCostModal from "./ViewDiscountUnitCostModal/ViewDiscountUnitCostModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  // boxShadow: 24,
};

const filterListPayload = [
  {
    id: 0,
    label: "None",
    value: "None",
  },
  {
    id: 1,
    label: "Date",
    value: "Date",
    selected: false,
  },
  {
    id: 2,
    label: "CP",
    value: "CP",
    selected: false,
  },
  {
    id: 3,
    label: "SM",
    value: "Users",
    selected: false,
  },
  {
    id: 4,
    label: "CRM",
    value: "CrmUsers",
    selected: false,
  },
  {
    id: 5,
    label: "Projects",
    value: "Projects",
    selected: false,
  },
  {
    id: 6,
    label: "Status",
    value: "Status",
    selected: false,
  },
  {
    id: 7,
    label: "Kyc",
    value: "Kyc",
    selected: false,
  },
  {
    id: 8,
    label: "CRM Tagged",
    value: "CRM Tagged",
    selected: false,
  },
  {
    id: 9,
    label: "Lead Type",
    value: "Lead Type",
    selected: false,
  },
];

const cancelfilterListPayload = [
  {
    id: 0,
    label: "None",
    value: "None",
  },
  {
    id: 1,
    label: "Date",
    value: "Date",
    selected: false,
  },
  {
    id: 2,
    label: "CP",
    value: "CP",
    selected: false,
  },
  {
    id: 3,
    label: "SM",
    value: "Users",
    selected: false,
  },
  {
    id: 4,
    label: "Projects",
    value: "Projects",
    selected: false,
  },
  {
    id: 5,
    label: "Status",
    value: "Status",
    selected: false,
  },
];

const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 2rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 1rem",

    "&:focus": {
      outline: "none",
    },
  },
};

const AllAllotments = () => {
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [selectBtnName, setSelectBtnName] = useState("Select All");
  // const [columnVisibilityModel,setColumnVisibilityModel]= useState<GridColumnVisibilityModel>({
  //   crmUsers:false
  // });

  let crmStatusIdValues = {
    0: "Tag Pending",
    1: "Change AV",
    2: "Update SDR",
    3: "Approval Pending",
    4: "Parking Selection",
    5: "Agreement",
    6: "Completed",
  }

  const [pendingUserData, setPendingUserData] = useState([]);
  const [showProjectList, setShowProjectList] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [projectStr, setProjectStr] = useState({ p: [], w: [], f: [] });
  const [projectSelected, setProjectSelected] = useState([]);
  // Bumped on filter apply/clear (and other actions that should force a
  // Table View refetch) as a safety net alongside the derived depStr below.
  const [depVersion, setDepVersion] = useState(0);
  const [allotmentCount, setAllotmentCount] = useState(0);
  const [isTableView, setIsTableView] = useState(!true);
  const [view, setView] = useState("Grid View");
  const { state } = useLocation();



  const [openParkingModal, setOpenParkingModal] = useState(false);
  // const [selectedAllotment, setSelectedAllotment] = useState(null);

  const handleSelectParking = (allotment) => {
    setSelectedAllotment(allotment);
    setOpenParkingModal(true);
  };

  const tabName = sessionStorage.getItem("tab")
  useEffect(() => {
    // getProjectList();

    const fetchEvents = async () => {
      const data = await getProjectList();
      setProjectList(data);
    };
    fetchEvents();
  }, []);
  const [checked, setChecked] = React.useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [filterNames, setFilterNames] = useState([]);
  const [filterBy, setFilterBy] = useState("Latest First");
  const [lists, setLists] = useState([
    "None",
    "Date",
    "CP",
    "Sales",
    "Project",
    "Status",
    "Lead Type",
  ]);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openAlertBox, setOpenAlertBox] = React.useState(false);
  const [showDropDown, setShowDropDown] = React.useState(false);
  const [openAdjustTokenModal, setOpenAdjustTokenModal] = React.useState(false);
  const [roleId, setRoleId] = useState();
  const [detail, setDetail] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [count, setCount] = useState(0);
  const [transactionDetail, setTransactionDetail] = useState([]);
  const [selectedAllotments, setSelectedAllotments] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [openLoaderModal, setOpenLoaderModal] = useState(false);
  const [filterCheck, setFilterCheck] = useState(0);
  const [cp, setCp] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("");
  const [ptrnNo, setPtrnNo] = useState("");
  const [currentAllotment, setCurrentAllotment] = useState(null);
  const [allotmentForAdjustToken, setAllotmentForAdjustToken] = useState(null);
  const [allotmentDetails, setAllotmentDetails] = useState(null);
  const [salesRepresentative, setSalesRepresentative] = useState([]);
  const [showPriceRange, setShowPriceRange] = useState(false);
  const [btnName, setBtnName] = useState("None");
  const [crmUser, setCrmUser] = useState("");
  const [amount, setAmount] = useState(0);
  const [amountToBePaid, setAmountToBePaid] = useState(0);
  const [timestamp, setTimestamp] = useState(0);
  const [allAllotments, setAllAllotments] = useState([]);
  // CRM2 M2-F7 (M2.8): CRM 2.0 bookings get their CRM by rule / claim / reassign, never by
  // today's Assign CRM. allotmentfilter has no isCrm2 column, so look up the rows on screen.
  const [crm2Ids, setCrm2Ids] = useState(() => new Set());
  useEffect(() => {
    const ids = [...new Set((allAllotments || []).map((a) => a?.allotmentpaymentid).filter(Boolean))];
    if (!ids.length) return;
    supabase
      .from("AllotmentPayment")
      .select("allotmentPaymentId")
      .in("allotmentPaymentId", ids)
      .eq("isCrm2", true)
      .then(({ data, error }) => {
        if (error) return console.error("[crm2][AllAllotments] CRM 2.0 booking lookup failed", { error: error.message });
        if (data?.length) setCrm2Ids((prev) => new Set([...prev, ...data.map((r) => r.allotmentPaymentId)]));
      });
  }, [allAllotments]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allCpId, setAllCpId] = useState([]);
  const [allProjectId, setAllProjectId] = useState([]);
  const [allSalesRepresentativeId, setAllSalesRepresentativeId] = useState([]);
  const [search, setSearch] = useState();
  const [selectedParking, setSelectedParking] = useState([]);
  const [allChangeAllotmentCount, setAllChangeAllotmentCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [queryPage, setQueryPage] = useState(0);
  const [message, setMessage] = useState("");
  const [dataForModal, setDataForModal] = useState(null);
  const [mode, setMode] = useState("pending");
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openCancelUnitConfirmationModal, setOpenCancelUnitConfirmationModal] =
    useState(false);
  const [selectedCancelUnit, setSelectedCancelUnit] = useState(null);
  const [selectedAllotmentDataToApprove, setSelectedAllotmentDataToApprove] =
    useState([]);
  const [cancellationCharges, setCancellationCharges] = useState(null);
  const [listsOrder, setListsOrder] = useState([
    "Name Ascending",
    "Name Descending",
    "Oldest First",
    "Latest First",
    "Unit No Ascending",
    "Unit No Descending",
  ]);
  // const [subTabs, setSubTabs] = useState([
  //   {
  //     text: "All",
  //     value: "All",
  //     isSelected: true,
  //     key: 0,
  //   },
  //   {
  //     text: "Pending",
  //     value: "Pending",
  //     isSelected: false,
  //   },
  //   {
  //     text: "On Hold",
  //     value: "On Hold",
  //     isSelected: false,
  //   },
  //   {
  //     text: "Completed",
  //     value: "Completed",
  //     isSelected: false,
  //   },
  //   {
  //     text: "Preselect",
  //     value: "Preselect",
  //     isSelected: false,
  //   },
  // ]);


  const [subTabs, setSubTabs] = useState([
    { text: "All", value: "All", isSelected: true, key: 0 },
    { text: "Pending", value: "Pending", isSelected: false },
    { text: "On Hold", value: "On Hold", isSelected: false },
    { text: "Parking Selection", value: "Parking Selection", isSelected: false }, // 👈 Add this
    { text: "Completed", value: "Completed", isSelected: false },
    { text: "Preselect", value: "Preselect", isSelected: false },
  ]);

  const [tabs, setTabs] = useState([]);
  const navigate = useNavigate()
  const [repriceUnitModal, setRepriceUnitModal] = useState(false);
  const [isRepricePending, setIsRepricePending] = useState(false)
  const [showSkipRepriceModal, setShowSkipRepriceModal] = useState(false)
  // ??For Reprice Unit SubTabs
  const [cancellationsSubTabs, setCancellationsSubTabs] = useState([
    {
      text: "Pending for approval",
      value: "Cancellation",
      isSelected: true,
    },
    {
      text: "Accepted",
      value: "Accepted",
      isSelected: true,
    },
    {
      text: "Rejected",
      value: "Rejected",
      isSelected: true,
    },
    {
      text: "Deemed",
      value: "Deemed",
      isSelected: false,
    },
    loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible || loggedInUser.roleId.level == 1
      ? {
        text: "Reprice Pending",
        value: "Pending",
        isSelected: false,
      }
      : null,
    loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible || loggedInUser.roleId.level == 1
      ? {
        text: "Reprice Done",
        value: "Done",
        isSelected: false,
      }
      : null,
  ]);

  const [changeUnitSubTabs, setChangeUnitSubTabs] = useState([
    {
      text: "Change Unit Request",
      value: "Change Unit Request",
      isSelected: true,
    },
    loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible
      ? {
        text: "Reprice Pending",
        value: "Pending",
        isSelected: false,
      }
      : null,
    loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible
      ? {
        text: "Reprice Done",
        value: "Done",
        isSelected: false,
      }
      : null,
  ]);

  const [crmTimeLineModalToggle, setcrmTimeLineModalToggle] = useState(false);
  const [allotmentData, setAllotmentData] = useState([]);
  const [viewUnitCostModalToggle, setViewUnitCostModalToggle] = useState(false);
  const [panConflicts, setPanConflicts] = useState([]);
  const [showDetails, setShowDetails] = useState({});
  const [refundDetails, setRefundDetails] = useState({});

  useEffect(() => {
    getFilterAllotment();
    setLoadingStatus(0);


    if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]) {
      let _tabs = [];
      _tabs.push({
        text: "Allotments",
        value: "Event",
        isSelected: false,
      });
      _tabs.push({
        text: "Cancellations",
        value: "Cancellation Requests",
        isSelected: false,
      });
      _tabs.push({
        text: "Change Unit Requests",
        value: "Change Requests",
        isSelected: false,
      });
      if (
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM
          ?.isAccessible
      ) {
        _tabs.push({
          text: "CRM",
          value: "CRM",
          isSelected: false,
        });
      }
      _tabs.push({
        text: "Conflicts",
        value: "Conflicts",
        isSelected: false,
      });

      if (_tabs.length > 0) {
        _tabs[0].isSelected = true;
      }
      setTabs([..._tabs]);
    }
  }, [loggedInUser]);

  useEffect(() => {
    if (tabName === "cancellation") {
      setTabs((pre) => {

        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Cancellation Requests") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });
      setCancellationsSubTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Cancellation") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });
    } else if (tabName === "cancellation-reprice") {
      setTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Cancellation Requests") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });

      setCancellationsSubTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Pending") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });

    } else if (tabName === "tag-pending" || tabName === "change-plan") {
      setTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "CRM") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });
    } else if (tabName === "change-unit") {
      setTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Change Requests") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });

      setChangeUnitSubTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Change Unit Request") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });
    }
    else if (tabName === "change-unit-reprice") {
      setTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Change Requests") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });

      setChangeUnitSubTabs((pre) => {
        pre?.filter(val => val !== null).forEach((ele) => {
          if (ele?.value === "Pending") {
            ele.isSelected = true;
          } else {
            ele.isSelected = false;
          }
        });
        return [...pre];
      });

    }
  }, [tabName])

  useEffect(() => {
    // console.log(tabName)
    return () => {
      sessionStorage.setItem("tab", null)
    }
  }, [])

  const [filterObj, setFilterObj] = useState([
    {
      id: 0,
      label: "None",
      value: "None",
    },
    {
      id: 1,
      label: "Date",
      value: "Date",
      selected: false,
    },
    {
      id: 2,
      label: "CP",
      value: "CP",
      selected: false,
    },
    {
      id: 3,
      label: "SM",
      value: "Users",
      selected: false,
    },
    {
      id: 4,
      label: "CRM",
      value: "CrmUsers",
      selected: false,
    },
    {
      id: 5,
      label: "Projects",
      value: "Projects",
      selected: false,
    },
    {
      id: 6,
      label: "Status",
      value: "Status",
      selected: false,
    },
    {
      id: 7,
      label: "Kyc",
      value: "Kyc",
      selected: false,
    },
    {
      id: 8,
      label: "CRM Tagged",
      value: "CRM Tagged",
      selected: false,
    },
    {
      id: 9,
      label: "Lead Type",
      value: "Lead Type",
      selected: false,
    },
  ]);
  const PANFilter = [{
    id: 0,
    label: "None",
    value: "None",
  },
  {
    id: 1,
    label: "Date",
    value: "Date",
    selected: false,
  },
  {
    id: 2,
    label: "CP",
    value: "CP",
    selected: false,
  },
  {
    id: 3,
    label: "SM",
    value: "Users",
    selected: false,
  },
  {
    id: 4,
    label: "Projects",
    value: "Projects",
    selected: false,
  }]

  useEffect(() => {
    if (tabs.filter((val) => val?.isSelected && val?.text === "Conflicts")
      ?.length > 0
    ) {
      setFilterObj(PANFilter)
    }
  }, [tabs, subTabs])


  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  // Table View (ServerPaginationGrid) react-query cache key — must include
  // every input getAllotmentPayment filters/sorts by, or switching sub-tabs
  // (or applying a filter) serves rows cached under the previous combination.
  const depStr = buildAllotmentDepStr({
    subTab: subTabs.find((t) => t?.isSelected)?.value,
    search,
    filterBy,
    checked,
    projectStr,
    selectDates,
    version: depVersion,
  });
  const [selectedDates, setSelectedDate] = useState(null);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);

  // **Cancel Units
  const [allCancelUnits, setAllCancelUnits] = useState([]);
  const [allCancelUnitsCount, setAllCancelUnitsCount] = useState([]);
  const [deemedRemindingCount, setDeemedRemindingCount] = useState(0); // Legal Notice sent, not yet auto-released — reported up by DeemedTab
  const [allChangeUnitsPresent, setAllChangeUnitsPresent] = useState(null);
  const [openAlertBoxForCancellation, setOpenAlertBoxForCancellation] =
    useState(false);
  const [assignSubmitModalToggle, setAssignSubmitModalToggle] = useState(false);
  const [cancelUnitModal, setCancelUnitModal] = useState(false);
  const [isRepriceForChangeUnit, setIsRepriceForChangeUnit] = useState(false)
  // const cancelUnitColumn = [
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: 100,
  //     renderCell: (params) => {
  //       return (
  //         <ThreeDotsMenu
  //           list={params.row.cancellationListMenu}
  //           selectedValue={(e) => {
  //             if (e === "Accept") {
  //               updateCancelRequests(params.row.cancelUnitRequestId, "Accepted")
  //                 .then((resp) => {
  //                   updateLeadAllStatus(
  //                     params.row.allotmentPaymentId.leadId.leadId,
  //                     "Cancel Unit Accepted"
  //                   )
  //                     .then((updateLeadStatus) => {
  //                       let obj = {
  //                         leadId: selectedCancelUnit.allotmentPaymentId.leadId.leadId,
  //                         leadStatus: `Cancel Unit Accepted`,
  //                         message: `Cancellation Done`
  //                       }
  //                       addLeadLogs(obj).then((leadLog) => { console.log(leadLog) }).catch((err) => { console.log('leadlog', err) })
  //                       updateAllotmentPaymentStatus(params.row.allotmentPaymentId.allotmentPaymentId, 'Cancelled').then((resp) => {
  //                       });
  //                       // ??In Inventory table leadId===null and Inventory Status =Available by passing Availble status id

  //                       if (params.row.allotmentPaymentId.unitId.unitId !== null) {

  //                         updateInventorForCancelUnit('51c40f6a-176d-4ef9-a2a7-a2c0569da025', params.row.allotmentPaymentId.unitId.unitId).then((updateInventoryRes) => {
  //                           console.log(updateInventoryRes);
  //                           let obj = {
  //                             status: 'cancelled'
  //                           }
  //                           updateAllotmentPayment(obj, params.row.allotmentPaymentId.allotmentPaymentId).then((updateAllotmentPaymentRes) => {
  //                             console.log({ updateAllotmentPaymentRes });
  //                             let InventoryLogObj = {
  //                               userId: loggedInUser?.userId,
  //                               leadId: params.row.allotmentPaymentId.leadId.leadId,
  //                               status: "Available",
  //                               unitId: params.row.allotmentPaymentId.unitId.unitId
  //                             }
  //                             insertInventoryLogs(InventoryLogObj).then((insertInventoryLogsRes) => {
  //                               console.log({ insertInventoryLogsRes });
  //                             }).catch((err) => {
  //                               console.log('err while inserting into inventory log', err);
  //                             });
  //                           }).catch((err) => {
  //                             console.log('err while updating allotmentPayment table')
  //                           })
  //                         }).catch((err) => {
  //                           console.log(err);
  //                         });
  //                       } else {
  //                         updateInventorForCancelUnit('51c40f6a-176d-4ef9-a2a7-a2c0569da025', params.row.allotmentPaymentId?.inventoryMergedId?.unit1Id.unitId).then((updateInventoryRes) => {
  //                           console.log(updateInventoryRes);
  //                           let obj = {
  //                             status: 'cancelled'
  //                           }
  //                           updateAllotmentPayment(obj, params.row.allotmentPaymentId.allotmentPaymentId).then((updateAllotmentPaymentRes) => {
  //                             console.log({ updateAllotmentPaymentRes });
  //                             let InventoryLogObj = {
  //                               userId: loggedInUser?.userId,
  //                               leadId: params.row.allotmentPaymentId.leadId.leadId,
  //                               status: "Available",
  //                               unitId: params.row.allotmentPaymentId?.inventoryMergedId?.unit1Id.unitId
  //                             }
  //                             insertInventoryLogs(InventoryLogObj).then((insertInventoryLogsRes) => {
  //                               console.log({ insertInventoryLogsRes });
  //                             }).catch((err) => {
  //                               console.log('err while inserting into inventory log', err);
  //                             });
  //                           }).catch((err) => {
  //                             console.log('err while updating allotmentPayment table')
  //                           })
  //                         }).catch((err) => {
  //                           console.log(err);
  //                         });
  //                         updateInventorForCancelUnit('51c40f6a-176d-4ef9-a2a7-a2c0569da025', params.row.allotmentPaymentId?.inventoryMergedId?.unit2Id.unitId).then((updateInventoryRes) => {
  //                           console.log(updateInventoryRes);
  //                           let obj = {
  //                             status: 'cancelled'
  //                           }
  //                           updateAllotmentPayment(obj, params.row.allotmentPaymentId.allotmentPaymentId).then((updateAllotmentPaymentRes) => {
  //                             console.log({ updateAllotmentPaymentRes });
  //                             let InventoryLogObj = {
  //                               userId: loggedInUser?.userId,
  //                               leadId: params.row.allotmentPaymentId.leadId.leadId,
  //                               status: "Available",
  //                               unitId: params.row.allotmentPaymentId?.inventoryMergedId?.unit2Id.unitId
  //                             }
  //                             insertInventoryLogs(InventoryLogObj).then((insertInventoryLogsRes) => {
  //                               console.log({ insertInventoryLogsRes });
  //                             }).catch((err) => {
  //                               console.log('err while inserting into inventory log', err);
  //                             });
  //                           }).catch((err) => {
  //                             console.log('err while updating allotmentPayment table')
  //                           })
  //                         }).catch((err) => {
  //                           console.log(err);
  //                         });
  //                       }

  //                       console.log(updateLeadStatus);
  //                       successTost("Cancel unit accepted successfully");
  //                       getAllCancelUnit(false);
  //                     })
  //                     .catch((err) => {
  //                       console.log(err, "err while changing unit");
  //                     });
  //                 })
  //                 .catch((err) => {
  //                   console.log(err);
  //                   errorTost("Error while confirming");
  //                 });
  //             } else if (e === "Reject") {
  //               updateCancelRequestsForRejection(params.row.cancelUnitRequestId, "Rejected")
  //                 .then((resp) => {
  //                   console.log(resp);
  //                   updateLeadAllStatus(
  //                     params.row.allotmentPaymentId.leadId.leadId,
  //                     "Cancel Unit Rejected"
  //                   )
  //                     .then((updateLeadStatus) => {
  //                       updateAllotmentPaymentStatus(params.row.allotmentPaymentId.allotmentPaymentId, 'Cancelled').then((resp) => {
  //                       });
  //                       console.log(updateLeadStatus);
  //                       successTost("Cancel unit accepted successfully");
  //                       getAllCancelUnit(false);
  //                     })
  //                     .catch((err) => {
  //                       console.log(err, "err while canceling reject unit");
  //                     });
  //                 })
  //                 .catch((err) => {
  //                   console.log(err);
  //                   errorTost("Error while confirming");
  //                 });
  //             }
  //           }}
  //         />
  //       );
  //     },
  //   },
  //   {
  //     field: "LeadName",
  //     headerName: "Lead Name",
  //     width: 280,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           {params?.row?.allotmentPaymentId.leadId?.personId?.name
  //             ? params?.row?.allotmentPaymentId?.leadId?.personId?.name
  //             : "-"}
  //           <div>
  //             {"VJ" +
  //               params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.replace(
  //                 params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.substring(
  //                   8,
  //                   12
  //                 ),
  //                 "-" +
  //                 params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.substring(
  //                   8,
  //                   12
  //                 )
  //               )}
  //           </div>
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "leadConfirmationStatus",
  //     headerName: "Lead Confirmation Status",
  //     width: 200,
  //     renderCell: (params) => {
  //       return (
  //         <div>
  //           {params.row.leadConfirmation === "Pending" && (
  //             <LeadStatusChip
  //               style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
  //               label={params.row.leadConfirmation}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //           {params.row.leadConfirmation === "Accepted" && (
  //             <LeadStatusChip
  //               style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
  //               label={params.row.leadConfirmation}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //           {params.row.leadConfirmation === "Rejected" && (
  //             <LeadStatusChip
  //               style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
  //               label={params.row.leadConfirmation}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "status",
  //     headerName: "Cancellation status",
  //     width: 200,
  //     renderCell: (params) => {
  //       return (
  //         <div>
  //           {params.row.status === "Pending" && (
  //             <LeadStatusChip
  //               style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
  //               label={params.row.status}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //           {params.row.status === "Accepted" && (
  //             <LeadStatusChip
  //               style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
  //               label={params.row.status}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //           {params.row.status === "Rejected" && (
  //             <LeadStatusChip
  //               style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
  //               label={params.row.status}
  //               icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  //             />
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "CPName",
  //     headerName: "CP Name",
  //     width: 150,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           {params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
  //             ? params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
  //             : "-"}
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "SalesRepresentative",
  //     headerName: "Sales Representative",
  //     width: 160,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           {params?.row?.userId?.name ? params?.row?.userId?.name : "-"}
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "Amount",
  //     headerName: "Amount Paid",
  //     width: 150,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           ₹{params?.row?.allotmentPaymentId?.paidAmount.toLocaleString()}
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "ProjectName",
  //     headerName: "Project Name",
  //     width: 200,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           {params?.row?.allotmentPaymentId?.unitId?.projectId?.projectName ?? params?.row?.allotmentPaymentId?.inventoryMergedId?.projectId?.projectName}
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "CurrentUnitDetails",
  //     headerName: "Current Unit Details",
  //     width: 200,
  //     renderCell: (params) => {
  //       return (
  //         <Box className={cssClasses.innerTitle}>
  //           {params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
  //             ? params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
  //             : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id?.wingId?.wingName}
  //           -
  //           {params?.row?.allotmentPaymentId?.unitId?.unitNo
  //             ? params?.row?.allotmentPaymentId?.unitId?.unitNo
  //             : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id?.unitNo + ',' + params?.row?.allotmentPaymentId?.inventoryMergedId?.unit2Id?.unitNo}
  //           <Box m={1} component={"span"}>
  //             {" "}
  //             |{" "}
  //           </Box>
  //           {params?.row?.allotmentPaymentId?.unitId?.inventoryTypeId?.type ??
  //             params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id?.inventoryTypeId.type
  //           }
  //         </Box>
  //       );
  //     },
  //   },
  // ];
  const [queryPageNumber, setQueryPageNumber] = useState(0);
  const [currentPageCancellation, setCurrentPageCancellation] = useState(0);
  const [searchCancelUnit, setSearchCancelUnit] = useState("");
  const [crmUsers, setCrmUsers] = useState([]);
  const [CRMUserFromCRMTable, setCRMUserFromCRMTable] = useState([]);
  // Change Alloted Units
  // Change Unit
  const [allChangeUnits, setAllChangeUnits] = useState([]);
  const [allCancelUnitsPresent, setAllCancelUnitsPresent] = useState([]);
  const [leadObj, setLeadObj] = useState(null);
  const [selectedAllotment, setSelectedAllotment] = useState(null);
  const changeUnitColumn = [
    {
      // field: "action",
      // headerName: "Action",
      // width: 100,
      // renderCell: (params) => {
      //   return (
      //     <ThreeDotsMenu
      //       list={params.row.changeUnitListMenu}
      //       selectedValue={(e) => {
      //         console.log(e);
      //         if (e === 'Accept') {
      //           updateChangeRequests(params.row.changeUnitRequestId, "Accepted")
      //             .then((resp) => {
      //               updateLeadAllStatus(params.row.allotmentPaymentId.leadId.leadId,"Change Unit Confirmed").then((updateLeadStatus)=>{
      //                 console.log(updateLeadStatus);
      //                 successTost("Cancel unit accepted successfully");
      //                 getAllChangeUnit(false);
      //               }).catch((err)=>{
      //                 console.log(err,'err while changing unit');
      //               })
      //               console.log(resp);
      //             })
      //             .catch((err) => {
      //               console.log(err);
      //               errorTost("Error while confirming");
      //             });
      //         } else if (e === 'Reject') {
      //           updateChangeRequests(params.row.changeUnitRequestId, "Rejected")
      //             .then((resp) => {
      //               updateLeadAllStatus(params.row.allotmentPaymentId.leadId.leadId,"Change Unit Rejected").then((updateLeadStatus)=>{
      //                 successTost("Cancel unit accepted successfully");
      //                 getAllChangeUnit(false);
      //               }).catch((err)=>{
      //                 console.log(err,'err while changing unit');
      //               })
      //               console.log(resp);
      //             })
      //             .catch((err) => {
      //               console.log(err);
      //               errorTost("Error while confirming");
      //             });
      //         }
      //       }}
      //     />
      //   );
      // },
    },
    {
      field: "LeadName",
      headerName: "Lead Name",
      width: 280,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.allotmentPaymentId.leadId?.personId?.name
              ? params?.row?.allotmentPaymentId?.leadId?.personId?.name
              : "-"}
            <div>
              {"VJ" +
                params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.replace(
                  params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.substring(
                    8,
                    12
                  ),
                  "-" +
                  params?.row?.allotmentPaymentId.leadId?.leadDisplayId?.substring(
                    8,
                    12
                  )
                )}
            </div>
          </Box>
        );
      },
    },
    {
      field: "leadConfirmationStatus",
      headerName: "Lead Confirmation Status",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.leadConfirmation === "Pending" && (
              <LeadStatusChip
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                label={params.row.leadConfirmation}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.leadConfirmation === "Accepted" && (
              <LeadStatusChip
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                label={params.row.leadConfirmation}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
           { console.log('leadConfirmation', params.row.leadConfirmation)}
            {params.row.leadConfirmation === "Rejected" && (
              <LeadStatusChip
                style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                label={params.row.leadConfirmation}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Unit Change status",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status === "Pending" && (
              <LeadStatusChip
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "Accepted" && (
              <LeadStatusChip
                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "Rejected" && (
              <LeadStatusChip
                style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
          </div>
        );
      },
    },
    {
      field: "CPName",
      headerName: "CP Name",
      width: 150,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
              ? params?.row?.allotmentPaymentId?.leadId?.cpId?.billingName
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "SalesRepresentative",
      headerName: "Sales Representative",
      width: 160,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.userId?.name ? params?.row?.userId?.name : "-"}
          </Box>
        );
      },
    },
    {
      field: "Amount",
      headerName: "Amount Paid",
      width: 150,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            ₹{numberWithCommas(params?.row?.allotmentPaymentId?.paidAmount)}
          </Box>
        );
      },
    },
    {
      field: "ProjectName",
      headerName: "Project Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.allotmentPaymentId?.unitId?.projectId?.projectName ??
              params?.row?.allotmentPaymentId?.inventoryMergedId?.projectId
                ?.projectName}
          </Box>
        );
      },
    },
    {
      field: "CurrentUnitDetails",
      headerName: "Current Unit Details",
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {/* {params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              ? params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                  ?.wingId?.wingName} */}
            {params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName ? params?.row?.allotmentPaymentId?.unitId?.wingId?.displayName : params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              ? params?.row?.allotmentPaymentId?.unitId?.wingId?.wingName
              : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                ?.wingId?.displayName ? params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                  ?.wingId?.displayName : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                    ?.wingId?.wingName}
            -
            {params?.row?.allotmentPaymentId?.unitId?.unitNo
              ? params?.row?.allotmentPaymentId?.unitId?.unitNo
              : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                ?.unitNo +
              "," +
              params?.row?.allotmentPaymentId?.inventoryMergedId?.unit2Id
                ?.unitNo}
            <Box m={1} component={"span"}>
              {" "}
              |{" "}
            </Box>
            {params?.row?.allotmentPaymentId?.unitId?.inventoryTypeId?.type
              ? params?.row?.allotmentPaymentId?.unitId?.inventoryTypeId?.type
              : params?.row?.allotmentPaymentId?.inventoryMergedId?.unit1Id
                ?.inventoryTypeId.type}
          </Box>
        );
      },
    },
    {
      field: "ChangeUnitDetails",
      headerName: "Change Unit Details",
      width: 200,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {/* {params?.row?.requestedUnitId?.wingId?.wingName
              ? params?.row?.requestedUnitId?.wingId?.wingName
              : "-"} */}
            {params?.row?.requestedUnitId?.wingId?.displayName ? params?.row?.requestedUnitId?.wingId?.displayName : params?.row?.requestedUnitId?.wingId?.wingName
              ? params?.row?.requestedUnitId?.wingId?.wingName
              : "-"}
            -
            {params?.row?.requestedUnitId?.unitNo
              ? params?.row?.requestedUnitId?.unitNo
              : "-"}
            <Box m={1} component={"span"}>
              {" "}
              |{" "}
            </Box>
            {params?.row?.requestedUnitId?.inventoryTypeId?.type ?? "-"}
          </Box>
        );
      },
    },
  ];
  const [queryPageNumberChangeUnit, setQueryPageNumberChangeUnit] = useState(0);
  const [currentPageChangeUnit, setCurrentPageChangeUnit] = useState(0);
  const [searchChangeUnit, setSearchChangeUnit] = useState("");
  const [searchChangeUnit1, setSearchChangeUnit1] = useState("");

  const [selectedSingleCrmAssign, setSelectedSingleCrmAssign] = useState(null);
  // New "Claim" flow (CRM user self-assign + approve tag) — Allotments > Completed
  const [selectedAllotmentToClaim, setSelectedAllotmentToClaim] = useState(null);
  const [openClaimAlert, setOpenClaimAlert] = useState(false);
  const { showError, AlertModal: ClaimAlertModal } = useAlertModal();
  const [kycPendingInventoryStatus, setKycPendingInventoryStatus] =
    useState("");
  const [kycDoneInventoryStatus, setKycDoneInventoryStatus] = useState("");
  const [holdInventoryStatus, setHoldInventoryStatus] = useState("");
  const [paymentPendingInventoryStatus, setPaymentPendingInventoryStatus] =
    useState("");
  useEffect(() => { }, [currentPage]);

  const scaleValues = (valueArray) => {
    return [scale(valueArray[0]), scale(valueArray[1])];
  };
  const scale = (value) => {
    if (value === undefined) {
      return undefined;
    }
    const previousMarkIndex = Math.floor(value / 50);
    const previousMark = all_prices[previousMarkIndex];
    const remainder = value % 50;
    if (remainder === 0) {
      return previousMark?.scaledValue;
    }
    const nextMark = all_prices[previousMarkIndex + 1];
    const increment = (nextMark?.scaledValue - previousMark?.scaledValue) / 50;
    return remainder * increment + previousMark?.scaledValue;
  };

  useEffect(() => {
    let insertUnitListener = supabase
      .from(`AllotmentPayment`)
      .on("INSERT", (handleRecordUpdated) => {
        setSearch("");
        setQueryPage(0);
        setLoadingStatus(0);
        getFilterAllotment();
      })
      .subscribe((status) => { });
    let updateUnitListener = supabase
      .from(`AllotmentPayment`)
      .on("UPDATE", (handleRecordUpdated) => {
        if (search == "") {
          setSearch("");
          setQueryPage(0);
          setLoadingStatus(0);
          getFilterAllotment();
        }
        if (
          tabs?.find((e) => e?.isSelected === true)?.value ===
          "Cancellation Requests"
        ) {
          setSearch("");
          getFilterAllotment();
          setQueryPageNumber(0);
          setCurrentPageCancellation(0);
          getAllCancelUnit(false);
        }
        //     if(search == ""){
        //       console.log("empty")
        // }else{
        //   console.log("search:", search);
        //   setSearch("");
        // }
      })
      .subscribe((status) => {
        // console.log("status: ", status);
      });
    // !!When CancelUnitRequest requestPendingWithUserId is null
    let updateCancelReqListener = supabase
      .from(`CancelUnitRequests`)
      .on("UPDATE", (handleRecordUpdated) => {
        setSearch("");
        setSearchCancelUnit("");
        setQueryPageNumber(0);
        setCurrentPageCancellation(0);
        // if (allCancelUnits?.length > 0) {
        // ! changed because it gave error for value of undefined
        let docId = document.getElementById(
          "input-with-icon-textfield cancelAlotLeadName"
        )
        if (docId) {
          docId.value = "";
        }
        // }
        setSearchCancelUnit("");
        getAllCancelUnit(false);
      })
      .subscribe((status) => {
        // console.log("status: ", status);
      });
    return () => {
      if (insertUnitListener) {
        supabase.removeSubscription(insertUnitListener);
        insertUnitListener = null;
      }
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
      if (updateCancelReqListener) {
        supabase.removeSubscription(updateCancelReqListener);
        updateCancelReqListener = null;
      }
    };
  }, []);

  useEffect(() => {
    if (filter == "CP") {
      setFilterNames(cp);
    } else if (filter == "Projects") {
      setFilterNames(projects);
    } else if (filter == "Users") {
      setFilterNames(salesRepresentative);
    } else if (filter == "Pending With") {
      setFilterNames(pendingUserData);
    } else if (filter == "CrmUsers") {
      setFilterNames(crmUser);
    } else if (filter == "Date") {
      setFilterNames([]);
    } else if (filter == "Status") {
      setFilterNames([
        // {
        //   filter: "Status",
        //   name: "Pending",
        //   id: "Pending",
        // },
        // {
        //   filter: "Status",
        //   name: "Partial",
        //   id: "Partial",
        // },
        // {
        //   filter: "Status",
        //   name: "Complete",
        //   id: "Complete",
        // },
        { filter: "Status", name: "Payment Pending", id: "Payment Pending" },
        {
          filter: "Status",
          name: "Partial Payment Done",
          id: "Partial Payment Done",
        },
        { filter: "Status", name: "Payment Complete", id: "Payment Complete" },
        { filter: "Status", name: "On Hold", id: "On Hold" },
        { filter: "Status", name: "Preselected", id: "Preselected" },
        { filter: "Status", name: "Change Requested", id: "Change Requested" },
        { filter: "Status", name: "Released", id: "Released" },
        {
          filter: "Status",
          name: "Cancellation Requested",
          id: "Cancellation Requested",
        },

        {
          filter: "Status",
          name: "Cancellation Pending",
          id: "Cancellation Pending",
        },
        { filter: "Status", name: "Cancelled", id: "Cancelled" },
        { filter: "Status", name: "Refund Initiated", id: "Refund Initiated" },
        { filter: "Status", name: "Refund Processed", id: "Refund Processed" },
        { filter: "Status", name: "Agreement Done", id: "Agreement Done" },
      ]);
    } else if (filter == "Kyc") {
      setFilterNames([
        { filter: "Kyc", name: "Kyc Pending", id: "Kyc Pending" },
        { filter: "Kyc", name: "Kyc Done", id: "Kyc Done" },
      ]);
    } else if (filter == "CRM Tagged") {
      setFilterNames([
        { filter: "CRM Tagged", name: "CRM Tagged", id: "CRM Tagged" },
        { filter: "CRM Tagged", name: "CRM Not Tagged", id: "CRM Not Tagged" },
      ]);
    } else if (filter == "Lead Type") {
      setFilterNames([
        { filter: "Lead Type", name: "Direct", id: "Direct" },
        { filter: "Lead Type", name: "CP", id: "CP" },
        { filter: "Lead Type", name: "R&L", id: "R&L" },
      ]);
    }
  }, [filter]);

  useEffect(() => {
    if (
      subTabs.findIndex((val) => val?.text === "Pending" && val?.isSelected) !==
      -1
    ) {
      if (filter === "Status") {
        setFilterNames([
          { filter: "Status", name: "Payment Pending", id: "Payment Pending" },
          {
            filter: "Status",
            name: "Partial Payment Done",
            id: "Partial Payment Done",
          },
        ]);
      }
    } else if (
      subTabs.findIndex((val) => val?.text === "On Hold" && val?.isSelected) !==
      -1
    ) {
      if (filter === "Status") {
        setFilterNames([{ filter: "Status", name: "On Hold", id: "On Hold" }]);
      }
    } else if (
      subTabs.findIndex(
        (val) => val?.text === "Completed" && val?.isSelected
      ) !== -1
    ) {
      if (filter === "Status") {
        setFilterNames([
          { filter: "Status", name: "Completed", id: "Completed" },
        ]);
      }
    } else if (
      tabs.filter((val) => val.isSelected && val.text === "Cancellations")
        ?.length > 0 ||
      tabs?.filter(
        (val) => val?.isSelected && val?.text === "Change Unit Requests"
      )?.length > 0
    ) {
      if (filter === "Status") {
        if (cancellationsSubTabs
          ?.filter((val) => val !== null)
          .find((f) => f?.isSelected)?.value === "Rejected") {
          setFilterNames([
            { filter: "Status", name: "Rejected", id: "Rejected" },
          ]);
        } else if (cancellationsSubTabs
          ?.filter((val) => val !== null)
          .find((f) => f?.isSelected)?.value === "Accepted") {
          setFilterNames([
            { filter: "Status", name: "Accepted", id: "Accepted" },
          ]);
        } else {
          setFilterNames([
            { filter: "Status", name: "Pending", id: "Pending" },
          ]);
        }
      }
    } else {
      if (filter === "Status") {
        setFilterNames([
          { filter: "Status", name: "Payment Pending", id: "Payment Pending" },
          {
            filter: "Status",
            name: "Partial Payment Done",
            id: "Partial Payment Done",
          },
          {
            filter: "Status",
            name: "Payment Complete",
            id: "Payment Complete",
          },
          { filter: "Status", name: "On Hold", id: "On Hold" },
          { filter: "Status", name: "Preselected", id: "Preselected" },
          {
            filter: "Status",
            name: "Change Requested",
            id: "Change Requested",
          },
          { filter: "Status", name: "Released", id: "Released" },
          {
            filter: "Status",
            name: "Cancellation Requested",
            id: "Cancellation Requested",
          },

          {
            filter: "Status",
            name: "Cancellation Pending",
            id: "Cancellation Pending",
          },
          { filter: "Status", name: "Cancelled", id: "Cancelled" },
          {
            filter: "Status",
            name: "Refund Initiated",
            id: "Refund Initiated",
          },
          {
            filter: "Status",
            name: "Refund Processed",
            id: "Refund Processed",
          },
          { filter: "Status", name: "Agreement Done", id: "Agreement Done" },
        ]);
      }
    }
  }, [tabs, filter, subTabs]);

  useEffect(() => {
    setSearch("");
    if (subTabs?.filter(
      (val) => val?.isSelected && val?.text === "Completed"
    )?.length > 0) {
      setChecked(['{"value":"CRM Not Tagged","filter":"CRM Tagged"}'])
    } else {
      setChecked([]);
    }
    setFilterBy("Latest First");
    setQueryPage(0);
    if (
      tabs.filter((val) => val.isSelected && val.text === "Allotments")
        ?.length > 0
    ) {
      setAllAllotments([]);
      getFilterAllotment(false, false);
    } else if (
      tabs?.filter(
        (val) => val?.isSelected && val?.text === "Change Unit Requests"
      )?.length > 0
    ) {
      setAllCancelUnits([]);
      getAllChangeUnit(false, false);
    }
  }, [tabs, subTabs]);

  useEffect(() => {
    if (
      tabs.filter((val) => val.isSelected && val.text === "Cancellations")
        ?.length > 0
    ) {
      setQueryPage(0);
      //setChecked([]);
      setAllCancelUnits([]);
      getAllCancelUnit(false);
    }
  }, [tabs, cancellationsSubTabs]);
console.log('AllCancelUnits', allCancelUnits);
  useEffect(() => {
    if (
      tabs.filter((val) => val.isSelected && val.text === "Change Unit Requests")
        ?.length > 0
    ) {
      setQueryPage(0);
      setAllChangeUnits([]);
      getAllChangeUnit(false);
    }
  }, [tabs, changeUnitSubTabs]);

  // useEffect(() => {

  //   if (
  //     subTabs.findIndex(
  //       (val) =>
  //         (val?.text === "Pending" || val?.text === "On Hold") &&
  //         val?.isSelected
  //     ) !== -1
  //   ) {
  //     const payload = [...filterListPayload];
  //     const index = payload.findIndex((val) => val?.label === "CRM Tagged");
  //     payload?.splice(index, 1);
  //     setFilterObj(payload);
  //   }
  //   if (
  //     tabs.filter((val) => val.isSelected && val.text === "Cancellations")
  //       ?.length > 0
  //   ) {
  //     if (cancellationsSubTabs
  //       ?.filter((val) => val !== null)
  //       .find((f) => f?.isSelected)?.value === "Rejected") {
  //       setFilterObj(cancelfilterListPayload);
  //       getSubfilters("None", 0);
  //     } else if (cancellationsSubTabs
  //       ?.filter((val) => val !== null)
  //       .find((f) => f?.isSelected)?.value === "Accepted") {
  //       setFilterObj(cancelfilterListPayload);
  //       getSubfilters("None", 0);
  //     } else {
  //       const payload = [
  //         ...cancelfilterListPayload,
  //         { id: 6, label: "Pending With", value: "Pending With" },
  //       ];
  //       setFilterObj(payload);
  //       getSubfilters("None", 0);
  //     }

  //   } else if (
  //     tabs?.filter(
  //       (val) => val?.isSelected && val?.text === "Change Unit Requests"
  //     )?.length > 0
  //   ) {
  //     setFilterObj(cancelfilterListPayload);
  //   } else {
  //     const payload = [...filterListPayload];
  //     payload.push({
  //       id: 8,
  //       label: "CRM Tagged",
  //       value: "CRM Tagged",
  //     });
  //     const finalPayload = _.uniqBy(payload, function (e) {
  //       return e.id;
  //     });
  //     setFilterObj(finalPayload);
  //   }
  // }, [subTabs, tabs, cancellationsSubTabs]);



  useEffect(() => {
    // Handle logic for showing/hiding filters based on subTabs and tabs
    if (
      subTabs.findIndex(
        (val) =>
          (val?.text === "Pending" || val?.text === "On Hold") && val?.isSelected
      ) !== -1
    ) {
      const payload = [...filterListPayload];
      const index = payload.findIndex((val) => val?.label === "CRM Tagged");
      payload?.splice(index, 1);
      setFilterObj(payload);
    }

    if (
      tabs.filter((val) => val.isSelected && val.text === "Cancellations")?.length > 0
    ) {
      if (
        cancellationsSubTabs
          ?.filter((val) => val !== null)
          .find((f) => f?.isSelected)?.value === "Rejected"
      ) {
        setFilterObj(cancelfilterListPayload);
        getSubfilters("None", 0);
      } else if (
        cancellationsSubTabs
          ?.filter((val) => val !== null)
          .find((f) => f?.isSelected)?.value === "Accepted"
      ) {
        setFilterObj(cancelfilterListPayload);
        getSubfilters("None", 0);
      } else {
        const payload = [
          ...cancelfilterListPayload,
          { id: 6, label: "Pending With", value: "Pending With" },
        ];
        setFilterObj(payload);
        getSubfilters("None", 0);
      }
    } else if (
      tabs?.filter(
        (val) => val?.isSelected && val?.text === "Change Unit Requests"
      )?.length > 0
    ) {
      // When "Change Unit Requests" tab is selected, exclude the "CP" filter
      const updatedPayload = cancelfilterListPayload.filter(
        (filter) => filter.value !== "CP"
      );
      setFilterObj(updatedPayload);
    } else {
      const payload = [...filterListPayload];
      payload.push({
        id: 8,
        label: "CRM Tagged",
        value: "CRM Tagged",
      });
      const finalPayload = _.uniqBy(payload, function (e) {
        return e.id;
      });
      setFilterObj(finalPayload);
    }
  }, [subTabs, tabs, cancellationsSubTabs]);

  useEffect(() => {
    if (filter === "CP") {
      setFilterNames(
        cp.filter((f) =>
          searchChangeUnit1
            ? f?.name?.toLowerCase()?.includes(searchChangeUnit1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Users") {
      setFilterNames(
        salesRepresentative.filter((f) =>
          searchChangeUnit1
            ? f?.name?.toLowerCase()?.includes(searchChangeUnit1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Pending With") {
      setFilterNames(
        pendingUserData.filter((f) =>
          searchChangeUnit1
            ? f?.name?.toLowerCase()?.includes(searchChangeUnit1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "CrmUsers") {
      setFilterNames(
        crmUser.filter((f) =>
          searchChangeUnit1
            ? f?.name?.toLowerCase()?.includes(searchChangeUnit1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Projects") {
      if (searchChangeUnit1 !== "") {
        setProjectList(
          projectList.filter((f) =>
            searchChangeUnit1
              ? f?.label
                ?.toLowerCase()
                ?.includes(searchChangeUnit1?.toLowerCase())
              : true
          )
        );
      } else {
        const fetchEvents = async () => {
          const data = await getProjectList();
          setProjectList(data);
        };
        fetchEvents();
      }
    }
  }, [searchChangeUnit1]);

  function pageChanged(e) {
    setCurrentPage(e);
    if (queryPage < e) {
      setQueryPage(e);
    }
  }
  function pageChangedCancellation(e) {
    setCurrentPageCancellation(e);
    if (queryPage < e) {
      setQueryPageNumber(e);
    }
  }
  function pageChangedChangeUnit(e) {
    setCurrentPageChangeUnit(e);
    if (queryPageNumberChangeUnit < e) {
      setQueryPageNumberChangeUnit(e);
    }
  }
  async function getSubfilters(value, filterId) {
    let CP_Items = [];
    let Project_Items = [];

    if (value !== "Projects") {
      setShowProjectList(false);
    }
    if (value == "CP") {
      if (!cp[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          CP_Items.push({
            id: item.cpId,
            name: item.billingName,
            filter: value,
          });
        });
        const sortedCp = orderBy(
          CP_Items,
          [(cp) => cp.name.toLowerCase()],
          ["asc"]
        );
        setCp(sortedCp);
        setFilterNames(sortedCp);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projectList[0]) {
        const data = await getProjectList();
        setProjectList(data);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projects[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          Project_Items.push({
            id: item.projectId,
            name: item.projectName,
            filter: value,
          });
        });
        const sortedProjects = orderBy(
          Project_Items,
          [(project) => project.name.toLowerCase()],
          ["asc"]
        );
        setProjects(sortedProjects);
      }
      setFilter(value);
    } else if (value == "Users") {
      if (!salesRepresentative[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          (item?.isCrmUser === null || item?.isCrmUser === false) &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setSalesRepresentative(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "Pending With") {
      if (!pendingUserData[0]) {
        presentLoader();
        const { data } = await getFilterNames("Users");
        dismissLoader();
        data.map((item) => {
          Project_Items.push({
            id: item.userId,
            name: item.name,
            filter: value,
          });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setPendingUserData(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "CrmUsers") {
      if (!crmUser[0]) {
        presentLoader();
        const { data } = await getFilterNames("Users");
        dismissLoader();
        data.map((item) => {
          item?.isCrmUser === true &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setCrmUser(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "priceRange") {
      setFilter(value);
    } else if (value == "Date") {
      setFilter(value);
    } else if (value == "Status") {
      setFilter(value);
      // setFilterNames([
      //   { filter: "Status", name: "Payment Complete", id: "Payment Complete" },
      //   { filter: "Status", name: "Kyc Done", id: "Kyc Done" },
      //   { filter: "Status", name: "SDR Pending", id: "SDR Pending" },
      //   { filter: "Status", name: "SDR Complete", id: "SDR Complete" },
      //   { filter: "Status", name: "Email Sent", id: "Email Sent" },
      //   {
      //     filter: "Status",
      //     name: "Cancellation Not Done",
      //     id: "Cancellation Not Done",
      //   },
      // ]);
    } else if (value === "Kyc") {
      setFilter(value);
    } else if (value === "CRM Tagged") {
      setFilter(value);
    } else if (value === "Pending With") {
      setFilter(value);
    } else if (value === "Lead Type") {
      setFilter(value);
    } else {
      setFilterNames([]);
      setCp([]);
      setSalesRepresentative([]);
      setPendingUserData([]);
      setCrmUser([]);
      setChecked([]);
      setProjects([]);
      setProjectList([]);

      setFilter("None");
    }
    setFilterCheck(filterId);
  }

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFilterClose = (isClear) => {
    setQueryPage(0);
    setCurrentPage(0);
    setLoadingStatus(0);
    if (filterOpen) {
      isClear && setProjectSelected([]);
      isClear && setProjectStr({ p: [], w: [], f: [] });
      isClear && setChecked([]);
      isClear &&
        setSelectDates([
          { label: "StartDate", value: "" },
          { label: "EndDate", value: "" },
        ]);
      isClear && getSubfilters("None", 0);
      setFilterOpen(false);
      isClear && setDepVersion((v) => v + 1);
      if (
        tabs?.filter((val) => val?.isSelected && val?.text === "Allotments")
          ?.length
      ) {
        isClear && getFilterAllotment(false, true);
      } else if (
        tabs.filter((val) => val.isSelected && val.text === "Cancellations")
          ?.length > 0
      ) {
        isClear && getAllCancelUnit(false, true);
      } else if (
        tabs?.filter(
          (val) => val?.isSelected && val?.text === "Change Unit Requests"
        )?.length > 0
      ) {
        isClear && getAllChangeUnit(false, true);
      } else if (
        tabs?.filter(
          (val) => val?.isSelected && val?.text === "Conflicts"
        )?.length > 0
      ) {
        isClear && getPANConflictsData(true);
      }
    } else {
      setFilterOpen(true);
    }

    // setChecked([]);
  };
  // useEffect(() => {
  //   if (!filterOpen) {
  //     getFilterAllotment();
  //   }
  // }, [filterOpen]);
  const handleFilterApply = async () => {
    setQueryPage(0);
    setLoadingStatus(0);
    setCurrentPage(0);
    setAllAllotments([]);
    setAllCancelUnits([]);
    if (checked) {
      if (
        tabs?.filter((val) => val?.isSelected && val?.text === "Allotments")
          ?.length > 0
      ) {
        getFilterAllotment();
      } else if (
        tabs.filter((val) => val.isSelected && val.text === "Cancellations")
          ?.length > 0
      ) {
        getAllCancelUnit();
      } else if (
        tabs?.filter(
          (val) => val?.isSelected && val?.text === "Change Unit Requests"
        )?.length > 0
      ) {
        getAllChangeUnit();
      } else if (tabs?.filter(
        (val) => val?.isSelected && val?.text === "Conflicts"
      )?.length > 0) {
        getPANConflictsData()
      }
    }
    setDepVersion((v) => v + 1);
  };
  async function getFilterAllotmentForDatagrid(nextRange = { from: 0, to: 9 }) {
    let items = await getFilterAllotmentPagination(false, true, nextRange);
    return items;
  }

  async function getFilterAllotmentPagination(
    merge = false,
    isShowSpinner = true,
    nextRange
  ) {
    //setAllAllotments([])
    try {
      const resp = await getAllotmentPayment(
        search,
        filterBy,
        queryPage,
        checked,
        subTabs.filter((e) => e.isSelected)[0],
        projectStr,
        nextRange,
        selectDates,
        true
      );

      if (resp.data) {
        let items = [];
        setAllotmentCount(resp.count);
        setSelectBtnName("Select All")
        setSelectedAllotments([])
        if (merge && resp.data.length === 0) {
          //isShowSpinner && dismissLoader();
          setLoadingStatus(1);
          // errorTost("No More Data")
        } else {
          let res = resp.data;

          res.forEach((data, i) => {
            items.push({
              id: i,
              ...data,
              currentUnitDetails: {
                char: data.wingname,
                projectId: data.unitno,
                area: data.unittype,
              },
              action: data.allotmentPaymentId,
            });
          });

          setUsers(items);

          if (!merge) {
            setAllAllotments((pre) => [...items]);
            isShowSpinner && dismissLoader();
          } else {
            setAllAllotments((pre) => [...pre, ...items]);
            isShowSpinner && dismissLoader();
          }
        }

        setFilterOpen(false);
        return items;
      }
      // react-query v3 treats an undefined resolved value as a rejection,
      // which leaves the previously cached rows on screen indefinitely.
      return [];
    } catch (err) {
      if (err?.message) {
        if (err?.message === 'Requested range not satisfiable') {
          // errorTost('No more data!');
        } else {
          errorTost(err?.message);
        }
      } else {
        errorTost('Something went wrong! Try again');
      }
      return [];
    }
  }

  async function getFilterAllotment(merge = false, isCheckedClear = false) {
    presentLoader();
    view === "Table View" && setAllAllotments([]);
    getAllotmentPayment(
      search,
      filterBy,
      queryPage,
      isCheckedClear ? [] : checked,
      subTabs.filter((e) => {
        return e.isSelected;
      })[0],
      projectStr,
      { from: 0, to: 9 },
      isCheckedClear ? undefined : selectDates,
      false
    )
      .then((resp) => {
        setAllotmentCount(resp?.count);
        setCount(resp.count);
        if (resp.data) {
          //else{
          let res = resp.data;
          let items = [];
          res.map((data, i) => {
            items.push({
              id: i,
              ...data,
              currentUnitDetails: {
                char: data.wingname,
                projectId: data.unitno,
                area: data.unittype,
              },
              action: data.allotmentPaymentId,
            });
          });

          setUsers(items);
          if (!merge) {
            setAllAllotments([...items]);
            dismissLoader();
          } else {
            setAllAllotments((pre) => {
              return [...pre, ...items];
            });
            dismissLoader();
          }
          //}
          if (resp.data.length < 10) {
            setLoadingStatus(1);
            // errorTost("No More Data")
          }
        } else {
          dismissLoader();
        }
        setFilterOpen(false);
      })
      .catch((err) => {
        dismissLoader();
        if (err?.message) {
          if (err?.message === "Requested range not satisfiable") {
            errorTost("No more data!");
          } else {
            errorTost(err?.message);
          }
        } else {
          //errorTost("Something went wrong! Try again");
        }
      });
  }

  
  //   **All Cancel Unit
  function getAllCancelUnit(merge = false, isCheckedClear = false) {

    presentLoader();
    getAllEventsCancelUnitRequests(
      queryPage,
      searchCancelUnit,
      filterBy,
      loggedInUser.userId,
      cancellationsSubTabs
        ?.filter((val) => val !== null)
        .filter((e) => e.isSelected && (e.text === "Pending for approval" || e.text === "Rejected" || e.text === "Accepted"))?.length > 0
        ? null
        : cancellationsSubTabs
          ?.filter((val) => val !== null)
          .filter((e) => {
            return e.isSelected;
          })[0],
      tabName === "cancellation" ? [
        "{\"value\":\"Pending\",\"filter\":\"Status\"}"
      ] : tabName === "cancellation-reprice" ? [
        "{\"value\":\"Accepted\",\"filter\":\"Status\"}"
      ] : isCheckedClear ? [] : checked,
      selectDates,
      cancellationsSubTabs
        ?.filter((val) => val !== null)
        .find((f) => f?.isSelected)?.value,
      checked
    )
      .then((respCancelUnits) => {
        //setAllCancelUnits([]);
        // ??while searching on leadName personId is null
        respCancelUnits.data = respCancelUnits.data.map((el, index) => ({
          ...el,
          id: el?.cancelunitrequestid,
          index: index,
          leadName: el?.leadname ?? null,
          cancellationListMenu: [],
        }));
        // respCancelUnits.data = respCancelUnits.data.filter(
        //   (val) => val.leadname !== null
        // );
        if (filterBy.includes("Name")) {
          if (filterBy.includes("Ascending")) {
            respCancelUnits.data = sortBy(respCancelUnits.data, "leadname");
          } else {
            respCancelUnits.data = sortBy(
              respCancelUnits.data,
              "leadname"
            ).reverse();
          }
        }
        // console.log('cancel units',respCancelUnits.data);
        setAllCancelUnitsCount(respCancelUnits.count);
        if (respCancelUnits?.data?.length < 10) {
          setLoadingStatus(1);
        }
        // if (respCancelUnits.data.length > 0) {
        //   setAllCancelUnitsPresent(true);
        // } else {
        //   setAllCancelUnitsPresent(false);
        // }

        // respCancelUnits?.data?.forEach((el) => {
      

        //   if (el.updatedunitprice === null) {
        //    if (el.leadconfirmation === "Accepted" ) {

        //       if (el.status === "Pending" && cancellationsSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0) {
        //         el.cancellationListMenu.push("Accept");
        //         if (!el.cancelledinfarvision && cancellationsSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0) {
        //           el.cancellationListMenu.push("Reject");
        //         }
        //       } else if (el.status === "Rejected" && cancellationsSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0) {
        //         el.cancellationListMenu.push("Accept");
        //       } else if (el.status === "Accepted") {
        //         if (el.requestpendingwithuserid === null) {
        //           if (
        //             loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
        //               "Reprice Unit"
        //             ]?.isAccessible
        //           ) {
        //             if (cancellationsSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Pending")?.length > 0) {
        //               el.cancellationListMenu.push("Reprice Unit");
        //               el.cancellationListMenu.push("Skip Reprice")
        //             } else {
        //               el.cancellationListMenu.push("View Details")
        //             }
        //           }
        //           // el.cancellationListMenu.push(['No actions available!']);
        //           // !!Add condition for refund initiated
        //           // !!Only for superAdmin for now
        //           if (
        //             loggedInUser.roleId.level === 1 &&
        //             !el.allotmentstatus?.includes("Refund") &&
        //             !el.cancelledinfarvision &&
        //             cancellationsSubTabs
        //               ?.filter((val) => val !== null)
        //               .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
        //           ) {
        //             el.cancellationListMenu.push("Initiate Refund");
        //           }
        //           // el.cancellationListMenu.push(['No actions available!']);
        //         } else {
        //           el.cancellationListMenu.push("Accept");
        //           if (!el.cancelledinfarvision) {
        //             el.cancellationListMenu.push("Reject");
        //           }
        //         }
        //       }
        //     } else {
        //       el.cancellationListMenu.push(["No actions available!"]);
        //     }
        //   } else {
        //     // ??Given user access
        //     if (
        //       loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
        //         "Reprice Unit"
        //       ]?.isAccessible
        //     ) {
        //       if (cancellationsSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Pending")?.length > 0) {
        //         el.cancellationListMenu.push("Reprice Unit");
        //         el.cancellationListMenu.push("Skip Reprice")
        //       } else {
        //         el.cancellationListMenu.push("View Details")
        //       }
        //     }
        //     // el.cancellationListMenu.push(['No actions available!']);
        //     // !!Add condition for Initiate Refund
        //     // !!Only for superAdmin for now
        //     if (
        //       loggedInUser.roleId.level === 1 &&
        //       !el.allotmentstatus?.includes("Refund") &&
        //       !el.cancelledinfarvision &&
        //       cancellationsSubTabs
        //         ?.filter((val) => val !== null)
        //         .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
        //     ) {
        //       el.cancellationListMenu.push("Initiate Refund");
        //     }
        //   }
        //   if (el.cancellationListMenu.length === 0) {
        //     el.cancellationListMenu.push(["No actions available!"]);
        //   }
        // });


        respCancelUnits?.data?.forEach((el) => {
  const isAdmin = loggedInUser?.roleId?.level === 1;

  if (el.updatedunitprice === null) {

    // ✅ ADMIN ONLY: Cancellation Requested → Accept / Reject
    if (
      isAdmin &&
      el.allotmentstatus === "Cancellation Requested" &&
      cancellationsSubTabs
        ?.filter((val) => val !== null)
        .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
    ) {
      el.cancellationListMenu.push("Accept");

      if (!el.cancelledinfarvision) {
        el.cancellationListMenu.push("Reject");
      }

    } 
    // 🔁 EXISTING NORMAL FLOW (unchanged)
    else if (el.leadconfirmation === "Accepted") {

      if (
        el.status === "Pending" &&
        cancellationsSubTabs
          ?.filter((val) => val !== null)
          .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
      ) {
        el.cancellationListMenu.push("Accept");
        if (!el.cancelledinfarvision) {
          el.cancellationListMenu.push("Reject");
        }
      }

      else if (
        el.status === "Rejected" &&
        cancellationsSubTabs
          ?.filter((val) => val !== null)
          .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
      ) {
        el.cancellationListMenu.push("Accept");
      }

      else if (el.status === "Accepted") {
        if (el.requestpendingwithuserid === null) {

          if (
            loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
              "Reprice Unit"
            ]?.isAccessible
          ) {
            if (
              cancellationsSubTabs
                ?.filter((val) => val !== null)
                .filter((e) => e.isSelected && e.value === "Pending")?.length > 0
            ) {
              el.cancellationListMenu.push("Reprice Unit");
              el.cancellationListMenu.push("Skip Reprice");
            } else {
              el.cancellationListMenu.push("View Details");
            }
          }

          if (
            isAdmin &&
            !el.allotmentstatus?.includes("Refund") &&
            !el.cancelledinfarvision &&
            cancellationsSubTabs
              ?.filter((val) => val !== null)
              .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
          ) {
            el.cancellationListMenu.push("Initiate Refund");
          }

        } else {
          el.cancellationListMenu.push("Accept");
          if (!el.cancelledinfarvision) {
            el.cancellationListMenu.push("Reject");
          }
        }
      }

    } else {
      el.cancellationListMenu.push(["No actions available!"]);
    }

  } else {
    // existing else block unchanged
    if (
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
        "Reprice Unit"
      ]?.isAccessible
    ) {
      if (
        cancellationsSubTabs
          ?.filter((val) => val !== null)
          .filter((e) => e.isSelected && e.value === "Pending")?.length > 0
      ) {
        el.cancellationListMenu.push("Reprice Unit");
        el.cancellationListMenu.push("Skip Reprice");
      } else {
        el.cancellationListMenu.push("View Details");
      }
    }

    if (
      isAdmin &&
      !el.allotmentstatus?.includes("Refund") &&
      !el.cancelledinfarvision &&
      cancellationsSubTabs
        ?.filter((val) => val !== null)
        .filter((e) => e.isSelected && e.value === "Cancellation")?.length > 0
    ) {
      el.cancellationListMenu.push("Initiate Refund");
    }
  }

  if (el.cancellationListMenu.length === 0) {
    el.cancellationListMenu.push(["No actions available!"]);
  }
});

        if (!merge) {
          setAllCancelUnits([...respCancelUnits.data]);
        } else {
          setAllCancelUnits((pre) => {
            return [...pre, ...respCancelUnits.data];
          });
          // setAllCancelUnitsCount((pre) => {
          //   return { ...(respCancelUnits.data.length + pre) };
          // });
        }
        setFilterOpen(false);
        dismissLoader();
      })
      .catch((err) => {
        dismissLoader();
      });
  }

  const handleSkipReprice = () => {
    presentLoader()
    updateCancelRequestsForSkipReprice(selectedCancelUnit?.cancelunitrequestid).then(() => {
      let InventoryLogObj = {
        userId: loggedInUser?.userId,
        leadId: selectedCancelUnit?.leadid,
        unitId: selectedCancelUnit?.unitid,
        status: "Cancellation Price Skip",
      };
      insertInventoryLogs(InventoryLogObj).catch((err) => {
        console.error("err while inserting into inventory log", err);
      });
      dismissLoader()
      successTost("Skip Reprice Sucessfully.")
      getAllCancelUnit(false)
    }).catch((err) => {
      dismissLoader()
      errorTost(err.message)
    })
  }

  // **All Change Unit
  function getAllChangeUnit(merge = false, isCheckedClear = false) {
    getAllEventsChangeUnitRequests(
      queryPage,
      searchChangeUnit,
      filterBy,
      loggedInUser.userId,
      changeUnitSubTabs
        ?.filter((val) => val !== null)
        .filter((e) => e.isSelected && e.text === "Change Unit Request")?.length > 0
        ? null
        : changeUnitSubTabs
          ?.filter((val) => val !== null)
          .filter((e) => {
            return e.isSelected;
          })[0],
      tabName === "change-unit" ? [
        "{\"value\":\"Pending\",\"filter\":\"Status\"}"
      ] : tabName === "change-unit-reprice" ? [
        "{\"value\":\"Accepted\",\"filter\":\"Status\"}"
      ] : isCheckedClear ? [] : checked,
      selectDates
    )
      .then((respChangeUnits) => {
        //setAllChangeUnits([]);
        // ??while searching on leadName personId is null

        respChangeUnits.data = respChangeUnits.data.map((el, index) => ({
          ...el,
          id: el?.changeunitrequestid,
          index: index,
          leadName: el?.leadname ?? null,
          changeUnitListMenu: [],
        }));
        respChangeUnits.data = respChangeUnits.data.filter(
          ({ leadname }) => leadname !== null
        );
        if (respChangeUnits?.data?.length < 10) {
          setLoadingStatus(1);
        }
        // if (respChangeUnits.data.length > 0) {
        //   setAllChangeUnitsPresent(true);
        // } else {
        //   setAllChangeUnitsPresent(false);
        // }
        if (filterBy.includes("Name")) {
          if (filterBy.includes("Ascending")) {
            respChangeUnits.data = sortBy(respChangeUnits.data, "leadname");
          } else {
            respChangeUnits.data = sortBy(
              respChangeUnits.data,
              "leadname"
            ).reverse();
          }
        }
        respChangeUnits.data.forEach((el) => {
          if (el.leadconfirmation === "Accepted") {
            console.log("el.status.........", el.status);

            if (el.status === "Pending" && (loggedInUser.roleId.level === 1 ||
              loggedInUser.roleId.accessibleTabs["All Allotments"]["Change Unit Approver"])) {
              el.changeUnitListMenu.push("Accept");
              el.changeUnitListMenu.push("Reject");
            } else if (el.status === "Rejected") {
              el.changeUnitListMenu.push("No Actions Available");
            } else if (el.status === "Accepted") {
              if (el.requestpendingwithuserid === null) {
                if (
                  loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
                    "Reprice Unit"
                  ]?.isAccessible
                ) {
                  if (changeUnitSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Pending")?.length > 0) {
                    el.changeUnitListMenu.push("Reprice Unit");
                  } else {
                    el.changeUnitListMenu.push("View Details");
                  }
                }
              }
            } else {
              el.changeUnitListMenu.push("No Actions Available");
              // el.changeUnitListMenu.push("Reject");
            }
          }
          else {
            if (
              loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
                "Reprice Unit"
              ]?.isAccessible
            ) {
              if (changeUnitSubTabs?.filter((val) => val !== null).filter((e) => e.isSelected && e.value === "Pending")?.length > 0) {
                el.changeUnitListMenu.push("Reprice Unit");
              } else {
                el.changeUnitListMenu.push("View Details");
              }
            }
            if (el.changeUnitListMenu.length === 0) {
              el.changeUnitListMenu.push(["No Actions Available"]);
            }
            // el.changeUnitListMenu.push([]);
          }
        });
        setAllChangeAllotmentCount(respChangeUnits?.count);
        if (!merge) {
          setAllChangeUnits([...respChangeUnits.data]);
        } else {
          setAllChangeUnits((pre) => {
            return [...pre, ...respChangeUnits.data];
          });
        }
        setFilterOpen(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  const debouncedFetchSearchData = debounce((e) => {
    setSearchCancelUnit(e.target.value);

    setAllCancelUnits([]);

    // getAllCancelUnit(false);
  }, 800);

  function cancelUnitFlow(values, buttonValue, cancellationCharge, waveOff, payload) {
    updateLeadAllStatus(
      selectedCancelUnit.leadid,
      `Cancellation Done`
    )
      .then(async (updateLeadStatus) => {
        updateAllotmentPaymentStatus(
          selectedCancelUnit.allotmentpaymentid,
          "Cancelled"
        ).then((resp) => { });
        updateAllotmentUnitCost(
          selectedCancelUnit.cancelunitrequestid,
          values
        ).then((resp) => { });
        // ! update token status also => make token available
        // ||selectedCancelUnit.allotmentPaymentId.pricingType ==="preselect"
        if (selectedCancelUnit.pricingtype === "event") {
          // supabase
          //   .from("EventTokenLeadRelations")
          //   .update({ status: "active" })
          //   .eq(
          //     "paymentId",
          //     selectedCancelUnit.allotmentPaymentId.paymentId
          //   )
          //   .then((resp) => {});
          supabase
            .from("EventTokenLeadRelations")
            .select("*")
            .eq("paymentId", selectedCancelUnit.paymentid)
            .then((statusResp) => {
              // !!If token status is adjusted we don't  want to update token status to active
              if (statusResp.data[0].status === "alloted") {
                supabase
                  .from("EventTokenLeadRelations")
                  .update({ status: "active" })
                  .eq(
                    "paymentId",
                    selectedCancelUnit.paymentid
                  )
                  .then((cancelresp3) => { });
              }
              // ??Discussion Pending
              // if (statusResp.data[0].status === "preselect") {
              //   supabase
              //     .from("EventTokenLeadRelations")
              //     .update({ status: "expired" })
              //     .eq(
              //       "paymentId",
              //       selectedCancelUnit.allotmentPaymentId.paymentId
              //     )
              //     .then((cancelresp3) => { });
              // }
            });
        }
        if (selectedCancelUnit.pricingtype === "preselect") {
          supabase
            .from("EventTokenLeadRelations")
            .update({ status: "cancelled" })
            .eq(
              "paymentId",
              selectedCancelUnit.paymentid
            )
            .then((cancelresp3) => { });
        }
        // ! Requiremnt has been changed now no need to update inventory prices here
        // ! update inventory prices
        let bsp =
          values.bsp ||
          (selectedCancelUnit.unitcost.bsp
            ? selectedCancelUnit.unitcost.bsp
            : null);
        let gst =
          values.gst ||
          (selectedCancelUnit.unitcost.gst
            ? selectedCancelUnit.unitcost.gst
            : null);
        let sdr =
          values.sdr ||
          (selectedCancelUnit.unitcost.sdr
            ? selectedCancelUnit.unitcost.sdr
            : null);
        let agreementVal =
          values.total ||
          (selectedCancelUnit.unitcost.total
            ? selectedCancelUnit.unitcost.total
            : null);
        // ! fetching available status id in service
        // supabase
        //   .from("InventoryStatus")
        //   .select("*")
        //   .eq("status", "Available")
        //   .then((statusRes) => {
        //     const availableStatus = statusRes.data[0].inventoryStatusId;
        // !!Single Unit
        // ??In Inventory table leadId===null and Inventory Status =Available by passing Availble status id
        if (selectedCancelUnit.unitid !== null) {
          // updateInventorForCancelUnit("51c40f6a-176d-4ef9-a2a7-a2c0569da025", selectedCancelUnit.allotmentPaymentId.unitId.unitId)
          // ??removed from modal these values
          updateInventorStatusWiseForCancelUnit(
            selectedCancelUnit.unitid,
            selectedCancelUnit
          )
            .then((updateInventoryRes) => {
              let obj = {
                status: "Cancelled",
                last_updated_at: new Date().getTime(),
              };
              updateAllotmentPayment(
                obj,
                selectedCancelUnit.allotmentpaymentid
              )
                .then((updateAllotmentPaymentRes) => {
                  let InventoryLogObj = {
                    userId: loggedInUser?.userId,
                    leadId: selectedCancelUnit.leadid,
                    status: "Available",
                    unitId: selectedCancelUnit.unitid,
                  };
                  insertInventoryLogs(InventoryLogObj)
                    .then(async (insertInventoryLogsRes) => {
                      let leadlogobj = {
                        allotmentPaymentId: selectedCancelUnit?.allotmentpaymentid,
                        leadId: selectedCancelUnit.leadid,
                        leadStatus: `Cancellation Done`,
                        message: `Cancellation Done for ${selectedCancelUnit?.wingname}-${selectedCancelUnit?.unitno},${selectedCancelUnit?.projectname}`,
                      };
                      // ! Requiremnt has change now
                      // !!Only for superAdmin for now
                      // if (loggedInUser.roleId.level === 1) {
                      //   setOpenAlertBoxForCancellation(true);
                      // }
                      // await getCrmAllotment(selectedCancelUnit?.allotmentpaymentid).then((resp) => {
                      //   if (resp.data?.length > 0) {
                      leadlogobj.message = leadlogobj.message + `. ${buttonValue === "acceptWithoutRefund" && "Hold Refund"}, Cancellation Charges ₹${numberWithCommas(cancellationCharge ?? 0)}, Waived charges ₹${numberWithCommas(payload?.waivedOffCancellationCharges ?? 0)}, Total Cancellation Charges ₹${numberWithCommas(payload?.newCancellationCharges ?? 0)}${waveOff ? ", WaivedOff Reason:" + payload?.waivedOffReason : ""}.`
                      //   }

                      // })
                      addLeadLogs(leadlogobj)
                        .then((leadLog) => { })
                        .catch((err) => {
                          console.log("leadlog", err);
                        });
                      let obj = {
                        action: `Cancellation has been done for Unit ${selectedCancelUnit?.unitno} in wing ${selectedCancelUnit?.wingname} of ${selectedCancelUnit?.projectname} by VJ SM ${loggedInUser.name}(${loggedInUser?.roleId?.title}) for ${selectedCancelUnit?.leadname}`,
                        cpId: selectedCancelUnit?.cpid,
                        leadId: selectedCancelUnit?.leadid,
                        userId: loggedInUser?.userId,
                        allotmentPaymentId:
                          selectedCancelUnit?.allotmentpaymentid,
                        eventId: selectedCancelUnit?.eventid,
                      };
                      if (selectedCancelUnit?.cpid !== null) {
                        addLeadNotificationForCp(obj)
                          .then((leadNotificationRes) => {
                            // console.log({
                            //   leadNotificationRes,
                            // });
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      }
                      if (buttonValue === "acceptWithRefund") {
                        if (selectedCancelUnit?.cancelledinfarvision) {
                          await supabase.from('AllotmentTransactions').update({ status: 'cancelled in farvision' }).eq('status', 'complete').eq('allotmentPaymentId', selectedCancelUnit?.allotmentpaymentid).then((resp) => {
                            setOpenCancelUnitConfirmationModal(
                              false
                            );
                            dismissLoader();
                            successTost(
                              "Cancellation done successfully!"
                            );
                            setSearchCancelUnit("");
                            document.getElementById(
                              "input-with-icon-textfield cancelAlotLeadName"
                            ).value = "";
                            getAllCancelUnit(false);
                          })
                        } else {
                          let body = {
                            mode: "Allotment",
                            allotmentPaymentId:
                              selectedCancelUnit?.allotmentpaymentid,
                            cancellationCharges:
                              values?.cancellationCharges,
                            refund: true,
                          };
                          // console.log({ body });
                          presentLoader();
                          refundTokenPayment(body)
                            .then((respRefundTokenPay) => {
                              // console.log({ respRefundTokenPay });
                              if (respRefundTokenPay?.data?.message?.includes("Insufficient balance")) {
                                errorTost("Cancellation done successfully! Your account does not have sufficient balance to carry out the refund operation");
                              } else {
                                if (
                                  respRefundTokenPay?.data?.success[0]
                                    ?.status === "success"
                                ) {
                                  // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                  successTost(
                                    "Cancellation done successfully and Allotment refund initiated successfully"
                                  );
                                  setOpenCancelUnitConfirmationModal(
                                    false
                                  );
                                  successTost(
                                    "Cancellation done successfully!"
                                  );
                                  setSearchCancelUnit("");
                                  dismissLoader();
                                  document.getElementById(
                                    "input-with-icon-textfield cancelAlotLeadName"
                                  ).value = "";
                                  getAllCancelUnit(false);
                                } else {
                                  setOpenCancelUnitConfirmationModal(
                                    false
                                  );
                                  presentLoader()
                                  errorTost(
                                    '"Cancellation done successfully but error while refunding.' +
                                    respRefundTokenPay?.data
                                      ?.failed[0]?.reason
                                  );
                                  dismissLoader();
                                }
                              }
                            })
                            .catch((errInRefundPay) => {

                              // console.log({ errInRefundPay });
                              errorTost(errInRefundPay.message);
                              dismissLoader();
                            });
                        }
                      } else {
                        let body = {
                          mode: "Allotment",
                          allotmentPaymentId:
                            selectedCancelUnit?.allotmentpaymentid,
                          cancellationCharges:
                            values?.cancellationCharges,
                          refund: false,
                        };
                        // console.log({ body });
                        presentLoader();
                        refundTokenPayment(body)
                          .then((respRefundTokenPay) => {
                            // console.log({ respRefundTokenPay });
                            if (respRefundTokenPay?.data?.message?.includes("Insufficient balance")) {
                              errorTost("Cancellation done successfully! Your account does not have sufficient balance to carry out the refund operation");
                            } else {
                              if (
                                respRefundTokenPay?.data?.success[0]
                                  ?.status === "success"
                              ) {
                                // !!All Updates are Handled by Siddarth's refundtokenpayment api
                                successTost(
                                  "Cancellation done successfully"
                                );
                                setOpenCancelUnitConfirmationModal(
                                  false
                                );
                                successTost(
                                  "Cancellation done successfully!"
                                );
                                setSearchCancelUnit("");
                                dismissLoader();
                                document.getElementById(
                                  "input-with-icon-textfield cancelAlotLeadName"
                                ).value = "";
                                getAllCancelUnit(false);
                              } else {
                                setOpenCancelUnitConfirmationModal(
                                  false
                                );
                                presentLoader()
                                errorTost(
                                  '"Cancellation done successfully but error while refunding.' +
                                  respRefundTokenPay?.data
                                    ?.failed[0]?.reason
                                );
                                dismissLoader()
                              }
                            }
                          })
                          .catch((errInRefundPay) => {

                            // console.log({ errInRefundPay });
                            errorTost(errInRefundPay.message);
                            dismissLoader();
                          });
                        // setOpenCancelUnitConfirmationModal(false);
                        // dismissLoader();
                        // successTost("Cancellation done successfully");
                        // setSearchCancelUnit("");
                        // document.getElementById(
                        //   "input-with-icon-textfield cancelAlotLeadName"
                        // ).value = "";
                        // getAllCancelUnit(false);
                      }
                    })
                    .catch((err) => {
                      console.log(
                        "err while inserting into inventory log",
                        err
                      );
                    });
                })
                .catch((err) => {
                  console.log(
                    "err while updating allotmentPayment table"
                  );
                });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // !!Merged Units
          // updateAllotmentUnitCost(selectedCancelUnit.allotmentPaymentId?.inventoryMergedId?.unit1Id.unitId,values).then((resp)=>{
          //   console.log(resp);
          // });
          // updateAllotmentUnitCost(selectedCancelUnit.allotmentPaymentId?.inventoryMergedId?.unit2Id.unitId,values).then((resp)=>{
          //   console.log(resp);
          // });
          updateInventorForCancelUnit(
            selectedCancelUnit.unit1id,
            0,
            0,
            0,
            0
          )
            .then((updateInventoryRes) => {
              let obj = {
                status: "Cancelled",
                last_updated_at: new Date().getTime(),
              };
              updateAllotmentPayment(
                obj,
                selectedCancelUnit.allotmentpaymentid
              )
                .then((updateAllotmentPaymentRes) => {
                  let InventoryLogObj = {
                    userId: loggedInUser?.userId,
                    leadId: selectedCancelUnit.leadid,
                    status: "Available",
                    unitId: selectedCancelUnit.unit1id,
                  };
                  insertInventoryLogs(InventoryLogObj)
                    .then((insertInventoryLogsRes) => { })
                    .catch((err) => {
                      console.log(
                        "err while inserting into inventory log",
                        err
                      );
                    });
                })
                .catch((err) => {
                  console.log(
                    "err while updating allotmentPayment table"
                  );
                });
            })
            .catch((err) => {
              console.log(err);
            });
          updateInventorForCancelUnit(
            selectedCancelUnit?.unit2id,
            0,
            0,
            0,
            0,
          )
            .then((updateInventoryRes) => {
              let obj = {
                status: "Cancelled",
                last_updated_at: new Date().getTime(),
              };
              updateAllotmentPayment(
                obj,
                selectedCancelUnit.allotmentpaymentid
              )
                .then((updateAllotmentPaymentRes) => {
                  let InventoryLogObj = {
                    userId: loggedInUser?.userId,
                    leadId: selectedCancelUnit.leadid,
                    status: "Available",
                    unitId: selectedCancelUnit.unit2id,
                  };
                  insertInventoryLogs(InventoryLogObj)
                    .then((insertInventoryLogsRes) => { })
                    .catch((err) => {
                      console.log(
                        "err while inserting into inventory log",
                        err
                      );
                    });
                  dismissLoader();
                  successTost("Cancellation done successfully!");
                  setOpenCancelUnitConfirmationModal(false);
                })
                .catch((err) => {
                  console.log(
                    "err while updating allotmentPayment table"
                  );
                });
            })
            .catch((err) => {
              console.log(err);
            });
          let leadlogobj = {
            allotmentPaymentId: selectedCancelUnit?.allotmentpaymentid,
            leadId: selectedCancelUnit.leadid,
            leadStatus: `Cancellation Done`,
            message: `Cancellation Done for ${selectedCancelUnit?.unit1no}-${selectedCancelUnit?.unit2no},${selectedCancelUnit?.mergedproject}`,
          };

          // await getCrmAllotment(selectedCancelUnit?.allotmentpaymentid).then((resp) => {
          //   if (resp.data?.length > 0) {
          leadlogobj.message = leadlogobj.message + `. ${buttonValue === "acceptWithoutRefund" && "Hold Refund"}, Cancellation Charges ₹${numberWithCommas(cancellationCharge ?? 0)}, Waived charges ₹${numberWithCommas(payload?.waivedOffCancellationCharges ?? 0)}, Total Cancellation Charges ₹${numberWithCommas(payload?.newCancellationCharges ?? 0)}${waveOff ? ", WaivedOff Reason:" + payload?.waivedOffReason : ""}.`
          //   }
          // })
          if (loggedInUser.roleId.level === 1) {
            setOpenAlertBoxForCancellation(true);
          }
          addLeadLogs(leadlogobj)
            .then((leadLog) => {
              console.log(leadLog);
            })
            .catch((err) => {
              console.log("leadlog", err);
            });
        }
        // })
        // .catch((err) => {
        //   console.log(err, "err while getting unit status");
        // });
      })
      .catch((err) => {
        console.log(err, "err while changing unit");
      });
  }


  const debouncedFetchSearchData1 = (e) => {
    setSearchChangeUnit1(e.target.value);
    // getAllCancelUnit(false);
  };

  const debouncedFetchSearchDataChangeUnit = debounce((e) => {
    setSearchChangeUnit(e.target.value);
    setAllChangeUnits([]);

    // getAllChangeUnit(false);
  }, 800);

  useEffect(() => {
    if (
      tabs.filter((val) => val?.isSelected && val?.text === "Allotments")
        ?.length > 0 &&
      queryPage > 0
    ) {
      getFilterAllotment(true);
    }

    if (
      tabs.filter(
        (val) => val?.isSelected && val?.value === "Cancellation Requests"
      )?.length > 0
    ) {
      getAllCancelUnit(true, false);
    }

    if (
      tabs.filter(
        (val) => val?.isSelected && val?.text === "Change Unit Requests"
      )?.length > 0
    ) {
      getAllChangeUnit(true, true);
    }

    if (
      tabs.filter((val) => val?.isSelected && val?.text === "Conflicts")
        ?.length > 0
    ) {
      //@todo get conflict data
      getPANConflictsData();
    }
    // else {
    //   getFilterAllotment(false);
    // }
  }, [queryPage]);

  const debounceForSearch = debounce((e) => {
    searchUser(e);
  }, 800);

  async function searchUser(e) {
    let searchData = e.target.value;
    setSearch(searchData);
    setQueryPage(0);
    setLoadingStatus(0);
    // let response = await getAllotmentsFilter(checked, "", searchData, filterBy, from, to);
    // if (response.data) {
    //     let res = response.data;
    //     let items = [];
    //     res.map((data, i) => {
    //         items.push({
    //             id: i,
    //             ...data,
    //             currentUnitDetails: {
    //                 char: data.wingname,
    //                 projectId: data.unitno,
    //                 area: data.unittype
    //             },
    //             action: data.allotmentpaymentid
    //         })
    //     });
    //     console.log('items', items)
    //     setUsers(items);
    //     setAllAllotments(items);
    // }
  }

  // const getAllotmentList = async (type) => {
  //     const response = await getAllotmentsFilter(checked, "", search, filterBy, from, to);
  //     if (response.data) {
  //         let res = response.data;
  //         let items = [];
  //         res.map((data, i) => {
  //             items.push({
  //                 id: i,
  //                 ...data,
  //                 currentUnitDetails: {
  //                     char: data.wingname,
  //                     projectId: data.unitno,
  //                     area: data.unittype
  //                 },
  //                 action: data.allotmentpaymentid
  //             })
  //         });
  //         console.log('items', items)
  //         setUsers(items);
  //         setAllAllotments(items);
  //     }
  // }

  // useEffect(() => {
  //   dispatch(actions.activeMenu("allallotments"));
  //   let tempSideMenuArray = [];
  //   subTabs.forEach((el, index) => {
  //     if (
  //       Object.keys(
  //         loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]
  //       )?.includes(el.text)
  //     ) {
  //       if (
  //         loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[el.text]
  //           ?.isAccessible
  //       ) {
  //         tempSideMenuArray.push(el);
  //       }
  //     }
  //   });
  //   if (tempSideMenuArray.length > 0) {
  //     tempSideMenuArray[0].isSelected = true;
  //   }
  //   setSubTabs([...tempSideMenuArray]);
  //   // axios.get(`https://labour.vjerp.com:4423/crmCustomer/getCRMUsers`).then((resp) => {
  //   //   resp.data.results.forEach((ele) => {
  //   //     ele.label = ele.Name
  //   //     ele.value = ele.Name
  //   //   })
  //   //   console.log(resp.data.results)
  //   //   setCrmUsers([...resp.data.results]);

  //   // }).catch((err) => {
  //   //   console.log(err)
  //   // })

  //   getCRMUsersFromUserTable()
  //     .then((crmUsersRes) => {
  //       crmUsersRes.data.forEach((ele) => {
  //         ele.label = ele.name;
  //         ele.value = ele.name;
  //       });
  //       setCrmUsers([...crmUsersRes.data]);
  //     })
  //     .catch((err) => {
  //       console.error(err.message);
  //     });
  //   getCRMUserFromCRMTable()
  //     .then((respCRM) => {
  //       setCRMUserFromCRMTable([...respCRM.data]);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  //   getAllStatusesFromTable();
  //   // getAllotmentList();
  //   // getSubfilters("None", "0");
  // }, []);


  useEffect(() => {
    dispatch(actions.activeMenu("allallotments"));

    let tempSideMenuArray = [];

    // Add fallback access for "Parking Selection" if missing
    const allAllotmentsAccess = {
      ...(loggedInUser?.roleId?.accessibleTabs?.["All Allotments"] || {}),
      ...(loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Parking Selection"]
        ? {}
        : { "Parking Selection": { isAccessible: true } }), // ✅ Fallback access
    };

    subTabs.forEach((el, index) => {
      if (
        Object.keys(allAllotmentsAccess).includes(el.text) &&
        allAllotmentsAccess[el.text]?.isAccessible
      ) {
        tempSideMenuArray.push(el);
      }
    });

    if (tempSideMenuArray.length > 0) {
      tempSideMenuArray[0].isSelected = true;
    }

    setSubTabs([...tempSideMenuArray]);

    // CRM Users Fetch
    getCRMUsersFromUserTable()
      .then((crmUsersRes) => {
        crmUsersRes.data.forEach((ele) => {
          ele.label = ele.name;
          ele.value = ele.name;
        });
        setCrmUsers([...crmUsersRes.data]);
      })
      .catch((err) => {
        console.error(err.message);
      });

    // CRM Table Users Fetch
    getCRMUserFromCRMTable()
      .then((respCRM) => {
        setCRMUserFromCRMTable([...respCRM.data]);
      })
      .catch((err) => {
        console.error(err);
      });

    // Statuses
    getAllStatusesFromTable();
  }, []);


  useEffect(() => {
    if (!openPaymentModal) {
      if (tabs?.filter((val) => val?.isSelected && val?.text === "Allotments")
        ?.length > 0) {
        setQueryPage(0);
        setCurrentPage(0);
        getFilterAllotment();
      }
      // getSubfilters("None", "0");
    }
  }, [filterBy, openPaymentModal, search, tabs]);

  useEffect(() => {
    setQueryPageNumber(0);
    setCurrentPageCancellation(0);
    if (tabs?.find((e) => e?.isSelected === true)?.value ===
      "Cancellation Requests") {
      getAllCancelUnit(false);
    }
    if (tabs?.find((e) => e?.isSelected === true)?.value ===
      "Conflicts") {
      getPANConflictsData()
    }
  }, [searchCancelUnit, filterBy]);
  useEffect(() => {
    // setQueryPageNumber(0);
    // setCurrentPageCancellation(0);
    if (tabs?.filter(
      (val) => val?.isSelected && val?.text === "Change Unit Requests"
    )?.length > 0) {
      getAllChangeUnit(false);
    }
  }, [searchChangeUnit, filterBy]);

  useEffect(() => {
    // console.log(checked);
    let all_filters = [];

    let all_cpId = [];
    let all_projectId = [];
    let all_salesRepresentativeId = [];
    let all_pendingUserId = [];
    let all_status = [];
    let all_crmUsers = [];
    let all_kyc = [];
    let all_crm_taged = [];
    let lead_type = [];
    let jsonParse;

    if (tabName === "cancellation" || tabName === "change-unit") {
      setChecked([
        "{\"value\":\"Pending\",\"filter\":\"Status\"}"
      ])
    }

    if (tabName === "cancellation-reprice" || tabName === "change-unit-reprice") {
      setChecked([
        "{\"value\":\"Accepted\",\"filter\":\"Status\"}"
      ])
    }

    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "Pending With") {
        all_pendingUserId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsers.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "Kyc") {
        all_kyc.push(jsonParse.value);
      } else if (jsonParse.filter == "CRM Tagged") {
        all_crm_taged.push(jsonParse.value);
      } else if (jsonParse.filter == "Lead Type") {
        lead_type.push(jsonParse.value);
      }
    });

    if (all_cpId.length !== 0) {
      if (all_filters.indexOf("CP") == -1) {
        all_filters.push("CP");
      }
    }

    if (all_kyc.length !== 0) {
      if (all_filters.indexOf("Kyc") == -1) {
        all_filters.push("Kyc");
      }
    }
    if (lead_type.length !== 0) {
      if (all_filters.indexOf("Lead Type") == -1) {
        all_filters.push("Lead Type");
      }
    }
    if (all_status.length !== 0) {
      if (all_filters.indexOf("Status") == -1) {
        all_filters.push("Status");
      }
    }

    if (all_crm_taged.length !== 0) {
      if (all_filters.indexOf("CRM Tagged") == -1) {
        all_filters.push("CRM Tagged");
      }
    }

    if (
      all_projectId[0]?.[0]?.["p"]?.length > 0 ||
      all_projectId[0]?.[0]?.["w"]?.length > 0 ||
      all_projectId[0]?.[0]?.["f"]?.length > 0
    ) {
      if (all_filters.indexOf("Projects") == -1) {
        all_filters.push("Projects");
      }
    }

    if (all_salesRepresentativeId.length !== 0) {
      if (all_filters.indexOf("SM") == -1) {
        all_filters.push("SM");
      }
    }

    if (all_pendingUserId.length !== 0) {
      if (all_filters.indexOf("Pending With") == -1) {
        all_filters.push("Pending With");
      }
    }

    if (all_crmUsers.length !== 0) {
      if (all_filters.indexOf("CRM") == -1) {
        all_filters.push("CRM");
      }
    }

    if (selectDates[0]?.value !== "" && selectDates[1]?.value !== "") {
      if (all_filters.indexOf("Date") == -1) {
        all_filters.push("Date");
      }
    }
    // if (projectSelected.length !== 0) {
    //   all_filters.push("Project");
    // }

    if (all_filters.length == 0) {
      setBtnName("None");
    } else {
      setBtnName(all_filters.join(","));
    }
  }, [checked, selectDates]);
  useEffect(() => {
    if (filter === "None") {
      setSelectDates([
        { label: "StartDate", value: "" },
        { label: "EndDate", value: "" },
      ]);
    }
    setSearchChangeUnit1("");
  }, [filter]);

  const handleToggle = (value, filter) => () => {
    const currentIndex = checked.indexOf(
      JSON.stringify({ value: value, filter: filter })
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(JSON.stringify({ value: value, filter: filter }));
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(0) + "M"; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  useEffect(() => {
    if (!openPaymentModal && !openLoaderModal) {
      setCurrentPage(0);
      setSearch("");
      setQueryPage(0);
      setChecked([]);
      setLoadingStatus(0);
    }
  }, [openPaymentModal, openLoaderModal]);

  function getAllStatusesFromTable() {
    //*to get inventory-Statuses
    getAllInventoryStatusFromTable()
      .then((resp) => {
        const AllotedStatus = resp.data.filter(
          (f) => f.status === "Payment Pending"
        );
        setPaymentPendingInventoryStatus(AllotedStatus[0]?.inventoryStatusId);

        const onHoldStatus = resp.data.filter((f) => f.status === "On Hold");
        setHoldInventoryStatus(onHoldStatus[0]?.inventoryStatusId);

        // const onPreSelectStatus = resp.data.filter(
        //   (f) => f.status === "Preselected"
        // );
        // setPreSelectInventoryStatus(onPreSelectStatus[0]?.inventoryStatusId);

        const kycPending = resp.data.filter((f) => f.status === "Kyc Pending");
        setKycPendingInventoryStatus(kycPending[0]?.inventoryStatusId);

        const kycDone = resp.data.filter((f) => f.status === "Kyc Done");
        setKycDoneInventoryStatus(kycDone[0]?.inventoryStatusId);
      })
      .catch((err) => {
        console.error("Inventory=Status", err);
      });
  }
  async function selectedValueCheck(value, allotment) {
    if (value === "Details") {
      presentLoader();
      getAllotmentById(allotment.allotmentpaymentid).then((resp) => {
        getAllAllotmentTransactions(allotment.allotmentpaymentid).then((re) => {
          setDataForModal({
            ...resp.data[0],
            AllotmentTransactions: re.data,
          });
          setOpen(true);
          dismissLoader();
        });
      });
    } else if (value === "Check Status") {
      getAllotmentById(allotment.allotmentpaymentid).then((resp) => {
        setAllotmentDetails(resp.data[0]);
        // let amt = resp.data[0]?.inventoryMergedId?.inventoryMergeId ? resp.data[0].inventoryMergedId.unit1Id.projectId.bookingAmt : resp.data[0].unitId.projectId.bookingAmt
        let amt = resp.data[0]?.bookingAmt?.total;
        if (
          resp.data[0]?.paymentId?.eventId?.adjustTokenAmt &&
          resp.data[0]?.paymentId?.pricingType !== "preselect"
        ) {
          setAmountToBePaid(
            parseInt(amt) - resp.data[0]?.paymentId?.paidAmount
          );
        } else {
          setAmountToBePaid(parseInt(amt));
        }
        getAllotmentTransactions(allotment.allotmentpaymentid).then(
          (transactions) => {
            if (transactions.data.length > 0) {
              setOpenLoaderModal(true);
              setMode("pending");
              setMessage("Checking Status");
              transactions.data.forEach((ele, index) => {
                axios
                  .post(
                    process.env.REACT_APP_PAYMENT_LINK_URL +
                    "payments/check-pos-transaction-status",
                    {
                      ptrnNo: parseInt(ele.paymentDetails.ptrnNo),
                      merchantId: ele.machineId.merchantId,
                      securityToken: ele.machineId.securityToken,
                      imei: ele.machineId.imei,
                      merchantStorePosCode: ele.machineId.merchantStorePosCode,
                    }
                  )
                  .then(async (statusRes) => {
                    if (statusRes.data.message === "expired") {
                      await supabase
                        .from("AllotmentTransactions")
                        .update({ status: "expired" })
                        .eq("paymentDetails->ptrnNo", ele.paymentDetails.ptrnNo)
                        .then(async (_re) => {
                          ele.status = "expired";
                          setAllTransactions((pre) => {
                            pre.push(ele);
                            return [...pre];
                          });
                          if (index === transactions.data.length - 1) {
                            // dismissLoader()
                            setMode("status");
                            setMessage("Transaction Expired");
                          }
                        });
                    } else if (statusRes.data.message === "completed") {
                      let leadstatus = "";
                      let allotmentstatus = "";
                      let totalAmount = 0;
                      if (
                        resp.data[0]?.paymentId?.eventId?.adjustTokenAmt &&
                        resp.data[0]?.paymentId?.pricingType !== "preselect"
                      ) {
                        totalAmount =
                          parseInt(resp.data[0].bookingAmt?.total) -
                          resp.data[0]?.paymentId?.paidAmount;
                      } else {
                        totalAmount = parseInt(resp.data[0].bookingAmt?.total);
                      }
                      let fullAmount = amountToBePaid
                        ? amountToBePaid
                        : totalAmount;
                      if (
                        fullAmount - resp.data[0].paidAmount >
                        parseInt(ele.amount)
                      ) {
                        allotmentstatus = "Partial Payment Done";
                        if (resp.data[0].pricingType === "preselect") {
                          leadstatus = "Preselect Partial Payment Done";
                        } else {
                          leadstatus = "Allotment Partial Payment Done";
                        }
                      } else {
                        allotmentstatus = "Payment Complete";
                        if (resp.data[0].pricingType === "preselect") {
                          leadstatus = "Preselect Price Confirmation Pending";
                        } else {
                          leadstatus = "Allotment Payment Complete";
                        }
                      }
                      let paidAmt = resp.data[0].paidAmt
                        ? resp.data[0].paidAmt
                        : { ocr: 0, gst: 0, sdr: 0 };
                      let currentAmt = parseInt(ele.amount);
                      let ocr = 0;
                      let gst = 0;
                      let sdr = 0;
                      if (
                        currentAmt <=
                        resp.data[0].bookingAmt.ocr - paidAmt.ocr
                      ) {
                        ocr = currentAmt;
                        currentAmt = 0;
                      } else {
                        ocr = resp.data[0].bookingAmt.ocr - paidAmt.ocr;
                        currentAmt =
                          currentAmt -
                          (resp.data[0].bookingAmt.ocr - paidAmt.ocr);
                      }
                      if (
                        currentAmt <=
                        resp.data[0].bookingAmt.gst - paidAmt.gst
                      ) {
                        gst = currentAmt;
                        currentAmt = 0;
                      } else {
                        gst = resp.data[0].bookingAmt.gst - paidAmt.gst;
                        currentAmt =
                          currentAmt -
                          (resp.data[0].bookingAmt.gst - paidAmt.gst);
                      }
                      if (
                        currentAmt <=
                        resp.data[0].bookingAmt.sdr - paidAmt.sdr
                      ) {
                        sdr = currentAmt;
                        currentAmt = 0;
                      } else {
                        sdr = resp.data[0].bookingAmt.sdr - paidAmt.sdr;
                        currentAmt =
                          currentAmt -
                          (resp.data[0].bookingAmt.sdr - paidAmt.sdr);
                      }
                      paidAmt = {
                        ocr: paidAmt.ocr + ocr,
                        gst: paidAmt.gst + gst,
                        sdr: paidAmt.sdr + sdr,
                      };
                      await supabase
                        .from("AllotmentPayment")
                        .update({
                          paidAmt: paidAmt,
                          status: allotmentstatus,
                          preselectConfirmation:
                            allotmentstatus ===
                              "Preselect Price Confirmation Pending"
                              ? "confirmation pending"
                              : resp.data[0].preselectConfirmation,
                          paidAmount: parseFloat(
                            resp.data[0].paidAmount + parseInt(ele.amount)
                          ),
                        })
                        .eq(
                          "allotmentPaymentId",
                          resp.data[0].allotmentPaymentId
                        )
                        .then(async (_resp) => {
                          await supabase
                            .from("AllotmentTransactions")
                            .update({
                              ocr: ocr,
                              gst: gst,
                              sdr: sdr,
                              status: "complete",
                            })
                            .eq(
                              "paymentDetails->ptrnNo",
                              ele.paymentDetails.ptrnNo
                            )
                            .then(async (_re) => {
                              // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - resp.data[0].paidAmount) > ele.amount) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
                              await supabase
                                .from("LeadStatus")
                                .update({
                                  status: leadstatus,
                                })
                                .eq("leadId", resp.data[0].leadId.leadId)
                                .then(async (_r) => {
                                  if (
                                    resp.data[0].pricingType === "preselect"
                                  ) {
                                    await supabase
                                      .from("EventTokenLeadRelations")
                                      .update({
                                        paidAmount: fullAmount,
                                        status: "alloted",
                                      })
                                      .eq(
                                        "paymentId",
                                        resp.data[0].paymentId.paymentId
                                      )
                                      .then((rr) => {
                                        ele.status = "complete";
                                        setAllTransactions((pre) => {
                                          pre.push(ele);
                                          return [...pre];
                                        });
                                        if (
                                          index ===
                                          transactions.data.length - 1
                                        ) {
                                          // dismissLoader()
                                          setMode("status");
                                          setMessage("Transaction Completed");
                                        }
                                      });
                                    let obj = {
                                      leadId: resp.data[0].leadId.leadId,
                                      leadStatus: leadstatus,
                                      message: leadstatus,
                                    };
                                    addLeadLogs(obj)
                                      .then((leadLog) => {
                                        console.log(leadLog);
                                      })
                                      .catch((err) => {
                                        console.log("leadlog", err);
                                      });
                                  } else {
                                    if (
                                      fullAmount - resp.data[0].paidAmount <=
                                      parseInt(ele.amount)
                                    ) {
                                      if (!resp.data[0].kycformfilled) {
                                        supabase
                                          .from("InventoryStatus")
                                          .select("*")
                                          .eq("status", "Kyc Pending")
                                          .then((statusRes) => {
                                            if (
                                              resp.data[0]?.inventoryMergedId &&
                                              resp.data[0]?.inventoryMergedId
                                                .inventoryMergeId !== ""
                                            ) {
                                              supabase
                                                .from("Inventory")
                                                .update({
                                                  inventoryStatusId:
                                                    statusRes.data[0]
                                                      .inventoryStatusId,
                                                })
                                                .eq(
                                                  "unitId",
                                                  resp.data[0].inventoryMergedId
                                                    .unit1Id.unitId
                                                )
                                                .then((updateRes) => {
                                                  supabase
                                                    .from("InventoryLogs")
                                                    .insert({
                                                      unitId:
                                                        resp.data[0]
                                                          .inventoryMergedId
                                                          .unit1Id.unitId,
                                                      leadId:
                                                        resp.data[0].leadId
                                                          .leadId,
                                                      userId: JSON.parse(
                                                        localStorage.getItem(
                                                          "user"
                                                        )
                                                      ).userId,
                                                      status: "kyc pending",
                                                      pricingType:
                                                        resp.data[0]
                                                          .pricingType,
                                                      eventId:
                                                        resp.data[0]?.paymentId
                                                          ?.eventId.eventId,
                                                      projectId:
                                                        resp.data[0]
                                                          .inventoryMergedId
                                                          .unit1Id.projectId
                                                          .projectId,
                                                    })
                                                    .then((updateRes) => {
                                                      supabase
                                                        .from("Inventory")
                                                        .update({
                                                          inventoryStatusId:
                                                            statusRes.data[0]
                                                              .inventoryStatusId,
                                                        })
                                                        .eq(
                                                          "unitId",
                                                          resp.data[0]
                                                            .inventoryMergedId
                                                            .unit2Id.unitId
                                                        )
                                                        .then((updateRes) => {
                                                          supabase
                                                            .from(
                                                              "InventoryLogs"
                                                            )
                                                            .insert({
                                                              unitId:
                                                                resp.data[0]
                                                                  .inventoryMergedId
                                                                  .unit1Id
                                                                  .unitId,
                                                              leadId:
                                                                resp.data[0]
                                                                  .leadId
                                                                  .leadId,
                                                              userId:
                                                                JSON.parse(
                                                                  localStorage.getItem(
                                                                    "user"
                                                                  )
                                                                ).userId,
                                                              status:
                                                                "kyc pending",
                                                              pricingType:
                                                                resp.data[0]
                                                                  .pricingType,
                                                              eventId:
                                                                resp.data[0]
                                                                  ?.paymentId
                                                                  ?.eventId
                                                                  .eventId,
                                                              projectId:
                                                                resp.data[0]
                                                                  .inventoryMergedId
                                                                  .unit1Id
                                                                  .projectId
                                                                  .projectId,
                                                            })
                                                            .then(
                                                              (updateRes) => {
                                                                let obj = {
                                                                  leadId:
                                                                    resp.data[0]
                                                                      .leadId
                                                                      .leadId,
                                                                  leadStatus: `${resp.data[0]
                                                                    .pricingType ===
                                                                    "preselect"
                                                                    ? "Preselect confirmation pending"
                                                                    : fullAmount -
                                                                      resp
                                                                        .data[0]
                                                                        .paidAmount >
                                                                      parseInt(
                                                                        ele.amount
                                                                      )
                                                                      ? "Allotment Partial Payment Done"
                                                                      : "Allotment Payment Complete"
                                                                    }`,
                                                                  message: `Unit:${resp
                                                                    ?.data[0]
                                                                    ?.inventoryMergedId
                                                                    ?.unit1Id
                                                                    ?.unit1No
                                                                    ? resp
                                                                      ?.data[0]
                                                                      ?.inventoryMergedId
                                                                      ?.unit1Id
                                                                      ?.unit1No +
                                                                    resp
                                                                      ?.data[0]
                                                                      ?.inventoryMergedId
                                                                      ?.unit2Id
                                                                      ?.unit2No
                                                                    : resp
                                                                      ?.data[0]
                                                                      ?.unitId
                                                                      ?.unitNo
                                                                    },by ${JSON.parse(
                                                                      localStorage.getItem(
                                                                        "user"
                                                                      )
                                                                    ).name
                                                                    }, status: "kyc pending", pricingType: ${resp
                                                                      ?.data[0]
                                                                      ?.pricingType
                                                                    },event: ${resp
                                                                      ?.data[0]
                                                                      ?.paymentId
                                                                      ?.eventId
                                                                      ?.title
                                                                    }, Project:${resp
                                                                      ?.data[0]
                                                                      ?.inventoryMergedId
                                                                      ?.unit1Id
                                                                      ?.projectId
                                                                      ?.projectName
                                                                      ? resp
                                                                        ?.data[0]
                                                                        ?.inventoryMergedId
                                                                        ?.unit1Id
                                                                        ?.projectId
                                                                        ?.projectName
                                                                      : resp
                                                                        ?.data[0]
                                                                        ?.unitId
                                                                        ?.projectId
                                                                        ?.projectName
                                                                    }`,
                                                                };
                                                                addLeadLogs(obj)
                                                                  .then(
                                                                    (
                                                                      leadLog
                                                                    ) => {
                                                                      console.log(
                                                                        leadLog
                                                                      );
                                                                    }
                                                                  )
                                                                  .catch(
                                                                    (err) => {
                                                                      console.log(
                                                                        "leadlog",
                                                                        err
                                                                      );
                                                                    }
                                                                  );
                                                                ele.status =
                                                                  "complete";
                                                                setAllTransactions(
                                                                  (pre) => {
                                                                    pre.push(
                                                                      ele
                                                                    );
                                                                    return [
                                                                      ...pre,
                                                                    ];
                                                                  }
                                                                );
                                                                if (
                                                                  index ===
                                                                  transactions
                                                                    .data
                                                                    .length -
                                                                  1
                                                                ) {
                                                                  // dismissLoader()
                                                                  setMode(
                                                                    "status"
                                                                  );
                                                                  setMessage(
                                                                    "Transaction Completed"
                                                                  );
                                                                }
                                                              }
                                                            );
                                                        });
                                                    });
                                                });
                                            } else {
                                              supabase
                                                .from("Inventory")
                                                .update({
                                                  inventoryStatusId:
                                                    statusRes.data[0]
                                                      .inventoryStatusId,
                                                })
                                                .eq(
                                                  "unitId",
                                                  resp.data[0].unitId.unitId
                                                )
                                                .then((updateRes) => {
                                                  supabase
                                                    .from("InventoryLogs")
                                                    .insert({
                                                      unitId:
                                                        resp.data[0].unitId
                                                          .unitId,
                                                      leadId:
                                                        resp.data[0].leadId
                                                          .leadId,
                                                      userId: JSON.parse(
                                                        localStorage.getItem(
                                                          "user"
                                                        )
                                                      ).userId,
                                                      status: "kyc pending",
                                                      pricingType:
                                                        resp.data[0]
                                                          .pricingType,
                                                      eventId:
                                                        resp.data[0]?.paymentId
                                                          ?.eventId.eventId,
                                                      projectId:
                                                        resp.data[0].unitId
                                                          .projectId.projectId,
                                                    })
                                                    .then((updateRes) => {
                                                      let obj = {
                                                        leadId:
                                                          resp.data[0].leadId
                                                            .leadId,
                                                        leadStatus: `${resp.data[0]
                                                          .pricingType ===
                                                          "preselect"
                                                          ? "Preselect confirmation pending"
                                                          : fullAmount -
                                                            resp.data[0]
                                                              .paidAmount >
                                                            parseInt(
                                                              ele.amount
                                                            )
                                                            ? "Allotment Partial Payment Done"
                                                            : "Allotment Payment Complete"
                                                          }`,
                                                        message: `Unit:${resp?.data[0]
                                                          ?.inventoryMergedId
                                                          ?.unit1Id?.unit1No
                                                          ? resp?.data[0]
                                                            ?.inventoryMergedId
                                                            ?.unit1Id
                                                            ?.unit1No +
                                                          resp?.data[0]
                                                            ?.inventoryMergedId
                                                            ?.unit2Id
                                                            ?.unit2No
                                                          : resp?.data[0]
                                                            ?.unitId?.unitNo
                                                          },by ${JSON.parse(
                                                            localStorage.getItem(
                                                              "user"
                                                            )
                                                          ).name
                                                          }, status: "kyc pending", pricingType: ${resp?.data[0]
                                                            ?.pricingType
                                                          },event: ${resp?.data[0]
                                                            ?.paymentId?.eventId
                                                            ?.title
                                                          }, Project:${resp?.data[0]
                                                            ?.inventoryMergedId
                                                            ?.unit1Id?.projectId
                                                            ?.projectName
                                                            ? resp?.data[0]
                                                              ?.inventoryMergedId
                                                              ?.unit1Id
                                                              ?.projectId
                                                              ?.projectName
                                                            : resp?.data[0]
                                                              ?.unitId
                                                              ?.projectId
                                                              ?.projectName
                                                          }`,
                                                      };
                                                      addLeadLogs(obj)
                                                        .then((leadLog) => {
                                                          console.log(leadLog);
                                                        })
                                                        .catch((err) => {
                                                          console.log(
                                                            "leadlog",
                                                            err
                                                          );
                                                        });
                                                      ele.status = "complete";
                                                      setAllTransactions(
                                                        (pre) => {
                                                          pre.push(ele);
                                                          return [...pre];
                                                        }
                                                      );
                                                      if (
                                                        index ===
                                                        transactions.data
                                                          .length -
                                                        1
                                                      ) {
                                                        // dismissLoader()
                                                        setMode("status");
                                                        setMessage(
                                                          "Transaction Completed"
                                                        );
                                                      }
                                                    });
                                                });
                                            }
                                          });
                                      } else {
                                        // callBookingApis();
                                      }
                                    } else {
                                      ele.status = "complete";
                                      setAllTransactions((pre) => {
                                        pre.push(ele);
                                        return [...pre];
                                      });
                                      if (
                                        index ===
                                        transactions.data.length - 1
                                      ) {
                                        // dismissLoader()
                                        setMode("status");
                                        setMessage("Transaction Completed");
                                      }
                                    }
                                  }
                                });
                            });
                        });
                    } else {
                      checkStatus(
                        ele.paymentDetails.ptrnNo,
                        true,
                        resp.data[0],
                        ele.amount,
                        ele.transactionTime,
                        ele.machineId
                      );
                    }
                  })
                  .catch((err) => {
                    setMode("expired");
                    setMessage("Please check POS internet connectivity");
                  });
              });
            } else {
              errorTost("No Pending Transactions available");
            }
          }
        );
      });
    } else if (value === "Adjust Token") {
      setAllotmentForAdjustToken(allotment);
    } else if (value === "Cancel Unit") {
      let leadobj = {
        leadId: allotment?.leadid,
        leadname: allotment?.leadname,
        leademail: allotment?.leademail,
        leadcontactnumber: allotment?.leadcontactnumber,
        leaddisplayid: allotment?.leaddisplayid,
      };
      let allotmentObj = {
        allotmentPaymentId: allotment?.allotmentpaymentid,
      };
      setLeadObj(leadobj);
      setSelectedAllotment(allotmentObj);
      setCancelUnitModal(true);
    } else if (value === "Assign CRM") {
      setSelectedSingleCrmAssign(allotment);
      setTimeout(() => {
        assignCrmSubmit(allotment?.allotmentpaymentid);
      }, 500);
    } else if (value === "Timeline And Notes") {
      setAllotmentData(allotment);
      setcrmTimeLineModalToggle(true);
    } else if (value === "View Unit Cost") {
      console.log(allotment)
      setAllotmentData(allotment);
      setViewUnitCostModalToggle(true);
    }
  }

  useEffect(() => {
    if (allotmentForAdjustToken && allotmentForAdjustToken.allotmentpaymentid) {
      setOpenAdjustTokenModal(true);
    }
  }, [allotmentForAdjustToken]);

  function checkStatus(ptrnNo, flag, allotment, myamt, time, machineId) {
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL +
        "payments/check-pos-transaction-status",
        {
          ptrnNo: parseInt(ptrnNo),
          merchantId: machineId.merchantId,
          securityToken: machineId.securityToken,
          imei: machineId.imei,
          merchantStorePosCode: machineId.merchantStorePosCode,
        }
      )
      .then(async (statusRes) => {
        if (statusRes.data.message === "expired") {
          await supabase
            .from("AllotmentTransactions")
            .update({ status: "expired" })
            .eq("paymentDetails->ptrnNo", ptrnNo)
            .then(async (_re) => {
              if (!flag) {
                setPtrnNo("");
                setMode("expired");
                setMessage("Transaction Expired");
              }
            });
        } else if (statusRes.data.message === "completed") {
          let leadstatus = "";
          let allotmentstatus = "";
          let totalAmount = 0;
          if (
            allotment?.paymentId?.eventId?.adjustTokenAmt &&
            allotment?.paymentId?.pricingType !== "preselect"
          ) {
            totalAmount =
              parseInt(allotment.bookingAmt?.total) -
              allotment?.paymentId?.paidAmount;
          } else {
            totalAmount = parseInt(allotment.bookingAmt?.total);
          }
          let fullAmount = amountToBePaid ? amountToBePaid : totalAmount;
          if (fullAmount - allotment.paidAmount > parseInt(myamt)) {
            allotmentstatus = "Partial Payment Done";
            if (allotment.pricingType === "preselect") {
              leadstatus = "Preselect Partial Payment Done";
            } else {
              leadstatus = "Allotment Partial Payment Done";
            }
          } else {
            allotmentstatus = "Payment Complete";
            if (allotment.pricingType === "preselect") {
              leadstatus = "Preselect Price Confirmation Pending";
            } else {
              leadstatus = "Allotment Payment Complete";
            }
          }
          let paidAmt = allotment.paidAmt
            ? allotment.paidAmt
            : { ocr: 0, gst: 0, sdr: 0 };
          let currentAmt = parseInt(myamt);
          let ocr = 0;
          let gst = 0;
          let sdr = 0;
          if (currentAmt <= allotment.bookingAmt.ocr - paidAmt.ocr) {
            ocr = currentAmt;
            currentAmt = 0;
          } else {
            ocr = allotment.bookingAmt.ocr - paidAmt.ocr;
            currentAmt = currentAmt - (allotment.bookingAmt.ocr - paidAmt.ocr);
          }
          if (currentAmt <= allotment.bookingAmt.gst - paidAmt.gst) {
            gst = currentAmt;
            currentAmt = 0;
          } else {
            gst = allotment.bookingAmt.gst - paidAmt.gst;
            currentAmt = currentAmt - (allotment.bookingAmt.gst - paidAmt.gst);
          }
          if (currentAmt <= allotment.bookingAmt.sdr - paidAmt.sdr) {
            sdr = currentAmt;
            currentAmt = 0;
          } else {
            sdr = allotment.bookingAmt.sdr - paidAmt.sdr;
            currentAmt = currentAmt - (allotment.bookingAmt.sdr - paidAmt.sdr);
          }
          paidAmt = {
            ocr: paidAmt.ocr + ocr,
            gst: paidAmt.gst + gst,
            sdr: paidAmt.sdr + sdr,
          };
          await supabase
            .from("AllotmentPayment")
            .update({
              paidAmt: paidAmt,
              status: allotmentstatus,
              preselectConfirmation:
                allotmentstatus === "Preselect Price Confirmation Pending"
                  ? "confirmation pending"
                  : allotment.preselectConfirmation,
              paidAmount: parseFloat(allotment.paidAmount + parseInt(myamt)),
            })
            .eq("allotmentPaymentId", allotment.allotmentPaymentId)
            .then(async (_resp) => {
              await supabase
                .from("AllotmentTransactions")
                .update({ ocr: ocr, gst: gst, sdr: sdr, status: "complete" })
                .eq("paymentDetails->ptrnNo", ptrnNo)
                .then(async (_re) => {
                  // await supabase.from('LeadStatus').update({ status: ((payments.data[i].totalCost - allotment.paidAmount) > myamt) ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete' }).eq('leadId', payments.data[0].leadId).then((_r) => {
                  await supabase
                    .from("LeadStatus")
                    .update({
                      status: leadstatus,
                    })
                    .eq("leadId", allotment.leadId.leadId)
                    .then(async (_r) => {
                      // if (fullAmount - allotment.paidAmount <= parseInt(myamt)) {
                      if (allotment.pricingType === "preselect") {
                        await supabase
                          .from("EventTokenLeadRelations")
                          .update({
                            paidAmount: fullAmount,
                            status: "alloted",
                          })
                          .eq("paymentId", allotment.paymentId.paymentId)
                          .then((rr) => {
                            let obj = {
                              leadId: allotment.leadId.leadId,
                              leadStatus: `${allotment.pricingType === "preselect"
                                ? "Preselect confirmation pending"
                                : fullAmount - allotment.paidAmount >
                                  parseInt(myamt)
                                  ? "Allotment Partial Payment Done"
                                  : "Allotment Payment Complete"
                                }`,
                              message: `Amount Paid${fullAmount}`,
                            };
                            addLeadLogs(obj)
                              .then((leadLog) => {
                                console.log(leadLog);
                              })
                              .catch((err) => {
                                console.error("leadlog", err);
                              });
                            if (!flag) {
                              setAmount(myamt);
                              setPtrnNo("");
                              setMode("complete");
                            }
                          });
                      } else {
                        if (
                          fullAmount - allotment.paidAmount <=
                          parseInt(myamt)
                        ) {
                          if (!allotment.kycformfilled) {
                            supabase
                              .from("InventoryStatus")
                              .select("*")
                              .eq("status", "Kyc Pending")
                              .then((statusRes) => {
                                if (
                                  allotment?.inventoryMergedId &&
                                  allotment?.inventoryMergedId
                                    .inventoryMergeId !== ""
                                ) {
                                  supabase
                                    .from("Inventory")
                                    .update({
                                      inventoryStatusId:
                                        statusRes.data[0].inventoryStatusId,
                                    })
                                    .eq(
                                      "unitId",
                                      allotment.inventoryMergedId.unit1Id.unitId
                                    )
                                    .then((updateRes) => {
                                      supabase
                                        .from("InventoryLogs")
                                        .insert({
                                          unitId:
                                            allotment.inventoryMergedId.unit1Id
                                              .unitId,
                                          leadId: allotment.leadId.leadId,
                                          userId: JSON.parse(
                                            localStorage.getItem("user")
                                          ).userId,
                                          status: "kyc pending",
                                          pricingType: allotment.pricingType,
                                          eventId:
                                            allotment?.paymentId?.eventId
                                              .eventId,
                                          projectId:
                                            allotment.inventoryMergedId.unit1Id
                                              .projectId.projectId,
                                        })
                                        .then((updateRes) => {
                                          supabase
                                            .from("Inventory")
                                            .update({
                                              inventoryStatusId:
                                                statusRes.data[0]
                                                  .inventoryStatusId,
                                            })
                                            .eq(
                                              "unitId",
                                              allotment.inventoryMergedId
                                                .unit2Id.unitId
                                            )
                                            .then((updateRes) => {
                                              supabase
                                                .from("InventoryLogs")
                                                .insert({
                                                  unitId:
                                                    allotment.inventoryMergedId
                                                      .unit1Id.unitId,
                                                  leadId:
                                                    allotment.leadId.leadId,
                                                  userId: JSON.parse(
                                                    localStorage.getItem("user")
                                                  ).userId,
                                                  status: "kyc pending",
                                                  pricingType:
                                                    allotment.pricingType,
                                                  eventId:
                                                    allotment?.paymentId
                                                      ?.eventId.eventId,
                                                  projectId:
                                                    allotment.inventoryMergedId
                                                      .unit1Id.projectId
                                                      .projectId,
                                                })
                                                .then((updateRes) => {
                                                  // !!remaining

                                                  let obj = {
                                                    leadId:
                                                      allotment.leadId.leadId,
                                                    leadStatus: `${allotment.pricingType ===
                                                      "preselect"
                                                      ? "Preselect confirmation pending"
                                                      : fullAmount -
                                                        allotment.paidAmount >
                                                        parseInt(myamt)
                                                        ? "Allotment Partial Payment Done"
                                                        : "Allotment Payment Complete"
                                                      }`,
                                                    message: `Unit:${allotment
                                                      ?.inventoryMergedId
                                                      ?.unit1Id?.unit1No
                                                      ? allotment
                                                        ?.inventoryMergedId
                                                        ?.unit1Id?.unit1No +
                                                      allotment
                                                        ?.inventoryMergedId
                                                        ?.unit2Id?.unit2No
                                                      : allotment?.unitId
                                                        ?.unitNo
                                                      },by ${JSON.parse(
                                                        localStorage.getItem(
                                                          "user"
                                                        )
                                                      ).name
                                                      }, status: "kyc pending", pricingType: ${allotment?.pricingType
                                                      },event: ${allotment?.paymentId
                                                        ?.eventId?.title
                                                      }, Project:${allotment
                                                        ?.inventoryMergedId
                                                        ?.unit1Id?.projectId
                                                        ?.projectName
                                                        ? allotment
                                                          ?.inventoryMergedId
                                                          ?.unit1Id?.projectId
                                                          ?.projectName
                                                        : allotment?.unitId
                                                          ?.projectId
                                                          ?.projectName
                                                      }`,
                                                  };
                                                  addLeadLogs(obj)
                                                    .then((leadLog) => {
                                                      console.log(leadLog);
                                                    })
                                                    .catch((err) => {
                                                      console.log(
                                                        "leadlog",
                                                        err
                                                      );
                                                    });
                                                  if (!flag) {
                                                    setAmount(myamt);
                                                    setPtrnNo("");
                                                    setMode("complete");
                                                  }
                                                });
                                            });
                                        });
                                    });
                                } else {
                                  supabase
                                    .from("Inventory")
                                    .update({
                                      inventoryStatusId:
                                        statusRes.data[0].inventoryStatusId,
                                    })
                                    .eq("unitId", allotment.unitId.unitId)
                                    .then((updateRes) => {
                                      supabase
                                        .from("InventoryLogs")
                                        .insert({
                                          unitId: allotment.unitId.unitId,
                                          leadId: allotment.leadId.leadId,
                                          userId: JSON.parse(
                                            localStorage.getItem("user")
                                          ).userId,
                                          status: "kyc pending",
                                          pricingType: allotment.pricingType,
                                          eventId:
                                            allotment?.paymentId?.eventId
                                              .eventId,
                                          projectId:
                                            allotment.unitId.projectId
                                              .projectId,
                                        })
                                        .then((updateRes) => {
                                          let obj = {
                                            leadId: allotment.leadId.leadId,
                                            leadStatus: `${allotment.pricingType ===
                                              "preselect"
                                              ? "Preselect confirmation pending"
                                              : fullAmount -
                                                allotment.paidAmount >
                                                parseInt(myamt)
                                                ? "Allotment Partial Payment Done"
                                                : "Allotment Payment Complete"
                                              }`,
                                            message: `Unit:${allotment?.inventoryMergedId
                                              ?.unit1Id?.unit1No
                                              ? allotment?.inventoryMergedId
                                                ?.unit1Id?.unit1No +
                                              allotment?.inventoryMergedId
                                                ?.unit2Id?.unit2No
                                              : allotment?.unitId?.unitNo
                                              },by ${JSON.parse(
                                                localStorage.getItem("user")
                                              ).name
                                              }, pricingType: ${allotment?.pricingType
                                              },event: ${allotment?.paymentId?.eventId
                                                ?.title
                                              }, Project:${allotment?.inventoryMergedId
                                                ?.unit1Id?.projectId
                                                ?.projectName
                                                ? allotment?.inventoryMergedId
                                                  ?.unit1Id?.projectId
                                                  ?.projectName
                                                : allotment?.unitId?.projectId
                                                  ?.projectName
                                              }`,
                                          };
                                          addLeadLogs(obj)
                                            .then((leadLog) => {
                                              console.log(leadLog);
                                            })
                                            .catch((err) => {
                                              console.log("leadlog", err);
                                            });
                                          if (!flag) {
                                            setAmount(myamt);
                                            setPtrnNo("");
                                            setMode("complete");
                                          }
                                        });
                                    });
                                }
                              });
                          } else {
                            // callBookingApis();
                          }
                        } else {
                          if (!flag) {
                            setAmount(myamt);
                            setPtrnNo("");
                            setMode("complete");
                          }
                        }
                      }
                    });
                });
            });
        } else {
          if (flag) {
            setMode("pending");
            setTimestamp(time);
            setMessage("Waiting for payment on POS machine");
            setPtrnNo(ptrnNo);
            setOpenLoaderModal(true);
            dismissLoader();
          }
          checkStatus(ptrnNo, false, allotment, myamt, time, machineId);
        }
      })
      .catch((err) => {
        setPtrnNo("");
        setMode("expired");
        setMessage("Please check POS internet connectivity");
      });
  }

  const [value, setValue] = React.useState([1, 200]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const handleChange = (event, newValue) => {
    let priceRanges = scaleValues(value);
    let fromRange = priceRanges[0];
    let toRange = priceRanges[1];

    setFrom(fromRange);
    setTo(toRange);
    setValue(newValue);
  };
  const filterAllotmentBySort = (e) => {
    setFilterBy(e);
    setQueryPage(0);
    setLoadingStatus(0);
  };
  const all_prices = [
    {
      value: 0,
      scaledValue: 2500000,
      label: "25L",
    },
    {
      value: 25,
      scaledValue: 5000000,
      label: "50L",
    },
    {
      value: 50,
      scaledValue: 7500000,
      label: "75L",
    },
    {
      value: 75,
      scaledValue: 10000000,
      label: "1Cr",
    },
    {
      value: 100,
      scaledValue: 20000000,
      label: "2Cr",
    },
    {
      value: 150,
      scaledValue: 50000000,
      label: "5Cr",
    },
    {
      value: 200,
      scaledValue: 100000000,
      label: "10Cr",
    },
  ];

  const userGridColumns = [
    {
      field: "action",
      headerName: "",
      // flex: 1,
      // width: showDropDown ? 200 : 160,
      width: 120,
      renderCell: (params) => {
        return (
          <div className={cssClasses.actionDiv}>
            <div>
              {(showDropDown ||
                (subTabs?.filter(
                  (val) => val.value === "Completed" && val?.isSelected
                )?.length > 0 &&
                  !(params?.row?.crmuserid && params?.row?.crmusername))) && (
                  <Checkbox
                    style={{ width: "2rem", height: "2rem" }}
                    checked={
                      selectedAllotments.filter(
                        (val) =>
                          val?.allotmentpaymentid ===
                          params.row.allotmentpaymentid
                      ).length > 0
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      const payload = [...selectedAllotments];
                      if (e.target.checked) {
                        payload.push(params?.row);
                        setSelectedAllotments(payload);
                        setSelectedAllotmentDataToApprove(payload);
                      } else {
                        const index = selectedAllotments.findIndex(
                          (val) =>
                            val?.allotmentpaymentid ===
                            params?.row?.allotmentpaymentid
                        );
                        payload.splice(index, 1);
                        setSelectedAllotments(payload);
                        setSelectedAllotmentDataToApprove(payload);
                      }

                      if (payload?.length === allAllotments?.length) {
                        setSelectBtnName("Remove All");
                      } else {
                        setSelectBtnName("Select All");
                      }
                    }}
                  />
                )}
              <ThreeDotsMenu
                // list={["Details", "Sync", "Check Status"]}
                list={getList(params.row)}
                selectedValue={(e) => {
                  selectedValueCheck(e, params.row);
                }}
              />
              {(params.row.status === "partial" ||
                params.row.status === "pending") && (
                  <div>
                    <Button
                      btnName={"Pay Now"}
                      clicked={() => {
                        // if (subTabs.find((f) => f.isSelected).value === 'On Hold') {
                        //   releaseUnit(params.row)
                        // } else {
                        openModal(params.row);
                        // }
                      }}
                      style={{
                        width: "60%",
                        color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                      }}
                    />
                    {subTabs.find((f) => f?.isSelected)?.value !== "On Hold" && (
                      <Button
                        btnName={"Release"}
                        clicked={() => {
                          // if (subTabs.find((f) => f.isSelected).value === 'On Hold') {
                          releaseUnit(params.row);
                          // } else {
                          //   openModal(params.row)
                          // }
                        }}
                        style={{
                          width: "60%",
                          color: "#fff",
                          backgroundColor: "rgb(21, 112, 239)",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                        }}
                      />
                    )}
                  </div>
                )}
            </div>
          </div>
        );
      },
    },
    {
      field: "currentUnitDetails",
      headerName: "UNIT",
      flex: 1,
      padding: 0,
      minWidth: 450,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              // alignItems: "center",
              gap: "0.5rem",
              flexDirection: "column",
              color: "#1D2939",
            }}
          >
            <div>
              {params.row.inventorymergeid ? (
                <p style={{ whiteSpace: "normal", fontWeight: 700 }}>
                  {params.row.mergedwing}-{params.row.unit1no}-
                  {params.row.unit2no}
                </p>
              ) : (
                <p style={{ whiteSpace: "normal", fontWeight: 700 }}>
                  {" "}
                  {`${params.value.char} - ${params.value.projectId} | ${params.value.area}`}{" "}
                  |{" "}
                  {params.row.projectname
                    ? params.row.projectname
                    : params.row.mergedproject}
                </p>
              )}
            </div>
            <Tooltip
              className={classes.Tooltip}
              placement="bottom-start"
              title={
                <p style={{ fontSize: "1.4rem" }}>
                  {params.row.allotmentpaymentid}
                </p>
              }
            >
              <p
                style={{
                  whiteSpace: "normal",
                  lineBreak: "anywhere",
                  opacity: "0.7",
                }}
              >
                {params.row.allotmentpaymentid}
              </p>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "leaddisplayid",
      headerName: "Lead",
      flex: 1,
      minWidth: 230,
      renderCell: (params) => {
        let el = { leaddisplayid: params.value };
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>{params.row.leadname}</p>
                <p>
                  VJ
                  {el?.leaddisplayid?.replace(
                    el?.leaddisplayid?.substring(8, 12),
                    "-" + el?.leaddisplayid?.substring(8, 12)
                  )}
                </p>
              </div>
            }
          >
            <div>
              <p
                style={{
                  color: "#1D2939",
                  fontWeight: 700,
                  whiteSpace: "normal",
                }}
              >
                {params.row.leadname}
              </p>
              <p style={{ opacity: "0.7" }}>
                VJ
                {el?.leaddisplayid?.replace(
                  el?.leaddisplayid?.substring(8, 12),
                  "-" + el?.leaddisplayid?.substring(8, 12)
                )}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 240,
      renderCell: (params) => {
        return (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <LeadStatusChip
              label={params.row.status}
              style={
                params.row.status === "Payment Pending"
                  ? { color: "#B42318", backgroundColor: "#FEF3F2" }
                  : params.row.status === "Payment Complete"
                    ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                    : { color: "#B54708", backgroundColor: "#FFFAEB" }
              }
              icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
            />
            {params?.row?.kycformfilled ? (
              <LeadStatusChip
                label={"Kyc Done"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
              ></LeadStatusChip>
            ) : (
              <LeadStatusChip
                label={"Kyc pending"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
              ></LeadStatusChip>
            )}
          </div>
        );
      },
    },
    {
      field: "crmStatus",
      headerName: "CRM Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {params?.row?.crmuserid && params?.row?.crmusername ? (
                  <LeadStatusChip
                    label={"CRM Tagged"}
                    icon={<LocalOfferIcon width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"CRM Not Tagged"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#B54708",
                      backgroundColor: "#FFFAEB",
                    }}
                  />
                )}
                {params?.row?.crmstatusid !== null &&
                  params?.row?.status !== "Cancelled" &&
                  params?.row?.status !== "Cancellation Requested" &&
                  params?.row?.status !== "Cancellation Pending" &&
                  params?.row?.status !== "Refund Initiated" &&
                  params?.row?.status !== "Refund Processed" && (
                    <LeadStatusChip
                      label={crmStatusIdValues[params?.row?.crmstatusid]}
                      style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                    />
                  )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "pricingtype",
      headerName: "Mode",
      flex: 1,
      minWidth: 180,
      // renderCell: (params) => {
      //     return (
      //         <LeadStatusChip label={(params.row.paidamount === 0) ? 'Pending' : (params.row.paidamount === 500000) ? 'Complete' : 'Partial'} style={(params.row.paidamount === 0) ? { color: "#B42318", backgroundColor: "#FEF3F2" } : (params.row.paidamount === 500000) ? { color: "#027A48", backgroundColor: "#ECFDF3" } : { color: "#B54708", backgroundColor: "#FFFAEB" }} icon={<Dot width={"0.6rem"} height={"0.6rem"} />} />
      //     )
      // }
    },
    {
      field: "paidamount",
      headerName: "Paid Amount",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            title={
              <p style={{ fontSize: "1.7rem" }}>
                ₹ {numberWithCommas(params.value)}
              </p>
            }
          >
            <p>₹ {numberWithCommas(params.value)}</p>
          </Tooltip>
        );
      },
    },
    {
      field: "totalcost",
      headerName: "Total Amount",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        // return `Rs ${(params.value).toLocaleString()}`;
        return (
          <Tooltip
            title={
              <p style={{ fontSize: "1.7rem" }}>
                ₹ {numberWithCommas(params.row?.unitcost?.total)}
              </p>
            }
            className={classes.Tooltip}
          >
            <p>₹ {numberWithCommas(params.row?.unitcost?.total)}</p>
          </Tooltip>
        );
      },
    },

    {
      field: "username",
      headerName: "Sales Manager",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: "normal" }}>{params.row.username}</div>
        );
      },
    },

    {
      field: "cpbillingname",
      headerName: "CP Name",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div>
              <Tooltip
                className={classes.Tooltip}
                placement="bottom-start"
                title={
                  <p style={{ fontSize: "1.4rem" }}>
                    {params.value ? params.value : "-"}
                  </p>
                }
              >
                <p style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
                  {params.value ? params.value : "-"}
                </p>
              </Tooltip>
            </div>
          </div>
        );
      },
    },

    // {
    //   field: "crmuser",
    //   headerName: JSON.parse(localStorage.getItem("user")).roleId
    //     ?.accessibleTabs["All Allotments"]["Crm Users"]?.isAccessible
    //     ? "CRM User"
    //     : "",
    //   flex: 1,
    //   minWidth: 180,
    //   renderCell: (params) => {
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "1rem",
    //         }}
    //       >
    //         {JSON.parse(localStorage.getItem("user")).roleId?.accessibleTabs[
    //           "All Allotments"
    //         ]["Crm Users"]?.isAccessible && (
    //           <DropDown
    //             list={crmUsers}
    //             selectedValue={params.row.crmuser ? params.row.crmuser : ""}
    //             onChangeSelect={(e) => {
    //               presentLoader();
    //               updateAllotmentPayment(
    //                 {
    //                   crmUser: e,
    //                   crmUserId:
    //                     crmUsers[crmUsers.findIndex((ele) => ele.label === e)]
    //                       .Id,
    //                 },
    //                 params.row.allotmentpaymentid
    //               )
    //                 .then((resp) => {
    //                   setAllAllotments((pre) => {
    //                     pre[
    //                       pre.findIndex(
    //                         (e) =>
    //                           e.allotmentpaymentid ===
    //                           params.row.allotmentpaymentid
    //                       )
    //                     ].crmuser = e;
    //                     pre[
    //                       pre.findIndex(
    //                         (e) =>
    //                           e.allotmentpaymentid ===
    //                           params.row.allotmentpaymentid
    //                       )
    //                     ].crmuserid =
    //                       crmUsers[
    //                         crmUsers.findIndex((ele) => ele.label === e)
    //                       ].Id;
    //                     return [...pre];
    //                   });
    //                   dismissLoader();
    //                 })
    //                 .catch((resp) => {
    //                   dismissLoader();
    //                 });
    //             }}
    //           />
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  async function ModalResp(e) {
    if (e === "confirmed") {
      // presentLoader()
      // selectedAllotments.forEach((ele, index) => {
      //   updateAllotmentPayment({ crmUser: crmUser, crmUserId: crmUsers[crmUsers.findIndex((ele) => ele.label === crmUser)].Id }, ele).then((resp) => {
      //     if (index === selectedAllotments.length - 1) {
      //       setCrmUser("")
      //       setShowDropDown(false)
      //       setOpenAlertBox(false)
      //       setQueryPage(0);
      //       setCurrentPage(0);
      //       getFilterAllotment();
      //       dismissLoader()
      //     }
      //   }).catch((resp) => {
      //     if (index === selectedAllotments.length - 1) {
      //       setCrmUser("")
      //       setShowDropDown(false)
      //       setOpenAlertBox(false)
      //       setQueryPage(0);
      //       setCurrentPage(0);
      //       getFilterAllotment();
      //       dismissLoader()
      //     }
      //   })
      // })

      let isErrorOccurs = false;
      try {
        let _selectedAllotments = [];
        if (selectedSingleCrmAssign) {
          _selectedAllotments = [selectedSingleCrmAssign?.allotmentpaymentid];
        } else {
          _selectedAllotments = [...selectedAllotments];
        }

        console.log("_selectedAllotments", _selectedAllotments)
        for (const selectedAllotmentItem of _selectedAllotments) {
          const data = allAllotments.find(
            (each) => each.allotmentpaymentid === selectedAllotmentItem
          )
          console.log("data", data)
          const updatedUnitCost = {
            bsp: 0,
            gst: 0,
            sdr: 0,
            total: 0
          }
          let allotmentPriceDiscountIds = [];
          if (data?.isdiscounteligible && !data?.isdiscountapplied) {
            let total = 0
            let bsp = 0
            let gst = 0
            let sdr = 0
            if (data?.pricingtype === "sustenance") {
              // if (data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") {
              //   const preselectConfirmationData =
              //     await getPreselectConfirmationsConfig(
              //       "493a6abf-99ee-4f0b-8e1b-e152924fce51",
              //       "3b9a064b-ffea-4b9d-b735-aaacb851cc85",
              //       "54cc7777-658c-4d3d-8f66-b7c7e9fea80c"
              //     );
              //   if (preselectConfirmationData?.data?.length > 0) {
              // total =
              //   data?.unitcost?.total - preselectConfirmationData?.data[0]?.priceDiscount
              const { totalDiscount, priceDiscountIds } = await getDiscountAmountTotal(data?.allotmentpaymentid);
              allotmentPriceDiscountIds = priceDiscountIds;
              total =
                data?.unitcost?.total - totalDiscount;

              // total =
              //   data?.unitcost?.total - ((data?.projectname === "PALLADIO KHARADI CENTRAL PH-2" && data?.wingname === "BUILDING-E3") ? data?.pricediscountamount : preselectConfirmationData?.data[0]?.priceDiscount);

              // bsp = (total - 45000) / 1.11;
              bsp = (total - 45000) / ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 1.11 : (1 + Number(data?.unitcost?.gst / data?.unitcost?.bsp) + (Number(data.sdrpercentage) / 100)));

              // gst = bsp * 0.05;
              // sdr = (((Math.ceil((Math.round((Number(bsp) * (6)) / 100)) / 100) * 100) + 45000) / 100) * 100;

              gst = bsp * Number(data?.unitcost?.gst / data?.unitcost?.bsp);
              // sdr = (Math.ceil((Math.round((bsp * ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(data.sdrpercentage) / 100))) / 100)) / 100) * 100) + sdrCharges;
              sdr = (Math.ceil(Math.round(bsp * ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(data.sdrpercentage) / 100))) / 100) * 100) + 45000;
              let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);

              updatedUnitCost.bsp = Math.round(bsp);
              updatedUnitCost.sdr = Math.round(sdr);
              updatedUnitCost.gst = Math.round(gst);
              updatedUnitCost.total = Math.round(newTotal);
              console.log("updatedUnitCost", updatedUnitCost)
              // } else {
              //   updatedUnitCost.bsp = data?.unitcost?.bsp;
              //   updatedUnitCost.sdr = data?.unitcost?.sdr;
              //   updatedUnitCost.gst = data?.unitcost?.gst;
              //   updatedUnitCost.total = data?.unitcost?.total;
              // }
              // } else {
              //   updatedUnitCost.bsp = data?.unitcost?.bsp;
              //   updatedUnitCost.sdr = data?.unitcost?.sdr;
              //   updatedUnitCost.gst = data?.unitcost?.gst;
              //   updatedUnitCost.total = data?.unitcost?.total;
              // }
            } else {
              // if (data?.eventid !== null && data?.eventtokenid !== null && data?.launchid !== null) {
              //   const preselectConfirmationData =
              //     await getPreselectConfirmationsConfig(
              //       data?.eventid,
              //       data?.eventtokenid,
              //       data?.launchid
              //     );
              //   if (preselectConfirmationData?.data?.length > 0) {
              const sdrCharges = ((Number(data?.unitcost?.bsp) > 3000000 ? (Math.ceil(Number(data?.registration_charges / 100)) * 100) : (Math.ceil(Number(data?.unitcost?.bsp / 100) / 100) * 100)) + data?.legal_charges)

              const { totalDiscount, priceDiscountIds } = await getDiscountAmountTotal(data?.allotmentpaymentid)
              allotmentPriceDiscountIds = priceDiscountIds;
              total =
                data?.unitcost?.total - totalDiscount;

              // total =
              //   data?.unitcost?.total - ((data?.projectname === "PALLADIO KHARADI CENTRAL PH-2" && data?.wingname === "BUILDING-E3") ? data?.pricediscountamount : preselectConfirmationData?.data[0]?.priceDiscount);

              bsp = (total - sdrCharges) / ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 1.11 : (1 + Number(data?.unitcost?.gst / data?.unitcost?.bsp) + (Number(data.sdrpercentage) / 100)));
              // round up bsp to nearest 100
              // bsp = Math.ceil(Math.round(bsp/100)*100);
              gst = bsp * Number(data?.unitcost?.gst / data?.unitcost?.bsp);
              // sdr = (Math.ceil((Math.round((bsp * ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(data.sdrpercentage) / 100))) / 100)) / 100) * 100) + sdrCharges;
              sdr = (Math.ceil(Math.round(bsp * ((data?.projectname === "YASHONE ETERNITEE PH-2" || data?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(data.sdrpercentage) / 100))) / 100) * 100) + sdrCharges;
              let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);
              updatedUnitCost.bsp = Math.round(bsp);
              updatedUnitCost.sdr = Math.round(sdr);
              updatedUnitCost.gst = Math.round(gst);
              updatedUnitCost.total = Math.round(newTotal);
              //   } else {
              //     updatedUnitCost.bsp = data?.unitcost?.bsp;
              //     updatedUnitCost.sdr = data?.unitcost?.sdr;
              //     updatedUnitCost.gst = data?.unitcost?.gst;
              //     updatedUnitCost.total = data?.unitcost?.total;
              //   }
              // } else {
              //   updatedUnitCost.bsp = data?.unitcost?.bsp;
              //   updatedUnitCost.sdr = data?.unitcost?.sdr;
              //   updatedUnitCost.gst = data?.unitcost?.gst;
              //   updatedUnitCost.total = data?.unitcost?.total;
              // }
            }
          }
          presentLoader();
          const obj = {
            crmStatusId: 0,
            crmUserId:
              crmUsers[crmUsers.findIndex((el) => el.label === crmUser)].userId,
            requestPendingWith:
              crmUsers[crmUsers.findIndex((el) => el.label === crmUser)].userId,
            allotmentPaymentId: selectedAllotmentItem,
            oldUnitCost:
              (data?.isdiscounteligible && !data?.isdiscountapplied) ? updatedUnitCost : allAllotments[
                allAllotments.findIndex(
                  (each) => each.allotmentpaymentid === selectedAllotmentItem
                )
              ].unitcost,
            oldPaymentPlan:
              allAllotments[
                allAllotments.findIndex(
                  (each) => each.allotmentpaymentid === selectedAllotmentItem
                )
              ].paymentplan,
          };
          if (!isErrorOccurs) {
            const payloadObj = {
              unitCost: (data?.isdiscounteligible && !data?.isdiscountapplied) ? updatedUnitCost : allAllotments[
                allAllotments.findIndex(
                  (each) => each.allotmentpaymentid === selectedAllotmentItem
                )
              ].unitcost,
              isDiscountApplied: allotmentPriceDiscountIds.length > 0 ? true : false
            }
            insertToCRMTable(obj).then(async (res) => {
              // console.log("Res", res);
              const crmUserName = crmUsers[crmUsers.findIndex((el) => el.label === crmUser)].name;
              const crmObj = {
                message: `Allotment unit ${data?.unitno} of Project ${data?.projectname} is tagged to ${crmUserName} by ${loggedInUser?.name}`,
                allotmentPaymentId: res?.[0]?.allotmentPaymentId,
                crmStatus: "CRM tagged"
              }
              insertCRMLogs(crmObj).then((res) => {
                console.log("Logs saved", res);
              }).catch((err) => {
                console.log(err);
              })
            }).catch((err) => {
              console.log(err);
            })
            const insertToAllotmentPaymentResponse =
              await updateUnitCostAllotmentPaymentById(
                data?.isdiscounteligible
                  ? payloadObj
                  : { unitCost: data?.unitcost },
                data?.allotmentpaymentid
              );

            if (insertToAllotmentPaymentResponse?.data) {
              if (allotmentPriceDiscountIds.length > 0) {
                await updateAllotmentPriceDiscount(allotmentPriceDiscountIds);
              }
              let bucketingObj = {
                allotmentPaymentId:
                  data?.allotmentpaymentid,
              };
              await bucketingForChangeUnit(bucketingObj)
            }
          }
        }
        if (!isErrorOccurs) {
          successTost("Assign crm successfully.");

          setCrmUser("");
          setShowDropDown(false);
          setOpenAlertBox(false);
          setQueryPage(0);
          setCurrentPage(0);
          getFilterAllotment();
          setSelectedAllotments([]);
          setAssignSubmitModalToggle(false);
          dismissLoader();
        }
      } catch (error) {
        isErrorOccurs = true;
        if (error?.message) {
          if (
            error?.message.includes(
              "duplicate key value violates unique constraint"
            )
          ) {
            errorTost("CRM user already assigned!");
          } else {
            errorTost(error?.message);
          }
        } else {
          errorTost("Something went wrong! Try again");
        }
        setCrmUser("");
        setShowDropDown(false);
        setOpenAlertBox(false);
        setQueryPage(0);
        setCurrentPage(0);
        getFilterAllotment();
        setSelectedAllotments([]);
        setAssignSubmitModalToggle(false);
        setSelectedSingleCrmAssign(null);
        dismissLoader();
      }
    } else {
      setCrmUser("");
      setSelectedSingleCrmAssign(null);
    }
  }
  useEffect(() => {
    if (tabs?.find((e) => e?.isSelected === true)?.value === "Event") {
    } else if (
      tabs?.find((e) => e?.isSelected === true)?.value ===
      "Cancellation Requests"
    ) {
      getSubfilters("None", 0);
      setSearchCancelUnit("");
      // if (allCancelUnits?.length > 0) {
      // document.getElementById("input-with-icon-textfield cancelAlotLeadName").value = "";
      // }
      // setCancellationsSubTabs((pre)=>{
      //   pre[0].isSelected=true;
      //   return [...pre];
      // });
      getAllCancelUnit(false, true);
    } else if (
      tabs?.find((e) => e?.isSelected === true)?.value === "Change Requests"
    ) {
      setListsOrder([
        "Name Ascending",
        "Name Descending",
        "Oldest First",
        "Latest First",
      ]);

      setSearchChangeUnit("");
      document.getElementById(
        "input-with-icon-textfield changeAlotLeadName"
      ).value = "";
      getAllChangeUnit(false);
    } else if (tabs?.find((e) => e?.isSelected === true)?.value === "Conflicts") {
      setListsOrder([
        "Name Ascending",
        "Name Descending",
        "Oldest First",
        "Latest First",
      ]);
      getPANConflictsData();
    }
  }, [tabs, cancellationsSubTabs, changeUnitSubTabs]);

  function openModal(row) {
    setCurrentAllotment(row);
    setOpenPaymentModal(true);
  }

  function assignCrmSubmit(_allotment) {
    // CRM2 M2-F7: never hand-assign a CRM 2.0 booking
    const crm2Picked = _allotment ? crm2Ids.has(_allotment) : (selectedAllotments || []).some((s) => crm2Ids.has(s));
    if (crm2Picked) {
      console.warn("[crm2][AllAllotments] Assign CRM refused for a CRM 2.0 booking", { allotment: _allotment || selectedAllotments });
      errorTost("CRM 2.0 bookings get their CRM automatically (or are claimed in CRM 2.0 › Unclaimed). Remove them from the selection.");
      setSelectedSingleCrmAssign(null);
      return;
    }
    if (_allotment) {
      //todo For single select from 3 dots
      let _aa = allAllotments?.find(
        (f) => _allotment === f?.allotmentpaymentid
      );
      if (!Boolean(_aa.mergedpaymentplan?.Id || _aa.wingpaymentplan?.Id)) {
        errorTost("Please select default payment plan first.");
        setSelectedSingleCrmAssign(null);
        return;
      }
      setAssignSubmitModalToggle(true);
    } else {
      //todo For Array
      let allClearFlag = true;
      allAllotments
        ?.filter((f) =>
          selectedAllotments?.some((s) => s === f?.allotmentpaymentid)
        )
        .forEach((allotmentElement) => {
          if (
            !Boolean(
              allotmentElement.mergedpaymentplan?.Id ||
              allotmentElement.wingpaymentplan?.Id
            )
          ) {
            allClearFlag = false;
          }
        });

      if (!allClearFlag) {
        errorTost("Please select default payment plan first.");
        return;
      }

      if (selectedAllotments.length > 0) {
        setAssignSubmitModalToggle(true);
      } else {
        errorTost("Please select allotments.");
      }
    }
  }

  // Mirrors the discount/unit-cost recompute inside ModalResp (Assign CRM), kept
  // isolated so the existing Assign CRM flow is left untouched. If ModalResp's
  // pricing logic changes, keep this in sync.
  async function computeUpdatedUnitCostForClaim(data) {
    const updatedUnitCost = {
      bsp: 0,
      gst: 0,
      sdr: 0,
      total: 0,
    };
    let allotmentPriceDiscountIds = [];
    if (data?.isdiscounteligible && !data?.isdiscountapplied) {
      let total = 0;
      let bsp = 0;
      let gst = 0;
      let sdr = 0;
      if (data?.pricingtype === "sustenance") {
        const { totalDiscount, priceDiscountIds } = await getDiscountAmountTotal(
          data?.allotmentpaymentid
        );
        allotmentPriceDiscountIds = priceDiscountIds;
        total = data?.unitcost?.total - totalDiscount;
        bsp =
          (total - 45000) /
          (data?.projectname === "YASHONE ETERNITEE PH-2" ||
          data?.mergedproject === "YASHONE ETERNITEE PH-2"
            ? 1.11
            : 1 +
              Number(data?.unitcost?.gst / data?.unitcost?.bsp) +
              Number(data.sdrpercentage) / 100);
        gst = bsp * Number(data?.unitcost?.gst / data?.unitcost?.bsp);
        sdr =
          Math.ceil(
            (Math.round(
              bsp *
                (data?.projectname === "YASHONE ETERNITEE PH-2" ||
                data?.mergedproject === "YASHONE ETERNITEE PH-2"
                  ? 0.06
                  : Number(data.sdrpercentage) / 100)
            ) /
              100) *
              100
          ) + 45000;
        let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);
        updatedUnitCost.bsp = Math.round(bsp);
        updatedUnitCost.sdr = Math.round(sdr);
        updatedUnitCost.gst = Math.round(gst);
        updatedUnitCost.total = Math.round(newTotal);
      } else {
        const sdrCharges =
          (Number(data?.unitcost?.bsp) > 3000000
            ? Math.ceil(Number(data?.registration_charges / 100)) * 100
            : Math.ceil(Number(data?.unitcost?.bsp / 100) / 100) * 100) +
          data?.legal_charges;
        const { totalDiscount, priceDiscountIds } = await getDiscountAmountTotal(
          data?.allotmentpaymentid
        );
        allotmentPriceDiscountIds = priceDiscountIds;
        total = data?.unitcost?.total - totalDiscount;
        bsp =
          (total - sdrCharges) /
          (data?.projectname === "YASHONE ETERNITEE PH-2" ||
          data?.mergedproject === "YASHONE ETERNITEE PH-2"
            ? 1.11
            : 1 +
              Number(data?.unitcost?.gst / data?.unitcost?.bsp) +
              Number(data.sdrpercentage) / 100);
        gst = bsp * Number(data?.unitcost?.gst / data?.unitcost?.bsp);
        sdr =
          Math.ceil(
            (Math.round(
              bsp *
                (data?.projectname === "YASHONE ETERNITEE PH-2" ||
                data?.mergedproject === "YASHONE ETERNITEE PH-2"
                  ? 0.06
                  : Number(data.sdrpercentage) / 100)
            ) /
              100) *
              100
          ) + sdrCharges;
        let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);
        updatedUnitCost.bsp = Math.round(bsp);
        updatedUnitCost.sdr = Math.round(sdr);
        updatedUnitCost.gst = Math.round(gst);
        updatedUnitCost.total = Math.round(newTotal);
      }
    }
    return { updatedUnitCost, allotmentPriceDiscountIds };
  }

  // Guard against claiming an allotment that already has a CRM row (e.g. claimed
  // by someone else since this list was last refreshed) before opening the
  // "Claim this lead?" confirmation.
  async function handleClaimClick(allotment) {
    try {
      presentLoader();
      const { data: freshAllotmentData } = await getAllotmentById(
        allotment?.allotmentpaymentid
      );
      const freshAllotment = freshAllotmentData?.[0];
      if (
        freshAllotment?.status !== "Payment Complete" ||
        !freshAllotment?.kycFormFilled
      ) {
        dismissLoader();
        showError("This allotment cannot be claimed until payment is complete and KYC is done.");
        return;
      }
      const { data } = await getCrmAllotment(allotment?.allotmentpaymentid);
      dismissLoader();
      if (data?.length > 0) {
        showError("This allotment is already claimed by another CRM user.");
        return;
      }
    } catch (error) {
      dismissLoader();
      showError("Something went wrong! Try again");
      return;
    }
    setSelectedAllotmentToClaim(allotment);
    setOpenClaimAlert(true);
  }

  // New "Claim" flow: a CRM user assigns a completed allotment to themselves AND
  // performs the approve-tag step in one action, so the lead lands directly in the
  // CRM > Change AV tab (skipping the CRM-head Assign CRM + Tag Pending approval).
  async function claimResp(e) {
    if (e !== "confirmed") {
      setSelectedAllotmentToClaim(null);
      setOpenClaimAlert(false);
      return;
    }
    const data = selectedAllotmentToClaim;
    if (!data) {
      return;
    }
    // Same default-payment-plan guard as assignCrmSubmit
    if (!Boolean(data?.mergedpaymentplan?.Id || data?.wingpaymentplan?.Id)) {
      errorTost("Please select default payment plan first.");
      setSelectedAllotmentToClaim(null);
      setOpenClaimAlert(false);
      return;
    }
    try {
      presentLoader();

      // 1) Recompute discounted unit cost (parity with Assign CRM / ModalResp)
      const { updatedUnitCost, allotmentPriceDiscountIds } =
        await computeUpdatedUnitCostForClaim(data);

      // 2) Insert CRM row tagged to SELF (crmStatusId 0 = Tag Pending); capture new row id
      const obj = {
        crmStatusId: 0,
        crmUserId: loggedInUser?.id,
        requestPendingWith: loggedInUser?.id,
        allotmentPaymentId: data?.allotmentpaymentid,
        oldUnitCost:
          data?.isdiscounteligible && !data?.isdiscountapplied
            ? updatedUnitCost
            : data?.unitcost,
        oldPaymentPlan: data?.paymentplan,
      };
      const insertRes = await insertToCRMTable(obj);
      const newCrmRowId = insertRes?.[0]?.id;
      if (!newCrmRowId) {
        throw new Error("Something went wrong! Try again");
      }

      // Mirror ModalResp side-effects: update allotment unit cost + discount flags + bucketing
      const payloadObj = {
        unitCost:
          data?.isdiscounteligible && !data?.isdiscountapplied
            ? updatedUnitCost
            : data?.unitcost,
        isDiscountApplied: allotmentPriceDiscountIds.length > 0 ? true : false,
      };
      const insertToAllotmentPaymentResponse =
        await updateUnitCostAllotmentPaymentById(
          data?.isdiscounteligible ? payloadObj : { unitCost: data?.unitcost },
          data?.allotmentpaymentid
        );
      if (insertToAllotmentPaymentResponse?.data) {
        if (allotmentPriceDiscountIds.length > 0) {
          await updateAllotmentPriceDiscount(allotmentPriceDiscountIds);
        }
        await bucketingForChangeUnit({
          allotmentPaymentId: data?.allotmentpaymentid,
        });
      }

      // 3) Approve tag → isTagApprove:true, crmStatusId:1 (Change AV)
      const approveRes = await approveTagCrmAllotment(newCrmRowId);
      if (!approveRes?.data?.id) {
        throw approveRes;
      }

      // 4) WhatsApp (non-fatal, parity with the Approve Tag button)
      let whatsappToast = "";
      await sendWhatsappMessageOnTagApprove(
        data?.leadname,
        data?.leadcontactnumber,
        data?.projectname,
        loggedInUser?.name,
        loggedInUser?.contactNumber,
        loggedInUser?.email,
        data?.unitno
      )
        .then(() => {
          whatsappToast = "Whatsapp message sent successfully.";
        })
        .catch((err) => {
          console.log("err", err);
          whatsappToast = "Error while sending whatsapp message.";
        });

      // 5) Single consolidated claim log with the new `claimedBy` column.
      // Non-fatal: if the claimedBy column is not yet added in Supabase the insert
      // will error, but the claim itself has already succeeded, so we swallow it.
      try {
        await insertCRMLogs({
          message: `Allotment unit ${data?.unitno} of project ${data?.projectname} claimed by ${loggedInUser?.name}`,
          allotmentPaymentId: data?.allotmentpaymentid,
          crmStatus: "CRM claimed",
          claimedBy: loggedInUser?.id,
        });
      } catch (logErr) {
        console.log("Claim log insert failed", logErr);
      }

      successTost(`Lead claimed successfully. ${whatsappToast}`);
      setSelectedAllotmentToClaim(null);
      setOpenClaimAlert(false);
      setQueryPage(0);
      setCurrentPage(0);
      getFilterAllotment();
      dismissLoader();
    } catch (error) {
      if (error?.message) {
        if (
          error?.message.includes(
            "duplicate key value violates unique constraint"
          )
        ) {
          showError("This allotment is already claimed by another CRM user.");
        } else {
          errorTost(error?.message);
        }
      } else if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      setSelectedAllotmentToClaim(null);
      setOpenClaimAlert(false);
      getFilterAllotment();
      dismissLoader();
    }
  }

  const handleFetchChild = (id) => {
    const fetchEvents = async () => {
      const data = await getWingList(id);
      const finalPayload = [...projectList];
      const index = finalPayload.findIndex((i) => i.id === id);
      finalPayload.splice(index, 1, data[0]);
      setProjectList(finalPayload);
    };
    fetchEvents();
  };

  const handleAllSelect = () => {
    const payload = allAllotments.filter(
      (val) => !val?.crmuserid && !val?.crmusername
    );
    if (selectBtnName === "Select All") {
      setSelectBtnName("Remove All");

      setSelectedAllotments(payload);
    } else {
      setSelectBtnName("Select All");
      setSelectedAllotments([]);
    }
  };

  function mainContent() {
    return (
      <div className={cssClasses.content}>
        {/* <Box display={"flex"} flexDirection={"column"} gap={"rem"}>
          <Typography className={cssClasses.headerTittle}>{allAllotments.length} Allotments</Typography>
        </Box> */}
        <div className={cssClasses.actionWrapper}>
          <div style={{ fontSize: "2rem" }}>
            <p>{count} Allotments</p>
          </div>

          <ClickAwayListener
            onClickAway={() => {
              setFilterOpen(false);
            }}
          >
            <div className={cssClasses.filtersort}>
              <div className={cssClasses.filterWrapper}>
                <div>
                  <div className={cssClasses.label}>
                    <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>
                      Filter by
                    </p>
                  </div>
                  <div
                    className={cssClasses.dropdownWrapper}
                    style={{ minWidth: "120px" }}
                  >
                    <DropDownButton
                      style={{
                        color: "#323232",
                        backgroundColor: "#fff",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                      }}
                      btnTextStyle={{ width: "130px" }}
                      btnName={btnName}
                      // outline={true}
                      clicked={() => handleFilterClose(false)}
                      btnIcon={
                        <ExpandMoreIcon
                          style={{ width: "15px", height: "15px" }}
                        />
                      }
                      iconPosition={"right"}
                    />

                    <div
                      className={cssClasses.filterModalWrapper}
                      style={{ display: filterOpen ? "block" : "none" }}
                    >
                      <div className={cssClasses.filterModalChild}>
                        <div style={{ width: "50%" }}>
                          <List
                            sx={{
                              width: "100%",
                              maxWidth: 360,
                              bgcolor: "background.paper",
                            }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                          >
                            {filterObj.map((item) => {
                              return (
                                <ListItem
                                  style={{ padding: "0" }}
                                  onClick={() => {
                                    getSubfilters(item.value, item.id);
                                  }}
                                >
                                  <ListItemButton>
                                    <ListItemText primary={item.label} />
                                    {filterCheck == item.id ? (
                                      <ListItemIcon
                                        style={{ minWidth: "auto" }}
                                      >
                                        <CheckIcon
                                          fontSize="large"
                                          color="primary"
                                        />
                                      </ListItemIcon>
                                    ) : (
                                      ""
                                    )}
                                  </ListItemButton>
                                </ListItem>
                              );
                            })}
                          </List>
                        </div>

                        <div
                          style={{
                            padding: "0 6px",
                            width: "75%",
                            backgroundColor: "#F9FAFB",
                            borderRadius: "8px",
                            height: "435px",
                            overflowY: "auto",
                            overFlowX: "hidden",
                          }}
                        >
                          {showProjectList ? (
                            <Box mt={1}>
                              {filter === "Projects" && (
                                <div style={{ margin: "5px" }}>
                                  <SearchBar
                                    placeholder={filter}
                                    search={debouncedFetchSearchData1}
                                    id={"tagPendingCrmAllotmentLeadName"}
                                  />
                                </div>
                              )}
                              {projectList?.length === 0 ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    top: "70%",
                                    height: "325px",
                                    fontSize: "1.5rem",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </div>
                              ) : (
                                <TreeviewCheckbox
                                  data={projectList}
                                  selectedCheckboxes={projectSelected}
                                  isChildFetch
                                  handleFetchChildren={(t) => {
                                    handleFetchChild(t);
                                  }}
                                  onSelectCheckbox={setProjectSelected}
                                  onChange={(str) => {
                                    setProjectStr(str);
                                    setChecked((prev) => [
                                      ...prev.filter((item) => {
                                        prev = JSON.parse(item);
                                        return prev.filter !== "Projects";
                                      }),
                                      JSON.stringify({
                                        value: [str],
                                        filter: "Projects",
                                      }),
                                    ]);
                                  }}
                                />
                              )}
                            </Box>
                          ) : (
                            <List
                              sx={{
                                width: "100%",
                                maxWidth: 360,
                                bgcolor: "background.#F9FAFB",
                                overflowY: "auto",
                                overFlowX: "hidden",
                                // height: "250px",
                              }}
                            >
                              {filter === "Date" ? (
                                <div>
                                  <div className={cssClasses.dateDivider}>
                                    <div className={cssClasses.label}>
                                      Start Date
                                    </div>
                                    <DateComponent
                                      value={selectDates[0].value}
                                      minDate={"1 Jan"}
                                      maxDate={new Date()}
                                      onChangeDate={(value) => {
                                        setSelectedDate("notNull");
                                        setSelectDates((pre) => {
                                          pre[0].value = value;
                                          return { ...pre };
                                        });
                                        setHelperText((pre) => {
                                          pre.endDate = "";
                                          return { ...pre };
                                        });
                                      }}
                                      helperText={helperText.startDate}
                                    ></DateComponent>
                                  </div>
                                  <div>
                                    <div className={cssClasses.label}>
                                      End Date
                                    </div>
                                    <DateComponent
                                      value={selectDates[1].value}
                                      isClassName
                                      minDate={"1 Jan"}
                                      onChangeDate={(value) => {
                                        setSelectedDate("notNull");
                                        if (selectDates[0].value === "") {
                                          setHelperText((pre) => {
                                            pre.endDate =
                                              "Please select start date first";
                                            return { ...pre };
                                          });
                                        } else {
                                          if (selectDates[0].value > value) {
                                            setHelperText((pre) => {
                                              pre.endDate =
                                                "Select End Date Greater than start Date";
                                              return { ...pre };
                                            });
                                          } else {
                                            setSelectDates((pre) => {
                                              pre[1].value = value;
                                              return { ...pre };
                                            });
                                            setHelperText((pre) => {
                                              pre.endDate = "";
                                              return { ...pre };
                                            });
                                            let indexOfMainList = findIndex(
                                              filterObj,
                                              ({ label }) => label === "Date"
                                            );
                                            setFilterObj((pre) => {
                                              pre[
                                                indexOfMainList
                                              ].select = true;
                                              return [...pre];
                                            });
                                            if (
                                              selectedListDropDown.find(
                                                (value) => value === "Date"
                                              ) === undefined
                                            ) {
                                              selectedListDropDown.push("Date");
                                            }
                                          }
                                        }
                                      }}
                                      helperText={helperText.endDate}
                                    ></DateComponent>
                                  </div>
                                </div>
                              ) : (
                                ["Users", "CrmUsers", "CP", "Projects"].map(
                                  (fil) => {
                                    return (
                                      <div style={{ margin: "5px" }}>
                                        {fil === filter && (
                                          <SearchBar
                                            placeholder={filter}
                                            search={debouncedFetchSearchData1}
                                            id={
                                              "tagPendingCrmAllotmentLeadName"
                                            }
                                          />
                                        )}
                                      </div>
                                    );
                                  }
                                )
                              )}
                              {filterNames?.length === 0 &&
                                ["Users", "CrmUsers", "CP", "Projects", "Lead Type"].includes(
                                  filter
                                ) ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    top: "70%",
                                    height: "325px",
                                    fontSize: "1.5rem",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data Available
                                </div>
                              ) : (
                                filterNames.map((item) => {
                                  const labelId = `checkbox-list-label-${item.id}`;

                                  return (
                                    <ListItem
                                      key={item.id}
                                      // secondaryAction={
                                      //     <IconButton edge="end" aria-label="comments">
                                      //         <CommentIcon />
                                      //     </IconButton>
                                      // }
                                      disablePadding
                                    >
                                      <ListItemButton
                                        role={undefined}
                                        onClick={handleToggle(
                                          item.id,
                                          item.filter
                                        )}
                                        dense
                                      >
                                        <ListItemIcon
                                          style={{ minWidth: "auto" }}
                                        >
                                          <Checkbox
                                            edge="start"
                                            checked={
                                              checked.indexOf(
                                                JSON.stringify({
                                                  value: item.id,
                                                  filter: item.filter,
                                                })
                                              ) !== -1
                                            }
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                              "aria-labelledby": labelId,
                                            }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText
                                          id={labelId}
                                          primary={item.name}
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  );
                                })
                              )}
                            </List>
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          backgroundColor: "#F9FAFB",
                          padding: "12px",
                          borderBottomLeftRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderTop: "1px solid #EAECF0",
                          justifyContent: "end",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: "100px",
                            float: "right",
                            marginRight: "12px",
                            backgroundColor: "#F9FAFB",
                          }}
                        >
                          <Button
                            style={{
                              width: "100px",
                              color: "#323232",
                              backgroundColor: "#fff",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                              fontFamily: "Inter-Medium !important",

                              // marginLeft: "-12px"
                            }}
                            btnName={"Clear"}
                            // outline={true}
                            clicked={() => handleFilterClose(true)}
                            // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                            iconPosition={"left"}
                          />
                        </div>
                        <div
                          style={{
                            width: "100px",
                          }}
                        >
                          <Button
                            style={{
                              color: "#fff",
                              backgroundColor: "#1570EF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                              fontFamily: "Inter-Medium !important",

                              // marginLeft: "-12px"
                            }}
                            btnName={"Apply"}
                            // outline={true}
                            disable={
                              helperText?.startDate !== "" ||
                              helperText?.endDate !== ""
                            }
                            clicked={handleFilterApply}
                            // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                            iconPosition={"left"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                <div
                  // className={cssClasses.filterWrapper}
                  style={{
                    marginLeft: "8px",
                  }}
                >
                  <div className={cssClasses.label}>
                    <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>
                      Sort by
                    </p>
                  </div>
                  <div className={cssClasses.dropdownWrapper}>
                    <DropDown
                      onChangeSelect={(e) => {
                        filterAllotmentBySort(e);
                      }}
                      selectedValue={filterBy}
                      style={{
                        selectedColor: "#175CD3",
                        background: "#E8F0FE",
                      }}
                      list={listsOrder}
                    />
                  </div>
                </div>
                <div
                  // className={cssClasses.filterWrapper}
                  style={{ marginLeft: "1em" }}
                >
                  <ViewToggleSwitch setMode={setView} />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2rem",
                  flexWrap: "wrap",
                }}
              >
                {
                  // JSON.parse(localStorage.getItem("user")).roleId?.accessibleTabs["All Allotments"]["Crm Users"]?.isAccessible &&
                  (subTabs.find((ele) => ele?.isSelected)?.text ===
                    "Completed" && loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.Completed?.["Assign CRM"]?.isAccessible) && (
                    // subTabs[3].isSelected === true &&
                    <div>
                      {/* {!showDropDown ? (
                    <>
                      <Button
                        style={{
                          color: "#fff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",

                          // marginLeft: "-12px"
                        }}
                        btnName={"Bulk assign crm users"}
                        // outline={true}
                        clicked={() => setShowDropDown(true)}
                        // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                        iconPosition={"left"}
                      />
                    </>
                  ) : (
                    <></>
                    )} */}
                      <Button
                        style={{
                          color: "#fff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",

                          // marginLeft: "-12px"
                        }}
                        btnName={"Assign CRM Submit"}
                        // outline={true}
                        clicked={() => {
                          assignCrmSubmit();
                        }}
                        // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                        iconPosition={"left"}
                      />
                    </div>
                  )
                }
                <div className={cssClasses.searchWrapper}>
                  <SearchBar
                    placeholder={"Search by Lead Name"}
                    search={debounceForSearch}
                    id={"userSearchBar"}
                  />
                </div>
              </div>
            </div>
          </ClickAwayListener>
        </div>
        {/* <div className={cssClasses.gridWrapper}>
          <DataGrid
            rows={allAllotments.map((m, i) => ({ ...m, id: i }))}
            // rows={allAllotments}
            columns={userGridColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={currentPage}
            onPageChange={(e) => {
              pageChanged(e);
            }}
            columnVisibilityModel={{
              // Hide column crmuser, the other columns will remain visible
              crmuser: loggedInUser?.roleId?.accessibleTabs?.['All Allotments']?.['Crm Users'].isAccessible ? true : false,
            }}
            sx={[dataGridStyles]}
          />
        </div> */}
        {allAllotments.length > 0 ? (
          view === "Table View" ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "6px" }}
            >
              {subTabs?.filter(
                (val) => val.value === "Completed" && val?.isSelected
              )?.length > 0 && (
                  <Button
                    btnName={selectBtnName}
                    style={{
                      color: "#fff",
                      backgroundColor: "#006AFF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                      width: "130px",
                    }}
                    clicked={() => {
                      handleAllSelect();
                    }}
                    disable={
                      allAllotments.filter(
                        (val) => !val?.crmuserid && !val?.crmusername
                      )?.length === 0
                    }
                  />
                )}
              <ServerPaginationGrid
                sx={{
                  "& .MuiDataGrid-columnHeaders + div": {
                    height: "calc(100vh - 400px) !important",
                  },
                  "& .MuiTablePagination-root .MuiTablePagination-selectLabel":
                  {
                    fontSize: "1.6rem !important",
                  },
                  "& MuiDataGrid-root .MuiDataGrid-footerContainer .MuiTablePagination-displayedRows":
                  {
                    fontSize: "1.6rem !important",
                  },
                }}
                name="all-allotments"
                columns={userGridColumns}
                rows={allAllotments}
                count={allotmentCount}
                getDataByPage={getFilterAllotmentForDatagrid}
                // getDataByPage={() => []}
                // dependecies={{
                //    filter, checked
                // }}
                depStr={depStr}
              />
            </div>
          ) : (
            <Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
              <Box sx={{ flexGrow: 1 }}>
                <InfiniteScroll
                  dataLength={allAllotments.length}
                  next={() =>
                    setQueryPage((pre) => {
                      return pre + 1;
                    })
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }} //To put endMessage and loader to the top.
                  hasMore={loadingStatus === 0}
                  // loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv"
                >
                  <Grid
                    style={{
                      marginTop: "0rem",
                      marginBottom: "1rem",
                      marginLeft: "0rem",
                      width: "100%",
                    }}
                    container
                    spacing={{ xs: 2, md: 3, lg: 3 }}
                    columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                  >
                    {/* <div id="scrollableDiv"> */}
                    {allotmentCard}
                    {/* </div> */}
                  </Grid>




                </InfiniteScroll>
              </Box>
            </Box>
          )
        ) : (
          <div style={{ height: "100%" }}>
            <p
              style={{
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                fontSize: "3rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={EmptyState} alt="No Data" />
                <span>No Allotment Available</span>
              </div>
            </p>
          </div>
        )}
      </div>
    );
  }

  const filterModal = () => {
    return (
      <div>
        <div className={cssClasses.label}>
          <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Filter by</p>
        </div>
        <ClickAwayListener
          onClickAway={() => {
            setFilterOpen(false);
          }}
        >
          <div
            className={cssClasses.dropdownWrapper}
            style={{ minWidth: "120px" }}
          >
            <DropDownButton
              style={{
                color: "#323232",
                backgroundColor: "#fff",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Inter-Medium !important",
              }}
              btnTextStyle={{ width: "130px" }}
              btnName={btnName}
              // outline={true}
              clicked={() => handleFilterClose(false)}
              btnIcon={
                <ExpandMoreIcon style={{ width: "15px", height: "15px" }} />
              }
              iconPosition={"right"}
            />

            <div
              className={cssClasses.filterModalWrapper}
              style={{ display: filterOpen ? "block" : "none" }}
            >
              <div className={cssClasses.filterModalChild}>
                <div style={{ width: "50%" }}>
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                  >
                    {(tabs.filter((val) => val?.isSelected && val?.text === "Conflicts")
                      ?.length > 0 ? PANFilter : filterObj).map((item) => {
                        return (
                          <ListItem
                            style={{ padding: "0" }}
                            onClick={() => {
                              getSubfilters(item.value, item.id);
                            }}
                          >
                            <ListItemButton>
                              <ListItemText primary={item.label} />

                              {filterCheck == item.id ? (
                                <ListItemIcon style={{ minWidth: "auto" }}>
                                  <CheckIcon fontSize="large" color="primary" />
                                </ListItemIcon>
                              ) : (
                                ""
                              )}
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </div>

                <div
                  style={{
                    padding: "0 6px",
                    width: "75%",
                    backgroundColor: "#F9FAFB",
                    borderRadius: "8px",
                    height: "435px",
                    overflowY: "auto",
                    overFlowX: "hidden",
                  }}
                >
                  {showProjectList ? (
                    <Box mt={1}>
                      {filter === "Projects" && (
                        <div style={{ margin: "5px" }}>
                          <SearchBar
                            placeholder={filter}
                            search={debouncedFetchSearchData1}
                            id={"tagPendingCrmAllotmentLeadName"}
                          />
                        </div>
                      )}
                      {projectList?.length === 0 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            top: "70%",
                            height: "325px",
                            fontSize: "1.5rem",
                            alignItems: "center",
                          }}
                        >
                          No Data Available
                        </div>
                      ) : (
                        <TreeviewCheckbox
                          data={projectList}
                          selectedCheckboxes={projectSelected}
                          isChildFetch
                          handleFetchChildren={(t) => {
                            handleFetchChild(t);
                          }}
                          onSelectCheckbox={setProjectSelected}
                          onChange={(str) => {
                            setProjectStr(str);
                            setChecked((prev) => [
                              ...prev.filter((item) => {
                                prev = JSON.parse(item);
                                return prev.filter !== "Projects";
                              }),
                              JSON.stringify({
                                value: [str],
                                filter: "Projects",
                              }),
                            ]);
                          }}
                        />
                      )}
                    </Box>
                  ) : (
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.#F9FAFB",
                        overflowY: "auto",
                        overFlowX: "hidden",
                        // height: "250px",
                      }}
                    >
                      {filter === "Date" ? (
                        <div>
                          <div className={cssClasses.dateDivider}>
                            <div className={cssClasses.label}>Start Date</div>
                            <DateComponent
                              value={selectDates[0].value}
                              minDate={"1 Jan"}
                              maxDate={new Date()}
                              onChangeDate={(value) => {
                                setSelectedDate("notNull");
                                setSelectDates((pre) => {
                                  pre[0].value = value;
                                  return { ...pre };
                                });
                                setHelperText((pre) => {
                                  pre.endDate = "";
                                  return { ...pre };
                                });
                              }}
                              helperText={helperText.startDate}
                            ></DateComponent>
                          </div>
                          <div>
                            <div className={cssClasses.label}>End Date</div>
                            <DateComponent
                              value={selectDates[1].value}
                              isClassName
                              minDate={"1 Jan"}
                              onChangeDate={(value) => {
                                setSelectedDate("notNull");
                                if (selectDates[0].value === "") {
                                  setHelperText((pre) => {
                                    pre.endDate =
                                      "Please select start date first";
                                    return { ...pre };
                                  });
                                } else {
                                  if (selectDates[0].value > value) {
                                    setHelperText((pre) => {
                                      pre.endDate =
                                        "Select End Date Greater than start Date";
                                      return { ...pre };
                                    });
                                  } else {
                                    setSelectDates((pre) => {
                                      pre[1].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = "";
                                      return { ...pre };
                                    });
                                    let indexOfMainList = findIndex(
                                      tabs.filter((val) => val?.isSelected && val?.text === "Conflicts")
                                        ?.length > 0 ? PANFilter : filterObj,
                                      ({ label }) => label === "Date"
                                    );
                                    setFilterObj((pre) => {
                                      pre[indexOfMainList].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Date"
                                      ) === undefined
                                    ) {
                                      selectedListDropDown.push("Date");
                                    }
                                  }
                                }
                              }}
                              helperText={helperText.endDate}
                            ></DateComponent>
                          </div>
                        </div>
                      ) : (
                        [
                          "Users",
                          "CrmUsers",
                          "CP",
                          "Projects",
                          "Pending With",
                        ].map((fil) => {
                          return (
                            <div style={{ margin: "5px" }}>
                              {fil === filter && (
                                <SearchBar
                                  placeholder={filter}
                                  search={debouncedFetchSearchData1}
                                  id={"tagPendingCrmAllotmentLeadName"}
                                />
                              )}
                            </div>
                          );
                        })
                      )}
                      {filterNames?.length === 0 &&
                        ["Users", "CrmUsers", "CP", "Projects", "Lead Type"].includes(
                          filter
                        ) ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            top: "70%",
                            height: "325px",
                            fontSize: "1.5rem",
                            alignItems: "center",
                          }}
                        >
                          No Data Available
                        </div>
                      ) : (
                        filterNames.map((item) => {
                          const labelId = `checkbox-list-label-${item.id}`;

                          return (
                            <ListItem
                              key={item.id}
                              // secondaryAction={
                              //     <IconButton edge="end" aria-label="comments">
                              //         <CommentIcon />
                              //     </IconButton>
                              // }
                              disablePadding
                            >
                              <ListItemButton
                                role={undefined}
                                onClick={handleToggle(item.id, item.filter)}
                                dense
                              >
                                <ListItemIcon style={{ minWidth: "auto" }}>
                                  <Checkbox
                                    edge="start"
                                    checked={
                                      checked.indexOf(
                                        JSON.stringify({
                                          value: item.id,
                                          filter: item.filter,
                                        })
                                      ) !== -1
                                    }
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  id={labelId}
                                  primary={item.name}
                                />
                              </ListItemButton>
                            </ListItem>
                          );
                        })
                      )}
                    </List>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  backgroundColor: "#F9FAFB",
                  padding: "12px",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                  borderTop: "1px solid #EAECF0",
                  justifyContent: "end",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100px",
                    float: "right",
                    marginRight: "12px",
                    backgroundColor: "#F9FAFB",
                  }}
                >
                  <Button
                    style={{
                      width: "100px",
                      color: "#323232",
                      backgroundColor: "#fff",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",

                      // marginLeft: "-12px"
                    }}
                    btnName={"Clear"}
                    // outline={true}
                    clicked={() => handleFilterClose(true)}
                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                    iconPosition={"left"}
                  />
                </div>
                <div
                  style={{
                    width: "100px",
                  }}
                >
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",

                      // marginLeft: "-12px"
                    }}
                    btnName={"Apply"}
                    // outline={true}
                    disable={
                      helperText?.startDate !== "" || helperText?.endDate !== ""
                    }
                    clicked={handleFilterApply}
                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                    iconPosition={"left"}
                  />
                </div>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    );
  };
  async function getRefundAmount(value, id, allotmentpaymentid) {
    if (value) {
      await getRefundedAmount(allotmentpaymentid).then((resp) => {
        const totalAmount = resp.data.reduce((total, item) => {
          return total + (item.amount != null ? item.amount : 0);
        }, 0);

        setRefundDetails((prevState) => ({
          ...prevState,
          [id]: totalAmount,
        }));

      }).catch(() => {
        setRefundDetails((prevState) => ({
          ...prevState,
          [id]: 0,
        }));

      })
      setShowDetails((prevState) => ({
        ...prevState,
        [id]: !prevState[id],
      }));
    } else {
      setShowDetails((prevState) => ({
        ...prevState,
        [id]: !prevState[id],
      }));
    }
  }

  function cancelledAllotment() {
    return (
      <div className={cssClasses.content}>
        <>
          <Box>
            <TabContext
              value={
                cancellationsSubTabs
                  ?.filter((val) => val !== null)
                  .find((f) => f?.isSelected)?.value
              }
            >
              <TabsMenu
                selectedColor={"#1570EF"}
                selectedBackgroundColor={"#FFFFFF"}
                stylesForTab={{
                  color: "#344054",
                  fontSize: "1.6rem",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "2.4rem",
                  padding: "0.8rem 1.2rem",
                  textTransform: "unset",
                  borderBottom: "1px solid #EAECF0",
                }}
                borderColor={"#1570EFs"}
                stylesForWrapper={{
                  padding: "1.5rem 0",
                  background: "#FFFFFF",
                }}
                list={cancellationsSubTabs?.filter((val) => val !== null)}
                value={
                  cancellationsSubTabs
                    ?.filter((val) => val !== null)
                    .find((f) => f?.isSelected)?.value
                }
                handleChange={(e, value) => {
                  sessionStorage.setItem("tab", null)
                  handleFilterClose(true)
                  setCancellationsSubTabs((pre) => {
                    pre.forEach((ele) => {
                      if (ele.value === value) {
                        ele.isSelected = true;
                      } else {
                        ele.isSelected = false;
                      }
                    });
                    return [...pre];
                  });
                  setRefundDetails({});
                  setShowDetails({});
                }}
              >
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Cancellation"}
                  index={0}
                ></TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Pending"}
                  index={1}
                ></TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Done"}
                  index={2}
                ></TabPanel>
              </TabsMenu>
            </TabContext>
          </Box>
          <div
            className={cssClasses.actionWrapper}
            style={{ marginBottom: "0rem" }}
          >
            <Typography className={cssClasses.headerTittle}>
              {cancellationsSubTabs?.filter((v) => v !== null).find((f) => f?.isSelected)?.value === "Deemed" ? (
                <>{deemedRemindingCount} Legal Notice Sent</>
              ) : (
                <>
                  {allCancelUnitsCount}{" "}
                  {cancellationsSubTabs
                    ?.filter((val) => val !== null)
                    .filter((val) => val.isSelected && val.value === "Pending")
                    ?.length > 0
                    ? "Request Pending"
                    : cancellationsSubTabs
                      ?.filter((val) => val !== null)
                      .filter((val) => val.isSelected && val.value === "Done")
                      ?.length > 0
                      ? "Request Done"
                      : "Cancel Request"}
                </>
              )}
              {/* {allCancelUnits.length} Cancel Request */}
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "1rem",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                {filterModal()}
                <div
                  style={{
                    marginLeft: "8px",
                  }}
                >
                  <div className={cssClasses.label}>
                    <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>
                      Sort by
                    </p>
                  </div>
                  <div className={cssClasses.dropdownWrapper}>
                    <DropDown
                      onChangeSelect={(e) => {
                        filterAllotmentBySort(e);
                      }}
                      selectedValue={filterBy}
                      style={{
                        selectedColor: "#175CD3",
                        background: "#E8F0FE",
                      }}
                      list={listsOrder}
                    />
                  </div>
                </div>
              </div>
              <div className={cssClasses.searchWrapper}>
                <SearchBar
                  placeholder={"Search by Lead Name"}
                  search={debouncedFetchSearchData}
                  id={"cancelAlotLeadName"}
                />
              </div>
            </div>
          </div>
        </>
        <div className={cssClasses.gridWrapper}>
          {/* hello */}
          {/* <DataGrid
            rows={allCancelUnits}
            columns={cancelUnitColumn}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={currentPageCancellation}
            onPageChange={(e) => {
              pageChangedCancellation(e);
            }}
            sx={[dataGridStyles]}
          /> */}
          {allCancelUnits?.length > 0 ? (
            <Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
              <Box sx={{ flexGrow: 1 }}>
                <InfiniteScroll
                  dataLength={allCancelUnits.length}
                  next={() =>
                    setQueryPage((pre) => {
                      return pre + 1;
                    })
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }} //To put endMessage and loader to the top.
                  hasMore={loadingStatus === 0}
                  // loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv"
                >
                  {cancellationsSubTabs?.filter((v) => v !== null).find((f) => f?.isSelected)?.value === "Deemed" && <DeemedTab onCountChange={setDeemedRemindingCount} />}
                  <Grid
                    style={{
                      marginTop: "1rem",
                      marginBottom: "1rem",
                      marginLeft: "1rem",
                      marginRight: "1rem",
                      gap: "2rem",
                      width: "calc(100% - 2rem)",
                    }}
                    container
                    spacing={{ xs: 2, md: 3, lg: 3 }}
                    columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                  >
                    {cancellationsSubTabs?.filter((v) => v !== null).find((f) => f?.isSelected)?.value !== "Deemed" &&
                      allCancelUnits?.length > 0 &&
                      allCancelUnits?.map((request, index) => (
                        <Card className={cssClasses.eventWrap} key={index}>
                          <div className={cssClasses.cardHeader}>
                            <div className={cssClasses.tokenNumWrap}>
                              {request?.unitno && (
                                <span>
                                  {
                                    // request?.allotmentPaymentId?.unitId?.wingId
                                    //   ?.wingName
                                    request?.allotmentPaymentId?.unitId?.wingId
                                      ?.displayName ? request?.allotmentPaymentId?.unitId?.wingId
                                      ?.displayName : request?.wingname
                                  }{" "}
                                  -{" "}
                                  {request?.unitno}{" "}
                                </span>
                              )}
                              {request?.inventorymergedid &&
                                ((request?.mergedwingid && (
                                  <span>
                                    {
                                      // request?.allotmentPaymentId
                                      //   ?.inventoryMergedId.unit1Id.wingId
                                      //   .wingName
                                      request?.allotmentPaymentId
                                        ?.inventoryMergedId.unit1Id.wingId
                                        .displayName ? request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit1Id.wingId
                                        .displayName : request?.mergedwingname
                                    }{" "}
                                    -{" "}
                                    {
                                      request?.unit1no
                                    }{" "}
                                    &{" "}
                                    {
                                      request?.unit2no
                                    }{" "}
                                  </span>
                                )) ||
                                  (request?.mergedwingid && (
                                    <span>
                                      {
                                        // request?.allotmentPaymentId
                                        //   ?.inventoryMergedId.unit1Id.wingId
                                        //   .wingName
                                        request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit1Id.wingId
                                          .displayName ? request?.allotmentPaymentId
                                            ?.inventoryMergedId.unit1Id.wingId
                                          .displayName : request?.mergedwingname
                                      }{" "}
                                      -{" "}
                                      {
                                        request?.unit1no
                                      }{" "}
                                      &{" "}
                                      {
                                        // request?.allotmentPaymentId
                                        //   ?.inventoryMergedId.unit2Id.wingId
                                        //   .wingName
                                        request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit2Id.wingId
                                          .displayName ? request?.allotmentPaymentId
                                            ?.inventoryMergedId.unit2Id.wingId
                                          .displayName : request?.mergedwingname
                                      }{" "}
                                      -{" "}
                                      {
                                        request?.unit2no
                                      }{" "}
                                    </span>
                                  )))}
                              <span>|</span>
                              {request?.projectname && (
                                <span>{request?.projectname}</span>
                              )}
                              {request?.inventorymergedid && (
                                <span>
                                  {
                                    request?.mergedproject
                                  }
                                </span>
                              )}
                              <div>
                                <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} style={{ color: "#B42318", backgroundColor: "#FEF3F2" }} label={request?.allotmentstatus} />
                              </div>
                              {request?.allotmentstatus === "Cancelled" && <div>
                                <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} style={{ color: "#FF4405", backgroundColor: "#FFE6D5" }} label="Refund Hold" />
                              </div>}
                              {request?.iswaivedoff && <div>
                                <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }} label="Cancellation Charges Waived " />
                              </div>}
                            </div>
                            {request?.cancelledinfarvision &&
                              <LeadStatusChip icon={<Dot width={"0.5rem"} height={"0.5rem"} />} style={{ color: "#B42318", backgroundColor: "#FEF3F2" }} label={"Cancelled In Farvision"} />
                            }
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              // width: "100%",
                              alignItems: "center",
                            }}
                          >
                            <div className={cssClasses.tokenStatus}>
                              <LeadStatusChip
                                label={
                                  // request?.allotmentPaymentId?.status==='Cancellation Pending'|| request?.allotmentPaymentId?.status==='Cancellation Requested'?
                                  request.leadconfirmation === "Pending"
                                    ? request.status + " by lead " + request.leadname
                                    : request.leadconfirmation === "Accepted"
                                      ? request.status === "Pending" && loggedInUser.roleId.level === 1 && request.requestpendingwithuserid && request.requestpendingwithroleid
                                        ? request.status + " with " + request.requestpendingwithusername + "(" + request.requestpendingwithroletitle + ")"
                                        : request?.requestpendingwithuserid !== null
                                          ? loggedInUser.roleId.level === 1 && request.requestpendingwithuserid && request.requestpendingwithroleid && request.status === 'Accepted' ?
                                            'Pending with ' + request.requestpendingwithusername + "(" + request.requestpendingwithroletitle + ")"
                                            : request.status === 'Accepted' ?
                                              "Pending" :
                                              request.status === 'Rejected' ?
                                                'Request Rejected by ' + request.requestpendingwithusername + "(" + request.requestpendingwithroletitle + ")"
                                                : request.status
                                          : request.status
                                      : `Request Rejected by ${request?.leadname}`
                                }
                                icon={
                                  <Dot width={"0.5rem"} height={"0.5rem"} />
                                }
                                style={
                                  request.status === "Pending"
                                    ? {
                                      color: "#B42318",
                                      backgroundColor: "#FEF3F2",
                                    }
                                    : request?.requestpendingwithuserid !== null
                                      ? {
                                        color: "#B42318",
                                        backgroundColor: "#FEF3F2",
                                      }
                                      : {
                                        color: "#027A48",
                                        backgroundColor: "#ECFDF3",
                                      }
                                }
                              ></LeadStatusChip>
                            </div>
                            <div className={cssClasses.tokenLastUpdate}>
                              <ReactTimeAgo
                                style={{ fontSize: "1.2rem" }}
                                date={
                                  request?.last_updated_at
                                    ? request?.last_updated_at
                                    : request?.created_at
                                }
                                locale="en-US"
                              />
                            </div>
                            <div className={cssClasses.tokenActions}>
                              {/* {!request.cancellationListMenu.includes('No actions available!') && */}
                              {console.log('cancellationsSubTabs', cancellationsSubTabs,request)}
                              <ThreeDotsMenu
                                list={
                                  cancellationsSubTabs
                                    ?.filter((val) => val !== null)
                                    .filter(
                                      (val) =>
                                        val.isSelected &&
                                        val.value === "Cancellation"
                                    )?.length !== 0
                                    ? request.cancellationListMenu?.filter(
                                      (val) => val !== "Reprice Unit"
                                    )?.length === 0
                                      ? ["No Actions Available"]
                                      : request.cancellationListMenu?.filter(
                                        (val) => val !== "Reprice Unit"
                                      )
                                    : request.cancellationListMenu?.length === 0
                                      ? ["No Actions Available"]
                                      : request.cancellationListMenu
                                }
                                selectedValue={async (e) => {
                                  // Options
                                  setSelectedCancelUnit(request);
                                  if (e === "Accept") {
                                    if (
                                      loggedInUser.parentId === null ||
                                      loggedInUser.parentId.parentId === null
                                    ) {
                                      const id = request?.allotmentpaymentid
                                      if (id) {
                                        await fetchSelectedParkingNumbers(id).then((res) => {
                                          if (res?.data) {
                                            setSelectedParking(res?.data);
                                            setOpenCancelUnitConfirmationModal(true);
                                          }
                                        }).catch((err) => {
                                          console.log(err);
                                        })
                                      }
                                    } else {
                                      let requestPending = {
                                        // userId:request.userId.parentId.userId,
                                        roleId: loggedInUser.parentId.parentId
                                          ? loggedInUser.parentId.roleId
                                          : loggedInUser.roleId.roleId,
                                        parentId: loggedInUser.parentId.parentId
                                          ? loggedInUser.parentId.userId
                                          : loggedInUser.userId,
                                      };
                                      let obj = {
                                        bsp: request?.unitcost?.bsp,
                                        sdr: request?.unitcost?.sdr,
                                        gst: request?.unitcost?.gst,
                                        total: request?.unitcos?.total
                                      }
                                      updateCancelRequests(
                                        request.cancelunitrequestid,
                                        `Pending`,
                                        requestPending,
                                        obj
                                      ).then((resp) => {
                                        updateLeadAllStatus(
                                          request?.leadid,
                                          `Cancellation Confirmation Pending by ${loggedInUser.parentId.name}`
                                        ).then((updateLeadStatus) => {
                                          let obj = {
                                            leadId: request?.leadid,
                                            leadStatus: `Cancellation Confirmation Pending by ${loggedInUser.parentId.name}`,
                                            message: `Cancellation Confirmation Pending by ${loggedInUser.parentId.name}.Cancellation accepted by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                                          };
                                          addLeadLogs(obj)
                                            .then((leadLog) => {
                                              // let obj = {
                                              //   action: `A cancellation request has been approved for Unit ${request?.allotmentPaymentId.unitId.unitNo} in Wing ${request?.allotmentPaymentId.unitId.wingId.wingName} of the PKC project ${request?.allotmentPaymentId?.unitId?.projectId?.projectName} by VJ SM ${loggedInUser.name}(${loggedInUser?.roleId?.title}) for ${request?.allotmentPaymentId?.leadId?.personId?.name}`,
                                              //   cpId: request
                                              //     ?.allotmentPaymentId?.leadId
                                              //     ?.cpId?.cpId,
                                              //   leadId:
                                              //     request?.allotmentPaymentId
                                              //       ?.leadId?.leadId,
                                              //   userId: loggedInUser?.userId,
                                              //   fosId:
                                              //     request?.allotmentPaymentId
                                              //       ?.leadId?.fosId,
                                              //   allotmentPaymentId:
                                              //     request?.allotmentPaymentId
                                              //       ?.allotmentPaymentId,
                                              // };
                                              // if (
                                              //   request?.allotmentPaymentId
                                              //     ?.leadId?.cpId !== null
                                              // ) {
                                              //   addLeadNotification(obj)
                                              //     .then(
                                              //       (leadNotificationRes) => {
                                              //       }
                                              //     )
                                              //     .catch((error) => {
                                              //       console.log(error);
                                              //     });
                                              // }
                                              setSearchCancelUnit("");
                                              document.getElementById(
                                                "input-with-icon-textfield cancelAlotLeadName"
                                              ).value = "";
                                              getAllCancelUnit(false);
                                            })
                                            .catch((err) => {
                                              console.log("leadlog", err);
                                            });
                                        });
                                      });
                                    }
                                  } else if (e === "Reject") {
                                    let requestReject = {
                                      userId: loggedInUser.userId,
                                      roleId: loggedInUser.roleId.roleId,
                                      //parentId: loggedInUser.parentId,
                                    };
                                    let obj = {
                                      bsp: request?.unitcost?.bsp,
                                      sdr: request?.unitcost?.sdr,
                                      gst: request?.unitcost?.gst,
                                      total: request?.unitcost?.total
                                    }
                                    let leadStatusResp
                                    if (request?.oldleadstatus === null) {
                                      leadStatusResp = await supabase.rpc("getoldleadstatus", { "leadid": request?.leadid })
                                    }
                                    updateCancelRequestsForRejection(
                                      request.cancelunitrequestid,
                                      "Rejected",
                                      obj,
                                      requestReject
                                    )
                                      .then((resp) => {
                                        updateLeadAllStatus(
                                          request.leadid,
                                          request.oldleadstatus !== null ? request?.oldleadstatus : leadStatusResp?.data[0]?.leadstatus
                                        )
                                          .then((updateLeadStatus) => {
                                            let obj = {
                                              leadId:
                                                request.leadid,
                                              leadStatus: request.oldleadstatus !== null ? request?.oldleadstatus : leadStatusResp?.data[0]?.leadstatus,
                                              message: `Cancellation Reject by ${loggedInUser?.name}(${loggedInUser?.roleId?.title}) `,
                                            };
                                            addLeadLogs(obj)
                                              .then((leadLog) => {
                                                let obj = {
                                                  action: `A cancellation request has been rejected for Unit ${request?.unitno} in wing ${request?.wingname} of  ${request?.projectname} by VJ SM ${loggedInUser.name}(${loggedInUser?.roleId?.title}) for ${request?.allotmentPaymentId?.leadname}`,
                                                  cpId: request?.cpid,
                                                  leadId: request?.leadid,
                                                  userId: loggedInUser?.userId,
                                                  allotmentPaymentId:
                                                    request?.allotmentpaymentid,
                                                  eventId: request?.eventid,
                                                };
                                                if (request?.cpid !== null) {
                                                  addLeadNotificationForCp(obj)
                                                    .then(
                                                      (leadNotificationRes) => {
                                                        console.log({
                                                          leadNotificationRes,
                                                        });
                                                      }
                                                    )
                                                    .catch((error) => {
                                                      console.log(error);
                                                    });
                                                }
                                                setSearchCancelUnit("");
                                                document.getElementById(
                                                  "input-with-icon-textfield cancelAlotLeadName"
                                                ).value = "";
                                                getAllCancelUnit(false);
                                              })
                                              .catch((err) => {
                                                console.log("leadlog", err);
                                              });
                                            updateAllotmentPaymentStatus(
                                              request.allotmentpaymentid,
                                              // "Cancellation Not Done"
                                              request.paidamount < request.bookingamt.total ? "Partial Payment Done" : "Payment Complete"
                                            ).then((resp) => { });
                                            successTost(
                                              "Cancel unit rejected successfully"
                                            );
                                            setSearchCancelUnit("");
                                            document.getElementById(
                                              "input-with-icon-textfield cancelAlotLeadName"
                                            ).value = "";
                                            getAllCancelUnit(false);
                                          })
                                          .catch((err) => {
                                            console.log(
                                              err,
                                              "err while canceling reject unit"
                                            );
                                          });
                                      })
                                      .catch((err) => {
                                        errorTost("Error while confirming");
                                      });
                                  } else if (e === "Initiate Refund") {
                                    setOpenAlertBoxForCancellation(true);
                                  } else if (e === "Reprice Unit") {
                                    console.log({ request });
                                    let leadobj = {
                                      leadId:
                                        request?.leadid,
                                      leadname:
                                        request?.leadname,
                                      leademail:
                                        request?.leademail,
                                      leadcontactnumber:
                                        request?.leadcontactnumber,
                                    };
                                    setIsRepriceForChangeUnit(false)
                                    setLeadObj(leadobj);
                                    setSelectedAllotment(request);
                                    setRepriceUnitModal(true);
                                    setIsRepricePending(true)
                                  } else if (e === "View Details") {
                                    console.log({ request });
                                    let leadobj = {
                                      leadId:
                                        request?.leadid,
                                      leadname:
                                        request?.leadname,
                                      leademail:
                                        request?.leademail,
                                      leadcontactnumber:
                                        request?.leadcontactnumber,
                                    };
                                    setIsRepriceForChangeUnit(false)
                                    setLeadObj(leadobj);
                                    setSelectedAllotment(request);
                                    setRepriceUnitModal(true);
                                    setIsRepricePending(false)
                                  } else if (e === "Skip Reprice") {
                                    setShowSkipRepriceModal(true)
                                  }
                                }}
                              />
                              {/* } */}
                            </div>
                          </div>
                          <div className={cssClasses.cardDetails} style={{ justifyContent: "space-between" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                // width: "50%",
                                // width: "100%",
                              }}
                            >
                              <div className={cssClasses.tokenNumWrap}>
                                <p>{request?.leadname}</p>
                              </div>
                              <div className={cssClasses.allotmentPaymentId}>
                                <p>
                                  {"VJ" +
                                    request?.leaddisplayid?.replace(
                                      request?.leaddisplayid?.substring(8, 12),
                                      "-" +
                                      request?.leaddisplayid?.substring(
                                        8,
                                        12
                                      )
                                    )}
                                </p>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className={cssClasses.tokenNumWrap}>
                                Paid Amount: <span className={cssClasses.cancellationPadiAmt}> ₹{numberWithCommas(request?.paidamount)}</span>
                              </div>
                            </div>
                            {request?.leadsalesmanager && (
                              <div>
                                SM: {request?.leadsalesmanager}
                              </div>
                            )}
                            {/* <div className={cssClasses.tokenStatus}>
                            <LeadStatusChip
                              label={request.leadConfirmation}
                              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                              style={
                                request.leadConfirmation === "Pending"
                                  ? {
                                    color: "#B42318",
                                    backgroundColor: "#FEF3F2",
                                  }
                                  : request.leadConfirmation === "Accepted"
                                    ? {
                                      color: "#027A48",
                                      backgroundColor: "#ECFDF3",
                                    }
                                    : {
                                      color: "#B54708",
                                      backgroundColor: "#FFFAEB",
                                    }
                              }
                            ></LeadStatusChip>
                          </div> */}
                          </div>
                          {showDetails[index] && (cancellationsSubTabs
                            ?.filter((val) => val !== null)
                            .find((f) => f?.isSelected)?.value !== "Rejected") &&
                            (cancellationsSubTabs
                              ?.filter((val) => val !== null)
                              .find((f) => f?.isSelected)?.value !== "Cancellation") &&
                            <div style={{ marginTop: "2rem", width: "100%" }}>
                              <Divider
                                sx={{
                                  width: "100%",
                                  borderColor: "#EAECF0",
                                  marginBottom: "1.2rem",
                                }}
                              />
                              <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                              }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className={cssClasses.tokenNumWrap}>
                                    Cancellation Charges: <span className={cssClasses.cancellationPadiAmt}> ₹{numberWithCommas(request?.cancellationcharges ?? 0)}</span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className={cssClasses.tokenNumWrap}>
                                    Waived Charges: <span className={cssClasses.cancellationPadiAmt}> ₹{numberWithCommas(request?.waivedoffcancellationcharges ?? 0)}</span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className={cssClasses.tokenNumWrap}>
                                    Total Cancellation Charges: <span className={cssClasses.cancellationPadiAmt}> ₹{numberWithCommas(request?.newcancellationcharges ? request?.newcancellationcharges : (request?.cancellationcharges - request?.waivedoffcancellationcharges ?? 0))}</span>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className={cssClasses.tokenNumWrap}>
                                    Refund Amount: <span className={cssClasses.cancellationPadiAmt}> ₹{numberWithCommas(refundDetails[index])}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                          }
                          {(cancellationsSubTabs
                            ?.filter((val) => val !== null)
                            .find((f) => f?.isSelected)?.value !== "Rejected") &&
                            (cancellationsSubTabs
                              ?.filter((val) => val !== null)
                              .find((f) => f?.isSelected)?.value !== "Cancellation") && <div style={{ width: "100%", display: "flex", justifyContent: "flex-start" }}>
                              <Box>
                                {showDetails[index] ? (
                                  <Button
                                    iconPosition={"right"}
                                    padding={"0.5rem"}
                                    clicked={() => getRefundAmount(false, index, request?.allotmentpaymentid)}
                                    btnName={"Hide Details"}
                                    style={{
                                      color: "#1570EF",
                                      borderRadius: "2.4rem",
                                      backgroundColor: "#EFF8FF",
                                      fontSize: "1.6rem",
                                      lineHeight: "2.4rem",
                                      border: "1px solid #EFF8FF",
                                    }}
                                    btnIcon={
                                      <KeyboardArrowUpIcon
                                        style={{
                                          color: "#1570EF",
                                          width: "3rem",
                                          height: "3rem",
                                        }}
                                      />
                                    }
                                  />
                                ) : (
                                  <Button
                                    iconPosition={"right"}
                                    padding={"0.5rem"}
                                    clicked={() => {
                                      console.log(request)
                                      getRefundAmount(true, index, request?.allotmentpaymentid);
                                    }}
                                    btnName={"More Details"}
                                    style={{
                                      color: "#1570EF",
                                      borderRadius: "2.4rem",
                                      backgroundColor: "#EFF8FF",
                                      fontSize: "1.6rem",
                                      lineHeight: "2.4rem",
                                      border: "1px solid #EFF8FF",
                                    }}
                                    btnIcon={
                                      <KeyboardArrowDownIcon
                                        style={{
                                          color: "#1570EF",
                                          width: "3rem",
                                          height: "3rem",
                                        }}
                                      />
                                    }
                                  />
                                )}
                              </Box>
                            </div>}
                        </Card>
                      ))}
                  </Grid>
                </InfiniteScroll>
              </Box>
            </Box>
          ) : (
            <div className={cssClasses.noDataWrapper}>
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyListIcon} alt="No Requests" />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Requests to show!
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function changedAllotment() {
    return (
      <div className={cssClasses.content}>
        <>
          <Box>
            <TabContext
              value={
                changeUnitSubTabs
                  ?.filter((val) => val !== null)
                  .find((f) => f?.isSelected)?.value
              }
            >
              <TabsMenu
                selectedColor={"#1570EF"}
                selectedBackgroundColor={"#FFFFFF"}
                stylesForTab={{
                  color: "#344054",
                  fontSize: "1.6rem",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "2.4rem",
                  padding: "0.8rem 1.2rem",
                  textTransform: "unset",
                  borderBottom: "1px solid #EAECF0",
                }}
                borderColor={"#1570EFs"}
                stylesForWrapper={{
                  padding: "1.5rem 0",
                  background: "#FFFFFF",
                }}
                list={changeUnitSubTabs?.filter((val) => val !== null)}
                value={
                  changeUnitSubTabs
                    ?.filter((val) => val !== null)
                    .find((f) => f?.isSelected)?.value
                }
                handleChange={(e, value) => {
                  sessionStorage.setItem("tab", null)
                  setChangeUnitSubTabs((pre) => {
                    pre.forEach((ele) => {
                      if (ele.value === value) {
                        ele.isSelected = true;
                      } else {
                        ele.isSelected = false;
                      }
                    });
                    return [...pre];
                  });
                }}
              >
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Change Unit Request"}
                  index={0}
                ></TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Pending"}
                  index={1}
                ></TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 7rem)",
                    padding: "0rem 0rem 2rem 1rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Done"}
                  index={2}
                ></TabPanel>
              </TabsMenu>
            </TabContext>
          </Box>
        </>
        <Box display={"flex"} flexDirection={"column"} gap={"rem"}>
          <Typography className={cssClasses.headerTittle}>
            {allChangeAllotmentCount} Change Request
          </Typography>
        </Box>
        <div
          className={cssClasses.actionWrapper}
          style={{ justifyContent: "flex-end" }}
        >
          {filterModal()}
          <div>
            <div
              style={{
                marginLeft: "8px",
              }}
            >
              <div className={cssClasses.label}>
                <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Sort by</p>
              </div>
              <div className={cssClasses.dropdownWrapper}>
                <DropDown
                  onChangeSelect={(e) => {
                    filterAllotmentBySort(e);
                  }}
                  selectedValue={filterBy}
                  style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                  list={listsOrder}
                />
              </div>
            </div>
          </div>
          <div className={cssClasses.searchWrapper}>
            <SearchBar
              placeholder={"Search by Lead Name"}
              search={debouncedFetchSearchDataChangeUnit}
              id={"changeAlotLeadName"}
            />
          </div>
        </div>
        <div className={cssClasses.gridWrapper}>
          {/* <DataGrid
            rows={allChangeUnits}
            columns={changeUnitColumn}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={currentPageChangeUnit}
            onPageChange={(e) => {
              pageChangedChangeUnit(e);
            }}
            sx={[dataGridStyles]}
          /> */}
          {allChangeUnits.length > 0 ? (
            <Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
              <Box sx={{ flexGrow: 1 }}>
                <InfiniteScroll
                  dataLength={allChangeUnits.length}
                  next={() =>
                    setQueryPage((pre) => {
                      return pre + 1;
                    })
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }} //To put endMessage and loader to the top.
                  hasMore={loadingStatus === 0}
                  // loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv"
                >
                  <Grid
                    style={{
                      marginTop: "1rem",
                      marginBottom: "1rem",
                      marginLeft: "1rem",
                      marginRight: "1rem",
                      gap: "2rem",
                      width: "calc(100% - 2rem)",
                    }}
                    container
                    spacing={{ xs: 2, md: 3, lg: 3 }}
                    columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                  >
                    {allChangeUnits.length > 0 &&
                      allChangeUnits.map((request, index) => (
                        <Card className={cssClasses.eventWrap} key={index}>
                          <div className={cssClasses.cardHeader}>
                            <div
                              className={cssClasses.tokenNumWrap}
                              style={{ fontFamily: "inter-semiBold" }}
                            >
                              {request?.currentunitid && (
                                <span>
                                  {/* {request?.currentUnitId?.wingId?.wingName} */}
                                  {request?.currentUnitId?.wingId?.displayName
                                    ? request?.currentUnitId?.wingId
                                      ?.displayName
                                    : request?.currentwingname}{" "}
                                  - {request?.currentunitno}{" "}
                                </span>
                              )}
                              {request?.inventorymergedid &&
                                ((request?.mergedwingid && (
                                  <span>
                                    {
                                      // request?.allotmentPaymentId
                                      //   ?.inventoryMergedId.unit1Id.wingId
                                      //   .wingName
                                      request?.allotmentPaymentId
                                        ?.inventoryMergedId.unit1Id.wingId
                                        .displayName
                                        ? request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit1Id.wingId
                                          .displayName
                                        : request?.mergedwing
                                    }{" "}
                                    -{" "}
                                    {
                                      request?.unit1no
                                    }{" "}
                                    &{" "}
                                    {
                                      request?.unit2no
                                    }{" "}
                                  </span>
                                )) ||
                                  (!request?.mergedwingid && (
                                    <span>
                                      {
                                        // request?.allotmentPaymentId
                                        //   ?.inventoryMergedId.unit1Id.wingId
                                        //   .wingName
                                        request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit1Id.wingId
                                          .displayName
                                          ? request?.allotmentPaymentId
                                            ?.inventoryMergedId.unit1Id.wingId
                                            .displayName
                                          : request?.mergedwing
                                      }{" "}
                                      -{" "}
                                      {
                                        request?.unit1no
                                      }{" "}
                                      &{" "}
                                      {
                                        // request?.allotmentPaymentId
                                        //   ?.inventoryMergedId.unit2Id.wingId
                                        //   .wingName
                                        request?.allotmentPaymentId
                                          ?.inventoryMergedId.unit2Id.wingId
                                          .displayName
                                          ? request?.allotmentPaymentId
                                            ?.inventoryMergedId.unit2Id.wingId
                                            .displayName
                                          : request?.mergedwing
                                      }{" "}
                                      -{" "}
                                      {
                                        request?.unit2no
                                      }{" "}
                                    </span>
                                  )))}
                              <Box component={"span"}> | </Box>
                              {request?.requestedunittype ?? "-"}
                              <span style={{ display: "flex", padding: "5px" }}>
                                <img src={ArrowBlockRight} alt="icon" />
                              </span>
                              <Box className={cssClasses.innerTitle}>
                                {/* {request?.requestedUnitId?.wingId?.wingName
                                  ? request?.requestedUnitId?.wingId?.wingName
                                  : "-"} */}
                                {request?.requestedUnitId?.wingId?.displayName
                                  ? request?.requestedUnitId?.wingId
                                    ?.displayName
                                  : request?.requestedwingname
                                    ? request?.requestedwingname
                                    : "-"}
                                -
                                {request?.requestedunitno
                                  ? request?.requestedunitno
                                  : "-"}
                                <Box component={"span"}> | </Box>
                                {request?.requestedunittype ?? "-"}
                              </Box>
                              <span>|</span>
                              {request?.currentunitid && (
                                <span>{request?.currentprojectname}</span>
                              )}
                              {request?.inventorymergedid && (
                                <span>
                                  {
                                    request?.mergedproject
                                  }
                                </span>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              // width: "100%",
                              alignItems: "center",
                            }}
                          >
                            <div className={cssClasses.tokenStatus}>
                              <LeadStatusChip
                                label={
                                  request.leadconfirmation === "Pending"
                                    ? request.status +
                                    " by lead " +
                                    request.leadname
                                    : request.status === "Pending" &&
                                      loggedInUser.roleId.level === 1 &&
                                      request.requestpendingwithuserid &&
                                      request.requestpendingwithroleid
                                      ? request.status +
                                      " with " +
                                      request.requestpendingwithusername +
                                      "(" +
                                      request.requestpendingwithroletitle +
                                      ")"
                                      : request.status
                                }
                                icon={
                                  <Dot width={"0.5rem"} height={"0.5rem"} />
                                }
                                style={
                                  request.status === "Pending"
                                    ? {
                                      color: "#B42318",
                                      backgroundColor: "#FEF3F2",
                                    }
                                    : request.status === "Accepted"
                                      ? {
                                        color: "#027A48",
                                        backgroundColor: "#ECFDF3",
                                      }
                                      : {
                                        color: "#B54708",
                                        backgroundColor: "#FFFAEB",
                                      }
                                }
                              ></LeadStatusChip>
                            </div>
                            <div className={cssClasses.tokenLastUpdate}>
                              <ReactTimeAgo
                                style={{ fontSize: "1.2rem" }}
                                date={
                                  request?.last_updated_at
                                    ? request?.last_updated_at
                                    : request?.created_at
                                }
                                locale="en-US"
                              />
                            </div>
                            <div className={cssClasses.tokenActions}>
                              {/* {!request.cancellationListMenu.includes('No actions available!') && */}
                              <ThreeDotsMenu
                                list={
                                  changeUnitSubTabs
                                    ?.filter((val) => val !== null)
                                    .filter(
                                      (val) =>
                                        val.isSelected &&
                                        val.value === "Change Unit Request"
                                    )?.length !== 0
                                    ? request.changeUnitListMenu?.filter(
                                      (val) => val !== "Reprice Unit"
                                    )?.length === 0
                                      ? ["No Actions Available"]
                                      : request.changeUnitListMenu?.filter(
                                        (val) => val !== "Reprice Unit"
                                      )
                                    : request.changeUnitListMenu?.length === 0
                                      ? ["No Actions Available"]
                                      : request.changeUnitListMenu
                                }
                                selectedValue={async (e) => {
                                  // CRM2 M5-F9 (DC-181): a CRM 2.0 booking's Change Unit is decided on its CRM 2.0 card
                                  if (e === "Accept" || e === "Reject") {
                                    const apId = request?.allotmentPaymentId || request?.allotmentpaymentid;
                                    const { data: c2 } = apId ? await supabase.from("AllotmentPayment").select("isCrm2").eq("allotmentPaymentId", apId).maybeSingle() : { data: null };
                                    if (c2?.isCrm2) {
                                      console.warn("[crm2][AllAllotments] old Change Unit action refused for a CRM 2.0 booking", { allotmentPaymentId: apId, action: e });
                                      errorTost("CRM 2.0 booking: approve or reject this Change Unit on its card in CRM 2.0 › Approval Pending.");
                                      return;
                                    }
                                  }
                                  // Options
                                  if (e === "Accept") {
                                    // **Single Unit
                                    if (
                                      request.inventorymergeid === null
                                    ) {
                                      const oldUnitInventoryRes = await checkForInventoryStatus(request.currentunitid);
                                      let obj = {
                                        bsp: oldUnitInventoryRes?.data?.BSP,
                                        sdr: oldUnitInventoryRes?.data?.SDR,
                                        gst: oldUnitInventoryRes?.data?.GST,
                                        total: oldUnitInventoryRes?.data?.totalCost
                                      }

                                      updateChangeUnitRequest(
                                        "Accepted",
                                        request.changeunitrequestid,
                                        obj,
                                        request?.pricingtype === "preselect" ? true : false,
                                        null
                                      )
                                        .then((changeUnitRequestRes) => {
                                          // ??old unit make it available, costing zeroed for reprice
                                          freeAndZeroInventoryForChangeUnit(
                                            request.currentunitid
                                          )
                                            .then(
                                              async (
                                                updateInventoryForChangeUnit
                                              ) => {
                                                // ??new one make it alloted
                                                updateInventoryStatus(
                                                  request?.requestedunitid,
                                                  request?.newbookingamount
                                                    ?.total <=
                                                    request?.paidamount
                                                    ? request
                                                      ?.kycformfilled
                                                      ? kycDoneInventoryStatus
                                                      : kycPendingInventoryStatus
                                                    : paymentPendingInventoryStatus
                                                )
                                                  .then(
                                                    (
                                                      updateInventoryStatus
                                                    ) => { }
                                                  )
                                                  .catch((err) => {
                                                    console.log(
                                                      "err while updating inventoryStatus"
                                                    );
                                                  });
                                                if (
                                                  request.requestedunitid !==
                                                  null
                                                ) {
                                                  let respUnitCost
                                                  if (request.newpaymentplanid !== null) {
                                                    respUnitCost = await getPaymentPlansPriceFromServer(request?.newpaymentplanid, request?.requestedunitid)
                                                  }
                                                  const unitcost = {}
                                                  if (request.newpaymentplanid !== null) {
                                                    if (respUnitCost?.data.length > 0) {
                                                      unitcost.bsp = respUnitCost?.data[0]?.BSP
                                                      unitcost.gst = respUnitCost?.data[0]?.GST
                                                      unitcost.sdr = respUnitCost?.data[0]?.SDR
                                                      unitcost.total = respUnitCost?.data[0]?.totalCost
                                                    } else {
                                                      unitcost.gst = request?.requestedunitgst
                                                      unitcost.sdr = request?.requestedunitsdr
                                                      unitcost.total = request?.requestedunittotalcost
                                                      unitcost.bsp = request?.requestedunitbsp
                                                    }
                                                  } else {
                                                    unitcost.gst = request?.requestedunitgst
                                                    unitcost.sdr = request?.requestedunitsdr
                                                    unitcost.total = request?.requestedunittotalcost
                                                    unitcost.bsp = request?.requestedunitbsp
                                                  }
                                                  let allotmentPaymentObj = {
                                                    // New unit updating
                                                    unitId:
                                                      request?.requestedunitid,
                                                    status:
                                                      request?.paidamount !== 0
                                                        ? request
                                                          ?.newbookingamount
                                                          ?.total >
                                                          request
                                                            ?.paidamount
                                                          ? "Partial Payment Done"
                                                          : "Payment Complete"
                                                        : "Payment Pending",
                                                    // request?.allotmentStatus,
                                                    bookingAmt:
                                                      request?.newbookingamount,
                                                    unitCost: unitcost,
                                                    paidAmt: null,
                                                    paidAmount:
                                                      request?.paidamount,
                                                    paymentPlanId: request.newpaymentplanid
                                                  };
                                                  updateAllotmentPayment(
                                                    allotmentPaymentObj,
                                                    request.allotmentpaymentid
                                                  )
                                                    .then(
                                                      (
                                                        updateAllotmentPaymentRes
                                                      ) => {
                                                        if (updateAllotmentPaymentRes?.data?.[0]?.CRM?.length > 0) {
                                                          const payload = {
                                                            oldUnitCost: unitcost,
                                                            newUnitCost: { bsp: 0, sdr: 0, gst: 0, total: 0 },
                                                          }
                                                          updateCrmByAllotmentPaymentId(request.allotmentpaymentid, payload).then((crmResp) => { })
                                                        }
                                                        updateAllotmentTransactions(
                                                          request?.allotmentpaymentid,
                                                          request?.requestedunitid
                                                        )
                                                          .then((response) => {
                                                            let bucketingObj = {
                                                              allotmentPaymentId:
                                                                request?.allotmentpaymentid,
                                                            };
                                                            bucketingForChangeUnit(
                                                              bucketingObj
                                                            )
                                                              .then(
                                                                (
                                                                  bucketingResp
                                                                ) => {
                                                                  if (
                                                                    bucketingResp
                                                                      .data
                                                                      .success
                                                                  ) {
                                                                    // ??success
                                                                  } else {
                                                                    errorTost(
                                                                      bucketingResp
                                                                        .data
                                                                        .message
                                                                    );
                                                                  }
                                                                }
                                                              )
                                                              .catch((err) => {
                                                                console.log(
                                                                  err
                                                                );
                                                              });
                                                          })
                                                          .catch((err) => {
                                                            console.log(err);
                                                          });
                                                        let InventoryLogObj = {
                                                          userId:
                                                            loggedInUser?.userId,
                                                          leadId:
                                                            request.leadid,
                                                          status: "Available",
                                                          unitId:
                                                            request.currentunitid,
                                                          oldUnitDetails: {
                                                            oldUnit: {
                                                              unitId: request.currentunitid,
                                                              bsp: oldUnitInventoryRes?.data?.BSP,
                                                              gst: oldUnitInventoryRes?.data?.GST,
                                                              sdr: oldUnitInventoryRes?.data?.SDR,
                                                              totalCost: oldUnitInventoryRes?.data?.totalCost,
                                                            },
                                                            lead: {
                                                              leadId: request?.leadid,
                                                              leadName: request?.leadname,
                                                              cuid: request?.leaddisplayid,
                                                            },
                                                          },
                                                        };
                                                        insertInventoryLogs(
                                                          InventoryLogObj
                                                        )
                                                          .then(
                                                            (
                                                              insertInventoryLogsRes
                                                            ) => {
                                                              let leadlogobj = {
                                                                leadId:
                                                                  request.leadid,
                                                                leadStatus: `Change Unit Done`,
                                                                message: `Change Unit request Done for ${request?.currentwingname},${request?.currentprojectname} by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                                                              };
                                                              addLeadLogs(
                                                                leadlogobj
                                                              )
                                                                .then(
                                                                  (leadLog) => {
                                                                    updateLeadAllStatus(
                                                                      request.leadid,
                                                                      request?.paidamount !==
                                                                        0
                                                                        ? request
                                                                          ?.newbookingamount
                                                                          ?.total >
                                                                          request
                                                                            ?.paidamount
                                                                          ? "Allotment Partial Payment Done"
                                                                          : "Allotment Payment Complete"
                                                                        : "Allotment Payment Pending"
                                                                      // request.leadStatus
                                                                    )
                                                                      .then(
                                                                        (
                                                                          resp
                                                                        ) => {
                                                                          successTost(
                                                                            "Change Request Updated Successfully"
                                                                          );
                                                                        }
                                                                      )
                                                                      .catch(
                                                                        (
                                                                          err
                                                                        ) => {
                                                                          console.log(
                                                                            err
                                                                          );
                                                                        }
                                                                      );
                                                                    document.getElementById(
                                                                      "input-with-icon-textfield changeAlotLeadName"
                                                                    ).value =
                                                                      "";
                                                                    setSearchChangeUnit(
                                                                      ""
                                                                    );
                                                                    getAllChangeUnit(
                                                                      false
                                                                    );
                                                                  }
                                                                )
                                                                .catch(
                                                                  (err) => {
                                                                    console.log(
                                                                      "leadlog",
                                                                      err
                                                                    );
                                                                  }
                                                                );
                                                            }
                                                          )
                                                          .catch((err) => {
                                                            console.log(
                                                              "err while inserting into inventory log",
                                                              err
                                                            );
                                                          });
                                                      }
                                                    )
                                                    .catch((error) => {
                                                      console.log(error);
                                                    });
                                                }
                                              }
                                            )
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        })
                                        .catch((changeUnitRequestErr) => {
                                          console.log(changeUnitRequestErr);
                                        });
                                    }
                                    // } else if (e === "Reject") {
                                    //   let obj = {
                                    //     bsp: request?.unitcost?.bsp,
                                    //     sdr: request?.unitcost?.sdr,
                                    //     gst: request?.unitcost?.gst,
                                    //     total: request?.unitcost?.total
                                    //   }
                                    //   updateChangeUnitRequest(
                                    //     "Rejected",
                                    //     request.changeunitrequestid,
                                    //     obj
                                    //   )
                                    //     .then((changeUnitRequestRes) => {
                                    //       updateInventorForChangeUnit(
                                    //         request.requestedunitid
                                    //       )
                                    //         .then(
                                    //           (updateInventoryForChangeUnit) => {
                                    //             updateLeadAllStatus(
                                    //               request.leadid,
                                    //               request.leadstatus
                                    //             )
                                    //               .then((resp) => {
                                    //                 let allotmentPaymentObj = {
                                    //                   // New unit updating
                                    //                   status:
                                    //                     request?.allotmentstatus,
                                    //                 };
                                    //                 updateAllotmentPayment(
                                    //                   allotmentPaymentObj,
                                    //                   request.allotmentpaymentid
                                    //                 )
                                    //                   .then(
                                    //                     (
                                    //                       updateAllotmentPaymentRes
                                    //                     ) => { }
                                    //                   )
                                    //                   .catch(
                                    //                     (
                                    //                       errInAllotmentPayment
                                    //                     ) => {
                                    //                       console.log(
                                    //                         errInAllotmentPayment
                                    //                       );
                                    //                     }
                                    //                   );
                                    //               })
                                    //               .catch((err) => {
                                    //                 successTost(
                                    //                   "Change Request Updated Successfully"
                                    //                 );
                                    //               });
                                    //             document.getElementById(
                                    //               "input-with-icon-textfield changeAlotLeadName"
                                    //             ).value = "";
                                    //             setSearchChangeUnit("");
                                    //             getAllChangeUnit(false);
                                    //           }
                                    //         )
                                    //         .catch((errForUpdatingInventory) => {
                                    //           console.log(
                                    //             errForUpdatingInventory
                                    //           );
                                    //         });
                                    //     })
                                    //     .catch((err) => {
                                    //       console.log(err);
                                    //     });
                                    // }

                                  } else if (e === "Reject") {

                                    supabase
                                      .from("ChangeUnitRequests")
                                      .select(`
      allotmentStatus,
      leadStatus,
      oldBookingAmount,
      oldUnitPrice,
      oldPaymentPlanId
    `)
                                      .eq("changeUnitRequestId", request.changeunitrequestid)
                                      .single()
                                      .then(({ data, error }) => {
                                        if (error || !data) throw error;

                                        const {
                                          allotmentStatus,
                                          leadStatus,
                                          oldBookingAmount,
                                          oldUnitPrice,
                                          oldPaymentPlanId
                                        } = data;

                                        return updateChangeUnitRequest(
                                          "Rejected",
                                          request.changeunitrequestid,
                                          oldUnitPrice,
                                          request?.unitpricealreadyupdated ?? false
                                        ).then(() => {

                                          // 🔓 1️⃣ RELEASE REQUESTED UNIT → AVAILABLE
                                          if (request?.requestedunitid) {
                                            return updateInventorForChangeUnit(request.requestedunitid);
                                          }
                                        }).then(() => {

                                          // 🔁 2️⃣ Restore allotment payment
                                          return updateAllotmentPayment(
                                            {
                                              unitId: request.currentunitid,
                                              status: allotmentStatus,
                                              bookingAmt: oldBookingAmount,
                                              unitCost: oldUnitPrice,
                                              paidAmount: request.paidamount,
                                              paymentPlanId: oldPaymentPlanId
                                            },
                                            request.allotmentpaymentid
                                          );
                                        }).then(() => {

                                          // 🔁 3️⃣ Restore lead status
                                          return updateLeadAllStatus(
                                            request.leadid,
                                            leadStatus
                                          );
                                        }).then(() => {

                                          // 📝 4️⃣ Lead log
                                          return addLeadLogs({
                                            leadId: request.leadid,
                                            leadStatus: "Change Unit Rejected",
                                            message: `Change Unit request rejected for ${request.currentwingname}, ${request.currentprojectname} by ${loggedInUser?.name} (${loggedInUser?.roleId?.title})`
                                          });
                                        }).then(() => {

                                          successTost("Change Request Rejected Successfully");

                                          document.getElementById(
                                            "input-with-icon-textfield changeAlotLeadName"
                                          ).value = "";

                                          setSearchChangeUnit("");
                                          getAllChangeUnit(false);
                                        });
                                      })
                                      .catch((err) => {
                                        console.error("Reject failed", err);
                                        errorTost("Reject failed");
                                      });
                                  }





                                  else if (e === "Reprice Unit") {
                                    console.log({ request });
                                    let leadobj = {
                                      leadId:
                                        request?.leadid,
                                      leadname:
                                        request?.leadname,
                                      leademail:
                                        request?.leademail,
                                      leadcontactnumber:
                                        request?.leadcontactnumber,
                                    };
                                    setIsRepriceForChangeUnit(true);
                                    setLeadObj(leadobj);
                                    setSelectedAllotment(request);
                                    setRepriceUnitModal(true);
                                    setIsRepricePending(true)
                                  } else if (e === "View Details") {
                                    let leadobj = {
                                      leadId:
                                        request?.leadid,
                                      leadname:
                                        request?.leadname,
                                      leademail:
                                        request?.leademail,
                                      leadcontactnumber:
                                        request?.leadcontactnumber,
                                    };
                                    setIsRepriceForChangeUnit(true);
                                    setLeadObj(leadobj);
                                    setSelectedAllotment(request);
                                    setRepriceUnitModal(true);
                                    setIsRepricePending(false)
                                  }
                                }}
                              />
                              {/* } */}
                            </div>
                          </div>
                          <div className={cssClasses.cardDetails}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "70%",
                                // width: "100%",
                              }}
                            >
                              <div className={cssClasses.tokenNumWrap}>
                                <p>{request?.leadname}</p>
                              </div>
                              <div className={cssClasses.allotmentPaymentId}>
                                <p>
                                  {"VJ" +
                                    request?.leaddisplayid?.replace(
                                      request?.leaddisplayid?.substring(8, 12),
                                      "-" +
                                      request?.leaddisplayid?.substring(
                                        8,
                                        12
                                      )
                                    )}
                                </p>
                              </div>
                            </div>

                            <div
                              className={cssClasses.tokenNumWrap}
                              style={{
                                display: "inline-block",
                                whiteSpace: window.innerWidth < 768 ? "normal" : "nowrap", // Wrap text on mobile, no wrap on desktop
                                alignItems: "center",
                                marginRight: window.innerWidth >= 768 ? "250px" : "0", // Add margin for desktop
                              }}
                            >
                              Paid Amount:
                              <span className={cssClasses.cancellationPadiAmt} style={{ marginLeft: "8px" }}>
                                ₹{numberWithCommas(request?.paidamount)}
                              </span>
                            </div>

                            {request?.leadsalesmanager && (
                              <div style={{ width: "20%" }}>
                                SM: {request?.leadsalesmanager}
                              </div>
                            )}
                            {/* <div className={cssClasses.tokenStatus}>
                            <LeadStatusChip
                              label={request.leadConfirmation}
                              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                              style={
                                request.leadConfirmation === "Pending"
                                  ? {
                                    color: "#B42318",
                                    backgroundColor: "#FEF3F2",
                                  }
                                  : request.leadConfirmation === "Accepted"
                                    ? {
                                      color: "#027A48",
                                      backgroundColor: "#ECFDF3",
                                    }
                                    : {
                                      color: "#B54708",
                                      backgroundColor: "#FFFAEB",
                                    }
                              }
                            ></LeadStatusChip>
                          </div> */}
                          </div>
                        </Card>
                      ))}
                  </Grid>
                </InfiniteScroll>
              </Box>
            </Box>
          ) : (
            <div className={cssClasses.noDataWrapper}>
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyListIcon} alt="No Requests" />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Requests to show!
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  function alotUnit(allotment) {
    presentLoader();
    supabase
      .from("LeadStatus")
      .update({ status: "Allotment Payment Pending" })
      .eq("leadId", allotment.leadid)
      .then((leadStatusRes) => {
        supabase
          .from("InventoryStatus")
          .select("*")
          .eq("status", "Payment Pending")
          .then((statusRes) => {
            axios
              .post(
                `${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-payment-email`,
                {
                  leadName: allotment.leadname,
                  allotmentPaymentId: allotment.allotmentpaymentid,
                  leadEmail: allotment.leademail,
                }
              )
              .then((reqRes) => {
                supabase
                  .from("AllotmentPayment")
                  .update({ status: "Payment Pending" })
                  .eq("allotmentPaymentId", allotment.allotmentpaymentid)
                  .then(async (paymentRes) => {
                    if (allotment.unitid) {
                      supabase
                        .from("Inventory")
                        .update({
                          inventoryStatusId:
                            statusRes.data[0].inventoryStatusId,
                        })
                        .eq("unitId", allotment.unitid)
                        .then((updateRes) => {
                          supabase
                            .from("InventoryLogs")
                            .insert({
                              unitId: allotment.unitid,
                              leadId: allotment.leadid,
                              userId: JSON.parse(localStorage.getItem("user"))
                                .userId,
                              status: "payment pending",
                              pricingType: allotment.pricingtype,
                            })
                            .then(async (updateRes) => {
                              // ! call auto adjust token api
                              await autoAdjustToken(allotment.allotmentpaymentid)
                              dismissLoader();
                              getFilterAllotment();
                            });
                        });
                    } else {
                      supabase
                        .from("Inventory")
                        .update({
                          inventoryStatusId:
                            statusRes.data[0].inventoryStatusId,
                        })
                        .eq("unitId", allotment.unit1id)
                        .then((updateRes) => {
                          supabase
                            .from("InventoryLogs")
                            .insert({
                              unitId: allotment.unit1id,
                              leadId: allotment.leadid,
                              userId: JSON.parse(localStorage.getItem("user"))
                                .userId,
                              status: "payment pending",
                              pricingType: allotment.pricingtype,
                            })
                            .then((updateRes) => {
                              supabase
                                .from("Inventory")
                                .update({
                                  inventoryStatusId:
                                    statusRes.data[0].inventoryStatusId,
                                })
                                .eq("unitId", allotment.unit2id)
                                .then((updateRes) => {
                                  supabase
                                    .from("InventoryLogs")
                                    .insert({
                                      unitId: allotment.unit2id,
                                      leadId: allotment.leadid,
                                      userId: JSON.parse(
                                        localStorage.getItem("user")
                                      ).userId,
                                      status: "payment pending",
                                      pricingType: allotment.pricingtype,
                                    })
                                    .then(async (updateRes) => {
                                      // ! call auto adjust token api
                                      await autoAdjustToken(allotment.allotmentpaymentid)
                                      dismissLoader();
                                      getFilterAllotment();
                                    });
                                });
                            });
                        });
                    }
                  });
              });
          });
      });
  }

  function getList(allotment) {
    let arr = ["Check Status", "Timeline And Notes", "View Unit Cost"];
    if (
      !Boolean(allotment?.crmuserid && allotment?.crmusername) &&
      subTabs?.find((f) => f?.isSelected)?.text === "Completed" && (allotment?.pricingtype === "preselect" ? allotment?.preselectconfirmation === "confirmed" ? true : false : true) &&
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.Completed?.["Assign CRM"]?.isAccessible &&
      !crm2Ids.has(allotment?.allotmentpaymentid)
    ) {
      arr.push("Assign CRM");
    }
    // if (allotment.paidamount > 0 || allotment?.status === "Payment Pending") {
    arr.push("Details");
    // }
    if (
      // allotment?.pricingtype !== "preselect" &&
      (allotment?.status === "Payment Pending" ||
        allotment?.status === "Payment Complete" ||
        allotment?.status === "Partial Payment Done" || allotment?.status === "Preselected") &&
      subTabs.filter((ele) => {
        return ele.isSelected;
      })[0]?.value === "All"
    ) {
      arr.push("Adjust Token");
    }
    if (
      allotment?.status !== "Released" &&
      allotment?.status !== "Change Requested" &&
      allotment?.status !== "Change Rejected" &&
      allotment?.status !== "Cancellation Requested" &&
      allotment?.status !== "Cancellation Rejected" &&
      allotment?.status !== "Cancellation Pending" &&
      allotment?.status !== "Cancellation Not Done" &&
      allotment?.status !== "Cancelled" &&
      // allotment?.status !== "Partial Payment Done" &&
      !allotment?.status?.includes("Refund") &&
      (!allotment?.["100B2bRes"] && !allotment?.["gstB2bRes"] && !allotment?.["SdrB2bRes"])
    ) {
      // !!Remaining user access condition
      if (
        loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.[
          "Cancel Unit"
        ]?.isAccessible && allotment?.sent_for_agreement !== true && allotment?.skip_create_draft !== true
      ) {
        arr.push("Cancel Unit");
      }
    }
    return arr;
  }

  const allotmentCard = allAllotments.map((allotment, index) => {
    console.log("allotment", allotment);
    return (
      <Grid
        className={classes.Grid}
        // itemtabs
        item
        xs={4}
        sm={4}
        md={4}
        lg={4}
        key={"allotmentCard" + index}
      >
        <Card
          className={cssClasses.eventWrap}
          key={allotment.allotmentpaymentid}
        >
          <div className={cssClasses.cardHeader}>
            <div className={cssClasses.tokenNumWrap}>
              {
                // showDropDown &&
                allotment.kycformfilled &&
                // CRMUserFromCRMTable.find( (el) => el.allotmentPaymentId !== allotment.allotmentpaymentid)
                subTabs?.find((f) => f?.isSelected)?.text === "Completed" &&
                !allotment?.crmuserid && (allotment?.pricingtype === "preselect" ? allotment?.preselectconfirmation === "confirmed" ? true : false : true) && (
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    checked={
                      selectedAllotments.includes(
                        allotment.allotmentpaymentid
                      )
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedAllotments((pre) => {
                          pre.push(allotment.allotmentpaymentid);
                          return [...pre];
                        });
                      } else {
                        setSelectedAllotments((pre) => {
                          pre.splice(
                            pre.findIndex(
                              (e) => e === allotment.allotmentpaymentid
                            ),
                            1
                          );
                          return [...pre];
                        });
                      }
                    }}
                  />
                )
              }
              {allotment?.unitno && (
                <span>
                  {allotment?.displaywingname ? allotment?.displaywingname : allotment?.wingname} - {allotment?.unitno}{" "}
                </span>
              )}
              {allotment?.inventorymergeid && (
                <span>
                  {allotment?.mergedwing} - {allotment?.unit1no}
                  {"-"}
                  {allotment?.unit2no}
                </span>
              )}
              <span>|</span>
              {allotment?.projectname && <span>{allotment?.projectname}</span>}
              {allotment?.inventorymergeid && (
                <span>{allotment?.mergedproject}</span>
              )}
            </div>
            {allotment?.unitof && <div><LeadStatusChip
              label={allotment?.unitof}
              style={{
                color: "#3538CD",
                backgroundColor: "#EEF4FF",
              }}
            /></div>}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.tokenStatus}>
              {allotment.status === "On Hold" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "rgb(89, 37, 220)",
                    backgroundColor: "rgb(244, 243, 255)",
                  }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Agreement Done" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "#1570EF",
                    backgroundColor: "#EFF8FF",
                  }}
                ></LeadStatusChip>
              )}
              {(allotment.status === "Released" ||
                allotment?.status?.includes("Refund")) && (
                  <LeadStatusChip
                    label={allotment.status}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                    }}
                  ></LeadStatusChip>
                )}
              {allotment?.status?.toLowerCase().includes("cancel") && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "rgb(180, 35, 24)",
                    backgroundColor: "rgb(254, 243, 242)",
                  }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Partial Payment Done" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Payment Complete" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Preselected" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Payment Pending" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Change Requested" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                ></LeadStatusChip>
              )}
              {allotment.status === "Payment Complete" &&
                allotment.paidAmount >=
                allotment?.unitId?.projectId?.bookingAmt &&
                allotment.paidAmount -
                allotment?.unitId?.projectId?.bookingAmt <
                allotment.SDR && (
                  <LeadStatusChip
                    label={"SDR Payment Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  ></LeadStatusChip>
                )}
            </div>
            <div className={cssClasses.tokenStatus}>
              {allotment?.status?.includes("Payment") &&
                !allotment.kycformfilled && (
                  <LeadStatusChip
                    label={"Kyc pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  ></LeadStatusChip>
                )}
              {allotment?.status?.includes("Payment") &&
                allotment.kycformfilled && (
                  <LeadStatusChip
                    label={"Kyc Done"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  ></LeadStatusChip>
                )}
            </div>
            <div className={cssClasses.tokenStatus}>
              {allotment?.paymenttransferred &&
                allotment?.status === "Cancelled" && (
                  <LeadStatusChip
                    label={"Payment Transferred"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                )}
            </div>
            <div className={cssClasses.tokenStatus}>
              {allotment?.crmuserid && allotment?.crmusername && (
                <LeadStatusChip
                  label={"CRM Tagged"}
                  icon={<LocalOfferIcon width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                />
              )}
            </div>
            { /*<div className={cssClasses.tokenStatus}>
              {allotment?.crmstatusid !== null &&
                allotment?.status !== "Cancelled" &&
                allotment?.status !== "Cancellation Requested" &&
                allotment?.status !== "Cancellation Pending" &&
                allotment?.status !== "Refund Initiated" &&
                allotment?.status !== "Refund Processed" && (
                  <LeadStatusChip
                    label={crmStatusIdValues[allotment?.crmstatusid]}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                />
              )}
            </div>*/}
            <div className={cssClasses.tokenActions}>
              <ThreeDotsMenu
                // list={["Details", "Sync", "Check Status"]}
                list={
                  getList(allotment)

                  // allotment.paidamount === 0
                  //   ? ["Check Status"]
                  //   : ["Details", "Check Status"]
                }
                selectedValue={(e) => {
                  selectedValueCheck(e, allotment);
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.tokenStatus}>
              {allotment?.crmstatusid !== null &&
                allotment?.status !== "Cancelled" &&
                allotment?.status !== "Cancellation Requested" &&
                allotment?.status !== "Cancellation Pending" &&
                allotment?.status !== "Refund Initiated" &&
                allotment?.status !== "Refund Processed" && (
                  <LeadStatusChip
                    label={crmStatusIdValues[allotment?.crmstatusid]}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              className={cssClasses.tokenNumWrap}
              style={{ alignItems: "baseline" }}
            >
              <p>{allotment.leadname}</p>
              <p
                style={{
                  fontFamily: "Inter-Regular",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "1.4rem",
                  lineHeight: "1.8rem",
                  color: "#667085",
                }}
              >
                {"VJ" +
                  allotment?.leaddisplayid?.replace(
                    allotment?.leaddisplayid?.substring(8, 12),
                    "-" + allotment?.leaddisplayid?.substring(8, 12)
                  )}
              </p>
            </div>
            <div className={cssClasses.allotmentPaymentId} style={{ display: "flex", justifyContent: "space-between" }}>
              <p>{allotment.allotmentpaymentid}</p>
            </div>
            <div style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "space-between",
              marginTop: "1rem",
              width: "100%",
              flexDirection: "row"
            }}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "start",
                }}
              >
                {allotment?.leadvjop && <div><LeadStatusChip
                  label="VJOP"
                  style={{
                    color: "rgb(180, 35, 24)",
                    backgroundColor: "rgb(254, 243, 242)",
                  }}
                /></div>}
              </div>
              <div style={{ display: "flex", gap: "1rem", justifyContent: "end" }}>
                {allotment?.isdiscountapplied ? (
                  <LeadStatusChip
                    label={"Discount Applied"}
                    style={{ color: "#234a2e", backgroundColor: "#b8e6c4" }}
                  ></LeadStatusChip>
                ) : (
                  allotment?.isdiscounteligible && (
                    <LeadStatusChip
                      label={"Discount Eligible"}
                      style={{
                        color: "#FF4F00",
                        backgroundColor: "#fad5be",
                      }}
                    ></LeadStatusChip>
                  )
                )}
              </div>
            </div>
          </div>
          <div className={cssClasses.cardDetails}>
            <div className={cssClasses.tokenDetails}>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <span>
                  {allotment.eventname ? allotment.eventname : "Sustenance"}
                </span>
                {allotment.eventname &&
                  allotment.pricingtype === "preselect" && (
                    <span>
                      <LeadStatusChip
                        label={"Preselect"}
                        style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
                      ></LeadStatusChip>
                    </span>
                  )}
                <div className={cssClasses.tokenLastUpdate}>
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={allotment?.lastupdated ?? allotment?.createdat}
                    locale="en-US"
                  />
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{
                  justifyContent: "space-between",
                  flexDirection: "row",
                }}
              >
                <div className={cssClasses.tokenLastUpdate} style={{ flex: 1 }}>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>VJ SM - {allotment.username}</span>
                  </p>
                  {/* <p>VJ SM - {allotment.cpbillingname}</p> */}
                  {allotment?.crmuserid && allotment?.crmusername && (
                    <p>VJ CRM - {allotment.crmusername}</p>
                  )}
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  {allotment?.displayinventorytype?.includes(
                    "Inventory Type"
                  ) ? (
                    <span>{allotment.unittype}</span>
                  ) : (
                    ""
                  )}
                  {allotment?.displayinventorytype?.includes(
                    "Display Unit Type"
                  ) ? (
                    <span>{"(" + allotment.displayunittype + ")"}</span>
                  ) : (
                    ""
                  )}
                  {!allotment.unittype && (
                    <>
                      <span>Merged</span>
                    </>
                  )}
                  {/* <span>|</span>
                  {allotment.unitId &&
                    <span>Floor {allotment.unitId.floorNo}</span>
                  }
                  {allotment.inventoryMergedId &&
                    <>
                      {allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo &&
                        <span>Floor {allotment.inventoryMergedId.unit1Id.floorNo}</span>
                      }
                      {allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo &&
                        <span>Floor {allotment.inventoryMergedId.unit1Id.floorNo} - Floor {allotment.inventoryMergedId.unit2Id.floorNo}</span>
                      }
                    </>
                  } */}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>Alloted By: </span>
                  <span>{allotment?.allotedbyuser}</span>
                </div>
                <div>
                  <span>Alloted On: </span>
                  <span>
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.allotmentdate).toDateString()},{" "}
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.allotmentdate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>

              </div>
              {allotment.paymentcompletedate && <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>Payment Complete: </span>
                  <span>
                    {new Date(allotment?.paymentcompletedate).toDateString()},{" "}
                    {new Date(allotment?.paymentcompletedate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>

              </div>}
            </div>
          </div>
          {allotment?.paymentplantitle &&
            <div
              style={{
                display: "flex",
                gap: "1rem",
                width: "100%",
                fontSize: "1.4rem",
                padding: "10px 0",
                color: "rgba(220, 104, 3, 1)",
              }}>
              <span style={{ textTransform: "capitalize" }}>Payment Plan {allotment?.paymentplantitle} is selected.</span>
            </div>
          }
          {subTabs?.find((f) => f?.isSelected)?.text === "Completed" && allotment?.pricingtype === "preselect" && allotment.preselectconfirmation !== "confirmed" && <div style={{
            display: "flex",
            gap: "1rem",
            width: "100%",
            fontSize: "1.4rem",
            padding: "10px 0",
            color: "rgba(179, 35, 24, 1)",
          }}>
            <img src={infoSvg} alt="info" />
            <span style={{ textTransform: "capitalize" }}>{allotment.preselectconfirmation}</span>
          </div>}
          {/* <div className={cssClasses.priceBreakDown}>
            <div className={cssClasses.price}>
              <span>OCR : </span>
              <span>₹ {numberWithCommas(allotment.unitId?.bookingOcr)}</span>
            </div>
            <div className={cssClasses.price}>
              <span>SDR : </span>
              <span>₹ {numberWithCommas(allotment.unitId?.bookingSdr)}</span>
            </div>
            <div className={cssClasses.price}>
              <span>GST : </span>
              <span>₹ {numberWithCommas(allotment.unitId?.bookingGst)}</span>
            </div>
            <div className={cssClasses.price}>
              <span>Booking Amount: </span>
              {!allotment.paymentId?.eventTokenId.tokenId.isPreselect &&
                <span>₹ {allotment?.unitId?.projectId?.bookingAmt}</span>
              }
              {allotment.paymentId?.eventTokenId.tokenId.isPreselect &&
                <span>₹ {numberWithCommas(allotment.paymentId?.eventTokenId.tokenId.amount)}</span>
              }
            </div>
          </div> */}
          {/* } */}
          {/* <div className={cssClasses.cpDetails}>

            <div className={cssClasses.price}>
              <span>CP : </span>
              <span>{loggedInUser?.cpId?.billingName ?? '-'}</span>
            </div>
            <div className={cssClasses.price}>
              <span>FOS : </span>
              <span>{loggedInUser?.fosId?.name ?? '-'}</span>
            </div>
            <div className={cssClasses.price}>
              <span>SM : </span>
              <span>{loggedInUser.userId.name ?? '-'}</span>
            </div>
          </div> */}
          <div className={cssClasses.cardFooter}>
            {/* <div className={cssClasses.totalAmt}>
              <div>
                <span>Total Cost of Unit: </span>
                <span>₹ {numberWithCommas(allotment.totalUnitPrice)}</span>
              </div>
            </div> */}
            {subTabs.find((f) => f?.isSelected)?.value !== "On Hold" ? (
              <div className={cssClasses.paidAmt}>
                <span>Paid Amount : </span>
                <span>₹ {numberWithCommas(allotment.paidamount)}</span>
              </div>
            ) : (
              <div className={cssClasses.paidAmt}>
                {allotment.unitholdtime && (
                  // < ReactStopwatch
                  //   hours={Math.floor(Math.abs(new Date().getTime() - new Date(allotment.unitholdtime).getTime()) / (1000 * 60 * 60))}
                  //   minutes={Math.floor(Math.abs(new Date().getTime() - new Date(allotment.unitholdtime).getTime()) / (1000 * 60)) % 60}
                  //   seconds={Math.floor(Math.abs(new Date().getTime() - new Date(allotment.unitholdtime).getTime()) / 1000) % 60}
                  //   // limit={ }
                  //   // onChange={({ hours, minutes, seconds }) => {
                  //   //   // do something
                  //   // }}
                  //   render={({ formatted, hours, minutes, seconds }) => {
                  //     return (
                  //       <div>{formatted}</div>
                  //     );
                  //   }}
                  // />
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={allotment?.unitholdtime}
                    locale="en-US"
                  />
                )}
              </div>
            )}
            {(allotment.status === "Partial Payment Done" ||
              allotment.status === "Preselected" ||
              allotment.status === "Payment Pending" ||
              allotment.status === "On Hold") && (
                <div style={{ display: "flex", gap: "1rem" }}>
                  {/* <Button btnName={subTabs.find((f) => f.isSelected).value === 'On Hold' ? "Alot" : "Pay Now"} clicked={() => { */}
                  {allotment.status === "On Hold" && (
                    <Button
                      btnName={"Alot"}
                      clicked={() => {
                        // if (subTabs.find((f) => f.isSelected).value === 'On Hold') {
                        alotUnit(allotment);
                        // } else {
                        //   openModal(params.row)
                        // }
                      }}
                      style={{
                        // width: "60%",
                        color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                      }}
                    />
                  )}
                  {subTabs.find((f) => f?.isSelected)?.value !== "On Hold" &&
                    (allotment.status === "Partial Payment Done" ||
                      allotment.status === "Preselected" ||
                      allotment.status === "Payment Pending") && (
                      <Button
                        btnName={"Pay Now"}
                        clicked={() => {
                          // if (subTabs.find((f) => f.isSelected).value === 'On Hold') {
                          // if (allotment.status === 'On Hold') {
                          //   alotUnit(allotment)
                          // } else {
                          openModal(allotment);
                          // }
                        }}
                        style={{
                          width: "100%",
                          color: "#fff",
                          backgroundColor: "rgb(21, 112, 239)",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          fontFamily: "Inter-Medium !important",
                        }}
                      />
                    )}
                  {subTabs.find((f) => f?.isSelected)?.value === "On Hold" && (
                    <Button
                      btnName={"Release"}
                      clicked={() => {
                        // if (subTabs.find((f) => f.isSelected).value === 'On Hold') {
                        releaseUnit(allotment);
                        // } else {
                        //   openModal(params.row)
                        // }
                      }}
                      style={{
                        width: "60%",
                        color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                      }}
                    />
                  )}
                </div>
              )}


            {/* CRM2 M5-F5 (M5.10): parking of a CRM 2.0 booking is picked by its CRM in CRM 2.0, not here */}
            {subTabs.find((f) => f?.isSelected)?.value === "Parking Selection" && !crm2Ids.has(allotment?.allotmentpaymentid) && (
              <div style={{ padding: "1rem", textAlign: "right" }}>
                {/* <MuiButton
  variant="contained"
  color="primary"
  onClick={() => handleSelectParking(allotment)}
  style={{ marginTop: "1rem",  color: "#fff",
                        backgroundColor: "rgb(21, 112, 239)",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium !important",
                        marginLeft: "400px"}}
>
  Select Parking
</MuiButton> */}


                <MuiButton
                  variant="contained"
                  color="primary"
                  onClick={() => handleSelectParking(allotment)}
                  sx={{

                    color: "#fff",
                    backgroundColor: "rgb(21, 112, 239)",
                    fontSize: "1.4rem",


                    fontFamily: "Inter-Medium !important",
                    // Adjust marginLeft for mobile and desktop
                  }}
                >
                  Select Parking
                </MuiButton>

              </div>
            )}
          </div>
          {loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.Completed?.["Claim"]?.isAccessible &&
            subTabs?.find((f) => f?.isSelected)?.text === "Completed" &&
            !allotment?.crmuserid &&
            !allotment?.crmusername &&
            allotment?.status === "Payment Complete" &&
            allotment?.kycformfilled &&
            (allotment?.pricingtype === "preselect"
              ? allotment?.preselectconfirmation === "confirmed"
              : true) && (
              <div style={{ alignSelf: "flex-end", padding: "10px 0 0" }}>
                <Button
                  btnName={"Claim"}
                  padding={"0.8rem 3.4rem"}
                  clicked={() => {
                    handleClaimClick(allotment);
                  }}
                  style={{
                    color: "#fff",
                    backgroundColor: "#006AFF",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    fontFamily: "Inter-Medium !important",
                  }}
                />
              </div>
            )}
        </Card>
      </Grid>
    );
  });

  function callBookingApis() {
    axios
      .post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}bookings/send-welcome-email`,
        { allotmentPaymentId: allotmentDetails.allotmentPaymentId }
      )
      .then((resp) => { });
  }

  function releaseUnit(allotment) {
    presentLoader();
    if (allotment.pricingtype === "event") {
      supabase
        .from("EventTokenLeadRelations")
        .update({ status: "active" })
        .eq("paymentId", allotment.paymentid)
        .then((resp) => {
          supabase
            .from("LeadStatus")
            .update({ status: "Checkpoint Two Cleared" })
            .eq("leadId", allotment.leadid)
            .then((resp) => {
              let obj = {
                leadId: allotment.leadid,
                leadStatus: `Checkpoint Two Cleared`,
                message: `Unit Release`,
              };
              addLeadLogs(obj)
                .then((leadLog) => { })
                .catch((err) => { });
              changeAllotmentStatus(allotment);
            });
        });
    } else {
      supabase
        .from("LeadStatus")
        .update({ status: "Site Visit Done" })
        .eq("leadId", allotment.leadid)
        .then((resp) => {
          let obj = {
            leadId: allotment.leadid,
            leadStatus: `Site Visit Done`,
            message: `Unit Release`,
          };
          addLeadLogs(obj)
            .then((leadLog) => {
              console.log(leadLog);
            })
            .catch((err) => {
              console.log("leadlog", err);
            });
          changeAllotmentStatus(allotment);
        });
    }
  }

  function changeAllotmentStatus(allotment) {
    supabase
      .from("AllotmentPayment")
      .update({ status: "Released" })
      .eq("allotmentPaymentId", allotment.allotmentpaymentid)
      .then(async (resp) => {
        if (allotment.unitid) {
          let unit = await changeUnitStatus(allotment.unitid);
          dismissLoader();
          setQueryPage(0);
          setLoadingStatus(0);
          getFilterAllotment();
        } else {
          let unit1 = await changeUnitStatus(allotment.unit1id);
          let unit2 = await changeUnitStatus(allotment.unit2id);
          dismissLoader();
          setQueryPage(0);
          setLoadingStatus(0);
          getFilterAllotment();
        }
      });
  }

  function changeUnitStatus(unitId) {
    return new Promise((resolve, reject) => {
      supabase
        .from("Inventory")
        .select("*,inventoryStatusId(*)")
        .eq("unitId", unitId)
        .then((resp) => {
          if (resp.data[0].inventoryStatusId.status === "On Hold") {
            supabase
              .from("InventoryStatus")
              .select("*")
              .eq("status", "Available")
              .then((statusRes) => {
                supabase
                  .from("Inventory")
                  .update({
                    last_updated_at: new Date().getTime(),
                    inventoryStatusId: statusRes.data[0].inventoryStatusId,
                    unitHoldTime: null,
                    leadId: null,
                  })
                  .eq("unitId", unitId)
                  .then((r) => {
                    supabase
                      .from("InventoryLogs")
                      .insert({ unitId: unitId, status: "available" })
                      .then((r) => {
                        resolve(true);
                      });
                  });
              });
          }
        });
    });
  }

  function funReturnRes(value) {
    setTimeout(() => {
      if (value) {
        console.log("PAN Conflicts")
      }
    }, 300);
  }

  function conflictAllotment() {
    return (
      <div className={cssClasses.content}>
        <>
          <div
            className={cssClasses.actionWrapper}
            style={{ marginBottom: "0rem" }}
          >
            <Typography className={cssClasses.headerTittle}>
              {panConflicts?.length} Site Visits
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "1rem",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                {filterModal()}
                <div
                  style={{
                    marginLeft: "8px",
                  }}
                >
                  <div className={cssClasses.label}>
                    <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>
                      Filter by
                    </p>
                  </div>
                  <div className={cssClasses.dropdownWrapper}>
                    <DropDown
                      onChangeSelect={(e) => {
                        filterAllotmentBySort(e);
                      }}
                      selectedValue={filterBy}
                      style={{
                        selectedColor: "#175CD3",
                        background: "#E8F0FE",
                      }}
                      list={listsOrder}
                    />
                  </div>
                </div>
              </div>
              <div className={cssClasses.searchWrapper}>
                <SearchBar
                  placeholder={"Search by Lead Name"}
                  search={debouncedFetchSearchData}
                  id={"conflictAlotLeadName"}
                />
              </div>
            </div>
          </div>
        </>
        <div className={cssClasses.gridWrapper}>
          {panConflicts?.length > 0 ? (
            <Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
              <Box sx={{ flexGrow: 1 }}>
                <InfiniteScroll
                  dataLength={allCancelUnits.length}
                  next={() =>
                    setQueryPage((pre) => {
                      return pre + 1;
                    })
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }} //To put endMessage and loader to the top.
                  hasMore={loadingStatus === 0}
                  // loader={<h4>Loading...</h4>}
                  scrollableTarget="scrollableDiv"
                >
                  {panConflicts.map((each, index) => {
                    return (
                      <div className={cssClasses.wrapperLead}>
                        <PANConflictCard
                          leadObj={each}
                        />
                      </div>
                    )
                  })}
                </InfiniteScroll>
              </Box>
            </Box>
          ) : (
            <div className={cssClasses.noDataWrapper}>
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyListIcon} alt="No Site Visit" />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Site Vist to show!
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  async function getPANConflictsData(isCheckedClear = false) {
    presentLoader();
    await getPANConflicts(searchCancelUnit, filterBy, isCheckedClear ? [] : checked, projectStr, isCheckedClear ? undefined : selectDates).then((resp) => {
      resp.data = resp.data.map((el, index) => ({
        ...el,
        person: {
          name: el?.leadname,
          personId: el?.personid,
        },
        id:
          'VJ' +
          el?.leaddisplayid?.replace(
            el?.leaddisplayid?.substring(8, 12),
            '-' + el?.leaddisplayid?.substring(8, 12)
          ),
        // !!Change on 17/05/23
        // createdAt: el?.statuschangeddate,
        createdAt: el?.created_at,
        last_updated_at: el?.statuschangeddate,
        type: el?.leadtype,
        status: el?.leadstatus,
        leadId: el?.id,
        leadStatus: el?.leadresponse ? el?.leadresponse : 'WARM',
        FOS: {
          name: el?.fosname ? el?.fosname : '-',
          fosId: el?.fosid ? el?.fosid : '-',
        },
        CP: {
          name: el?.cpname ? el?.cpname : '-',
          cpId: el?.cpid ? el?.cpid : '-',
        },
        Sales: {
          name: el?.salesname ? el?.salesname : '-', //Sie Visit
          userId: el?.salesid ? el?.salesid : '-',
          email: el?.useremail,
          contactNumber: el?.usercontactnumber,
        },
        unit: {
          status: '',
          allotmentDate: '',
          number: '',
        },
        project: {
          unitType: el?.unittype,
          name: el?.projectname,
        },
        leadDetails: {
          contactNumber: el?.leadcontactnumber,
          leadEmail: el?.leademail,
        },
      }));
      setPanConflicts([...resp.data]);
      console.log("data after", [...resp.data])
      dismissLoader();
    })
  }
  return (
    <div className={`pageWrapper ${cssClasses.pageWrapper}`}>
      {!openPaymentModal && (
        <div style={{ height: "100%", width: "100%" }}>
          {/* <Box className={cssClasses.headerWrapper}>
                        <Box className={cssClasses.headerLeftSide}>

                            <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
                                <Typography className={cssClasses.headerTittle}>All Allotments</Typography>
                            </Box>

                        </Box>


                    </Box> */}
          <div className={cssClasses.tabsWrapper} style={{ height: "100%" }}>
            <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
              <TabContext value={tabs?.find((f) => f?.isSelected)?.value}>
                <TabsMenu
                  selectedColor={"#1570EF"}
                  selectedBackgroundColor={"#FFFFFF"}
                  stylesForTab={{
                    color: "#344054",
                    fontSize: "1.6rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "2.4rem",
                    padding: "0.8rem 1.2rem",
                    textTransform: "unset",
                    borderBottom: "1px solid #EAECF0",
                  }}
                  borderColor={"#1570EFs"}
                  stylesForWrapper={{
                    // padding: "1.5rem 0",
                    background: "#FFFFFF",
                  }}
                  list={tabs}
                  value={tabs?.find((f) => f?.isSelected)?.value}
                  handleChange={(e, value) => {
                    sessionStorage.setItem("tab", null)
                    setTabs((pre) => {
                      pre.forEach((ele) => {
                        setCurrentPage(0);
                        setQueryPage(0);
                        setSearch("");
                        setChecked([]);
                        if (ele.value === value) {
                          ele.isSelected = true;
                        } else {
                          ele.isSelected = false;
                        }
                      });
                      return [...pre];
                    });
                  }}
                />
                <TabPanel
                  style={{
                    height: "calc(100% - 5rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Event"}
                  index={1}
                >
                  <Box style={{ height: "100%" }}>
                    <div
                      className={cssClasses.tabsWrapper}
                      style={{ height: "100%" }}
                    >
                      <Box
                        className={cssClasses.TabsWrapper}
                        style={{ height: "100%" }}
                      >
                        <TabContext
                          value={subTabs.find((f) => f?.isSelected)?.value}
                        >
                          <TabsMenu
                            selectedColor={"#1570EF"}
                            selectedBackgroundColor={"#FFFFFF"}
                            stylesForTab={{
                              color: "#344054",
                              fontSize: "1.6rem",
                              fontStyle: "normal",
                              fontWeight: "500",
                              lineHeight: "2.4rem",
                              padding: "0.8rem 1.2rem",
                              textTransform: "unset",
                              borderBottom: "1px solid #EAECF0",
                            }}
                            borderColor={"#1570EFs"}
                            stylesForWrapper={{
                              padding: "1.5rem 0",
                              background: "#FFFFFF",
                            }}
                            list={subTabs}
                            value={subTabs.find((f) => f?.isSelected)?.value}
                            handleChange={(e, value) => {
                              sessionStorage.setItem("tab", null)
                              setSubTabs((pre) => {
                                pre.forEach((ele) => {
                                  if (ele.value === value) {
                                    ele.isSelected = true;
                                  } else {
                                    ele.isSelected = false;
                                  }
                                });
                                return [...pre];
                              });
                              setLoadingStatus(0);
                              setShowDropDown(false);
                              setSelectedAllotments([]);
                              if (queryPage > 0) {
                                setQueryPage(0);
                              } else {
                                getFilterAllotment(false, true);
                              }
                            }}
                          />
                          <TabPanel
                            style={{
                              height: "calc(100% - 7rem)",
                              padding: "0rem 0rem 2rem 1rem !important",
                            }}
                            className={classes.Tabs}
                            value={"All"}
                            index={0}
                          >
                            {mainContent()}
                          </TabPanel>
                          <TabPanel
                            style={{
                              height: "calc(100% - 10rem)",
                              padding: "0rem !important",
                            }}
                            className={classes.Tabs}
                            value={"Pending"}
                            index={1}
                          >
                            {mainContent()}
                          </TabPanel>
                          <TabPanel
                            style={{
                              height: "calc(100% - 10rem)",
                              padding: "0rem !important",
                            }}
                            className={classes.Tabs}
                            value={"On Hold"}
                            index={1}
                          >
                            {mainContent()}
                          </TabPanel>


                          <TabPanel
                            value={"Parking Selection"}
                            style={{ height: "calc(100% - 10rem)", padding: "0rem !important" }}
                            className={classes.Tabs}
                          >
                            {mainContent()}
                          </TabPanel>

                          <TabPanel
                            style={{
                              height: "calc(100% - 10rem)",
                              padding: "0rem !important",
                            }}
                            className={classes.Tabs}
                            value={"Completed"}
                            index={1}
                          >
                            {mainContent()}
                          </TabPanel>
                          <TabPanel
                            style={{
                              height: "calc(100% - 10rem)",
                              padding: "0rem !important",
                            }}
                            className={classes.Tabs}
                            value={"Preselect"}
                            index={1}
                          >
                            {mainContent()}
                          </TabPanel>
                        </TabContext>
                      </Box>
                    </div>
                    {/* {mainContent()} */}
                  </Box>
                </TabPanel>
                {/* <TabPanel
                  style={{
                    height: "calc(100% - 10rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Pre-Select"}
                  index={0}
                >
                  <Box
                    style={{ height: "100%" }}
                  >
                    {mainContent()}
                  </Box>
                </TabPanel> */}
                <TabPanel
                  style={{
                    height: "calc(100% - 10rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Cancellation Requests"}
                  index={0}
                >
                  <Box style={{ height: "100%" }}>{cancelledAllotment()}</Box>
                </TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 10rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Change Requests"}
                  index={1}
                >
                  <Box style={{ height: "100%" }}>{changedAllotment()}</Box>
                </TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 10rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"CRM"}
                  index={2}
                >
                  <Box style={{ height: "100%" }}>{<CrmAllotment />}</Box>
                </TabPanel>
                <TabPanel
                  style={{
                    height: "calc(100% - 10rem)",
                    padding: "0rem !important",
                  }}
                  className={classes.Tabs}
                  value={"Conflicts"}
                  index={0}
                >
                  <Box style={{ height: "100%" }}>{conflictAllotment()}</Box>
                </TabPanel>
              </TabContext>
            </Box>
          </div>

          {/* <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
          >
            <Box sx={{ ...style, width: "50%" }}>
              <div className={cssClasses.paymentDetailsWrapperHeader}>
                <h1>Payment Details</h1>
                <CloseIcon
                  fontSize="large"
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div className={cssClasses.paymentDetailsWrapper}>
                <div className={cssClasses.detailsInfoWrapper}>
                  <div className={cssClasses.detailsInfo}>
                    <h3
                      className={cssClasses.headerTittle}
                      style={{ marginRight: "30px" }}
                    >
                      {detail?.leadname}
                    </h3>

                    <div className={cssClasses.statusWrapper}>
                      <p style={{ marginRight: "12px" }}>Status: </p>
                      <LeadStatusChip
                        label={"Complete"}
                        style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                      />
                    </div>
                  </div>

                  <div>
                    <h3
                      className={cssClasses.headerTittle}
                      style={{
                        margin: "10px 0px",
                      }}
                    >
                      Details
                    </h3>

                    <table className={cssClasses.tableWrapper}>
                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Lead ID :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>{detail.leadId}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Project Name :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>
                            {detail.projectName}
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Amount :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>{detail.amount}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Payment for :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>
                            {detail.paymentFor}
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Wing - Unit :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>
                            {detail.wingName} - {detail.wingUnit}
                          </p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className={cssClasses.leadLight}>Unit Type :</p>
                        </td>
                        <td>
                          <p className={cssClasses.leadDark}>
                            {detail.unitType}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div className={cssClasses.transactionInfo}>
                  <h3
                    className={cssClasses.headerTittle}
                    style={{
                      margin: "20px 0px",
                    }}
                  >
                    Transaction Details
                  </h3>

                  <div className={cssClasses.scrollable}>
                    {selectedAllotments.setSelectedAllotments((item) => (
                      <>
                        <table className={cssClasses.tableWrapper}>
                          <tr>
                            <td>
                              <p className={cssClasses.leadLight}>
                                Payment Method :
                              </p>
                            </td>
                            <td>
                              <p className={cssClasses.leadDark}>
                                {item.modeOfPayment}
                              </p>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <p className={cssClasses.leadLight}>Amount :</p>
                            </td>
                            <td>
                              <p className={cssClasses.leadDark}>
                                ₹ {item.amount}
                              </p>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <p className={cssClasses.leadLight}>
                                Transaction ID :
                              </p>
                            </td>
                            <td>
                              <p className={cssClasses.leadDark}>
                                {item.transactionId}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p className={cssClasses.leadLight}>
                                Transaction Status :
                              </p>
                            </td>
                            <td>
                              <p className={cssClasses.leadDark}>
                                {item.status}
                              </p>
                            </td>
                          </tr>
                        </table>

                        <hr width="100%" color="#dadce0" />
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </Box>
          </Modal> */}
        </div>
      )}
      {open && (
        <AllotmentDetails
          handleClose={handleClose}
          open={open}
          data={dataForModal}
        />
      )}
      {openPaymentModal && (
        <PaymentModal
          desk={"seperateDeskPaymentModes"}
          allotment={currentAllotment}
          setOpenPaymentModal={setOpenPaymentModal}
        />
      )}
      {openParkingModal && (
        <ParkingModal
          isOpen={openParkingModal}
          onClose={() => setOpenParkingModal(false)}
          allotment={selectedAllotment}   // optional if you want to pass data
        />
      )}

      {openLoaderModal && (
        <LoaderModal
          allotmentDetails={allotmentDetails}
          timestamp={timestamp}
          amount={amount}
          ptrnNo={ptrnNo}
          allTransactions={allTransactions}
          message={message}
          mode={mode}
          open={openLoaderModal}
          handleClose={() => {
            setOpenLoaderModal(false);
          }}
        />
      )}
      {openAlertBox && (
        <ConfirmationAlert
          confirm={(e) => {
            ModalResp(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenAlertBox(false)}
          title={"Warning"}
          subTitle={`Are you sure! Do you want to link crm user - ${crmUser}`}
          open={openAlertBox}
        />
      )}
      {openClaimAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            claimResp(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Claim"}
          close={() => {
            setOpenClaimAlert(false);
            setSelectedAllotmentToClaim(null);
          }}
          title={"Claim Lead"}
          subTitle={`Claim this lead? It will be assigned to you and moved to Change AV.`}
          open={openClaimAlert}
        />
      )}
      {ClaimAlertModal}
      {showSkipRepriceModal && (
        <ConfirmationAlert
          confirm={(e) => {
            setShowSkipRepriceModal(false)
            if (e === "confirmed") {
              handleSkipReprice(e);
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setShowSkipRepriceModal(false)}
          title={"Warning"}
          subTitle={`Are you sure you want to skip reprice ?`}
          open={showSkipRepriceModal}
        />
      )}
      {openAlertBoxForCancellation && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              //?Api call Done
              let body = {
                allotmentPaymentId: selectedCancelUnit?.allotmentpaymentid,
              };
              presentLoader();
              refundFromAllAllotmentPayment(body)
                .then((respRefundTokenPay) => {
                  if (
                    respRefundTokenPay?.data?.success[0]?.status === "success"
                  ) {
                    // !!All Updates are Handled by Siddarth's refundtokenpayment api
                    dismissLoader();
                    successTost("Allotment refund initiated successfully");
                    document.getElementById(
                      "input-with-icon-textfield cancelAlotLeadName"
                    ).value = "";
                    setSearchCancelUnit("");
                    getAllCancelUnit(false);
                    setOpenAlertBoxForCancellation(false);
                  } else {
                    dismissLoader();
                    errorTost(respRefundTokenPay?.data?.failed[0]?.reason);
                  }
                })
                .catch((errInRefundPay) => {
                  dismissLoader();
                  errorTost(errInRefundPay.message);
                });
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setOpenAlertBoxForCancellation(false)}
          title={"Info"}
          subTitle={`Do you want to Initiate Refund?`}
          open={openAlertBoxForCancellation}
        />
      )}
      {openCancelUnitConfirmationModal && (
        <CancelUnitConfirmation
          open={openCancelUnitConfirmationModal}
          handleClose={() => {
            setOpenCancelUnitConfirmationModal(false);
          }}
          data={selectedCancelUnit}
          cancellationRequest={selectedCancelUnit}
          returnRes={(values, buttonValue, waiveOff, cancellationChargeValue, payload) => {
            setCancellationCharges(values);
            presentLoader();
            //**Update cost */
            let requestPending = {
              // userId:request.userId.parentId.userId,
              roleId: loggedInUser.roleId.roleId,
              // parentId: loggedInUser.userId,
              // !!To show no actions available
              parentId: null,
            };
            let obj = {
              bsp: selectedCancelUnit?.unitcost?.bsp,
              sdr: selectedCancelUnit?.unitcost?.sdr,
              gst: selectedCancelUnit?.unitcost?.gst,
              total: selectedCancelUnit?.unitcost?.total
            }
            updateCancelRequests(
              selectedCancelUnit.cancelunitrequestid,
              "Accepted",
              requestPending,
              obj,
              cancellationChargeValue,
              waiveOff,
              payload
            )
              .then(async (resp) => {
                if (selectedParking?.length > 0) {
                  let deleteCount = 0;
                  for (const parking of selectedParking) {
                    await deleteOldParkingRecords(parking?.parkingInventoryId?.parkingInventoryId).then(async (res) => {
                      if (!res?.error) {
                        await updateParkingStatusFlag(parking?.parkingInventoryId?.parkingInventoryId, 0).then((res) => {
                          deleteCount++
                          if (deleteCount === selectedParking?.length) {
                            //SUCESS
                            cancelUnitFlow(values, buttonValue,
                              cancellationChargeValue,
                              waiveOff,
                              payload)
                          }
                        }).catch((err) => {
                          console.log("Status", err);
                        })
                      } else {
                        console.log(res?.error);
                        errorTost(res?.error);
                      }
                    })
                      .catch((err) => {
                        console.log(err);
                        errorTost(err);
                      });
                  }
                } else {
                  cancelUnitFlow(values, buttonValue, cancellationChargeValue,
                    waiveOff,
                    payload);
                }
              })
              .catch((err) => {
                console.log(err);
                errorTost("Error while confirming");
              });
          }}
        />
      )}
      {assignSubmitModalToggle && (
        <SelectCrmUserModal
          open={assignSubmitModalToggle}
          handleClose={(_result) => {
            if (_result?.flag) {
              setCrmUser(_result?.selectedCrmUser?.value);
              setOpenAlertBox(true);
            } else {
              setAssignSubmitModalToggle(false);
            }
          }}
          crmUsersList={crmUsers}
          heading={"Bulk assign crm users"}
        />
      )}
      {openAdjustTokenModal && (
        <AdjustToken
          allotment={allotmentForAdjustToken}
          open={openAdjustTokenModal}
          handleClose={(_result) => {
            setAllotmentForAdjustToken(null);
            setOpenAdjustTokenModal(false);
          }}
        />
      )}
      {cancelUnitModal && (
        <CancelUnit
          open={cancelUnitModal}
          handleClose={() => {
            setCancelUnitModal(false);
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value) {
              dismissLoader();
              successTost("Cancellation done successfully!");
            }
          }}
          selectedAllotmentPass={selectedAllotment}
        />
      )}
      {repriceUnitModal && (
        <RepriceUnit
          open={repriceUnitModal}
          isRepriceForChangeUnit={isRepriceForChangeUnit}
          isRepricePending={isRepricePending}
          handleClose={() => {
            setRepriceUnitModal(false);
          }}
          data={leadObj}
          returnRes={(value) => {
            if (value) {
              setSearchCancelUnit("");
              if (
                document.getElementById(
                  "input-with-icon-textfield cancelAlotLeadName"
                )?.value
              ) {
                document.getElementById(
                  "input-with-icon-textfield cancelAlotLeadName"
                ).value = "";
              }
              getAllCancelUnit(false);
            }
          }}
          selectedAllotmentPass={selectedAllotment}
        />
      )}
      {crmTimeLineModalToggle && (
        <CrmTimeLineModal
          open={true}
          data={allotmentData}
          handleClose={() => {
            setcrmTimeLineModalToggle(false);
          }}
        />
      )}
      {viewUnitCostModalToggle && (
        <ViewUnitCostModal
          open={true}
          allotment={allotmentData}
          handleClose={() => {
            setViewUnitCostModalToggle(false);
          }}
        />
      )}
    </div>
  );
};

export default AllAllotments;
